/**
 * Rangy, a cross-browser JavaScript range and selection library
 * https://github.com/timdown/rangy
 *
 * Copyright 2015, Tim Down
 * Licensed under the MIT license.
 * Version: 1.3.1-dev
 * Build date: 20 May 2015
 */

(function(factory, root) {
    if (typeof define == "function" && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else if (typeof module != "undefined" && typeof exports == "object") {
        // Node/CommonJS style
        module.exports = factory();
    } else {
        // No AMD or CommonJS support so we place Rangy in (probably) the global variable
        root.rangy = factory();
    }
})(function() {

    var OBJECT = "object", FUNCTION = "function", UNDEFINED = "undefined";

    // Minimal set of properties required for DOM Level 2 Range compliance. Comparison constants such as START_TO_START
    // are omitted because ranges in KHTML do not have them but otherwise work perfectly well. See issue 113.
    var domRangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
        "commonAncestorContainer"];

    // Minimal set of methods required for DOM Level 2 Range compliance
    var domRangeMethods = ["setStart", "setStartBefore", "setStartAfter", "setEnd", "setEndBefore",
        "setEndAfter", "collapse", "selectNode", "selectNodeContents", "compareBoundaryPoints", "deleteContents",
        "extractContents", "cloneContents", "insertNode", "surroundContents", "cloneRange", "toString", "detach"];

    var textRangeProperties = ["boundingHeight", "boundingLeft", "boundingTop", "boundingWidth", "htmlText", "text"];

    // Subset of TextRange's full set of methods that we're interested in
    var textRangeMethods = ["collapse", "compareEndPoints", "duplicate", "moveToElementText", "parentElement", "select",
        "setEndPoint", "getBoundingClientRect"];

    /*----------------------------------------------------------------------------------------------------------------*/

    // Trio of functions taken from Peter Michaux's article:
    // http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting
    function isHostMethod(o, p) {
        var t = typeof o[p];
        return t == FUNCTION || (!!(t == OBJECT && o[p])) || t == "unknown";
    }

    function isHostObject(o, p) {
        return !!(typeof o[p] == OBJECT && o[p]);
    }

    function isHostProperty(o, p) {
        return typeof o[p] != UNDEFINED;
    }

    // Creates a convenience function to save verbose repeated calls to tests functions
    function createMultiplePropertyTest(testFunc) {
        return function(o, props) {
            var i = props.length;
            while (i--) {
                if (!testFunc(o, props[i])) {
                    return false;
                }
            }
            return true;
        };
    }

    // Next trio of functions are a convenience to save verbose repeated calls to previous two functions
    var areHostMethods = createMultiplePropertyTest(isHostMethod);
    var areHostObjects = createMultiplePropertyTest(isHostObject);
    var areHostProperties = createMultiplePropertyTest(isHostProperty);

    function isTextRange(range) {
        return range && areHostMethods(range, textRangeMethods) && areHostProperties(range, textRangeProperties);
    }

    function getBody(doc) {
        return isHostObject(doc, "body") ? doc.body : doc.getElementsByTagName("body")[0];
    }

    var forEach = [].forEach ?
        function(arr, func) {
            arr.forEach(func);
        } :
        function(arr, func) {
            for (var i = 0, len = arr.length; i < len; ++i) {
                func(arr[i], i);
            }
        };

    var modules = {};

    var isBrowser = (typeof window != UNDEFINED && typeof document != UNDEFINED);

    var util = {
        isHostMethod: isHostMethod,
        isHostObject: isHostObject,
        isHostProperty: isHostProperty,
        areHostMethods: areHostMethods,
        areHostObjects: areHostObjects,
        areHostProperties: areHostProperties,
        isTextRange: isTextRange,
        getBody: getBody,
        forEach: forEach
    };

    var api = {
        version: "1.3.1-dev",
        initialized: false,
        isBrowser: isBrowser,
        supported: true,
        util: util,
        features: {},
        modules: modules,
        config: {
            alertOnFail: false,
            alertOnWarn: false,
            preferTextRange: false,
            autoInitialize: (typeof rangyAutoInitialize == UNDEFINED) ? true : rangyAutoInitialize
        }
    };

    function consoleLog(msg) {
        if (typeof console != UNDEFINED && isHostMethod(console, "log")) {
            console.log(msg);
        }
    }

    function alertOrLog(msg, shouldAlert) {
        if (isBrowser && shouldAlert) {
            alert(msg);
        } else  {
            consoleLog(msg);
        }
    }

    function fail(reason) {
        api.initialized = true;
        api.supported = false;
        alertOrLog("Rangy is not supported in this environment. Reason: " + reason, api.config.alertOnFail);
    }

    api.fail = fail;

    function warn(msg) {
        alertOrLog("Rangy warning: " + msg, api.config.alertOnWarn);
    }

    api.warn = warn;

    // Add utility extend() method
    var extend;
    if ({}.hasOwnProperty) {
        util.extend = extend = function(obj, props, deep) {
            var o, p;
            for (var i in props) {
                if (props.hasOwnProperty(i)) {
                    o = obj[i];
                    p = props[i];
                    if (deep && o !== null && typeof o == "object" && p !== null && typeof p == "object") {
                        extend(o, p, true);
                    }
                    obj[i] = p;
                }
            }
            // Special case for toString, which does not show up in for...in loops in IE <= 8
            if (props.hasOwnProperty("toString")) {
                obj.toString = props.toString;
            }
            return obj;
        };

        util.createOptions = function(optionsParam, defaults) {
            var options = {};
            extend(options, defaults);
            if (optionsParam) {
                extend(options, optionsParam);
            }
            return options;
        };
    } else {
        fail("hasOwnProperty not supported");
    }

    // Test whether we're in a browser and bail out if not
    if (!isBrowser) {
        fail("Rangy can only run in a browser");
    }

    // Test whether Array.prototype.slice can be relied on for NodeLists and use an alternative toArray() if not
    (function() {
        var toArray;

        if (isBrowser) {
            var el = document.createElement("div");
            el.appendChild(document.createElement("span"));
            var slice = [].slice;
            try {
                if (el.childNodes.length && slice.call(el.childNodes, 0)[0].nodeType == 1) {
                    toArray = function(arrayLike) {
                        return slice.call(arrayLike, 0);
                    };
                }
            } catch (e) {}
        }

        if (!toArray) {
            toArray = function(arrayLike) {
                var arr = [];
                for (var i = 0, len = arrayLike.length; i < len; ++i) {
                    arr[i] = arrayLike[i];
                }
                return arr;
            };
        }

        util.toArray = toArray;
    })();

    // Very simple event handler wrapper function that doesn't attempt to solve issues such as "this" handling or
    // normalization of event properties
    var addListener;
    if (isBrowser) {
        if (isHostMethod(document, "addEventListener")) {
            addListener = function(obj, eventType, listener) {
                obj.addEventListener(eventType, listener, false);
            };
        } else if (isHostMethod(document, "attachEvent")) {
            addListener = function(obj, eventType, listener) {
                obj.attachEvent("on" + eventType, listener);
            };
        } else {
            fail("Document does not have required addEventListener or attachEvent method");
        }

        util.addListener = addListener;
    }

    var initListeners = [];

    function getErrorDesc(ex) {
        return ex.message || ex.description || String(ex);
    }

    // Initialization
    function init() {
        if (!isBrowser || api.initialized) {
            return;
        }
        var testRange;
        var implementsDomRange = false, implementsTextRange = false;

        // First, perform basic feature tests

        if (isHostMethod(document, "createRange")) {
            testRange = document.createRange();
            if (areHostMethods(testRange, domRangeMethods) && areHostProperties(testRange, domRangeProperties)) {
                implementsDomRange = true;
            }
        }

        var body = getBody(document);
        if (!body || body.nodeName.toLowerCase() != "body") {
            fail("No body element found");
            return;
        }

        if (body && isHostMethod(body, "createTextRange")) {
            testRange = body.createTextRange();
            if (isTextRange(testRange)) {
                implementsTextRange = true;
            }
        }

        if (!implementsDomRange && !implementsTextRange) {
            fail("Neither Range nor TextRange are available");
            return;
        }

        api.initialized = true;
        api.features = {
            implementsDomRange: implementsDomRange,
            implementsTextRange: implementsTextRange
        };

        // Initialize modules
        var module, errorMessage;
        for (var moduleName in modules) {
            if ( (module = modules[moduleName]) instanceof Module ) {
                module.init(module, api);
            }
        }

        // Call init listeners
        for (var i = 0, len = initListeners.length; i < len; ++i) {
            try {
                initListeners[i](api);
            } catch (ex) {
                errorMessage = "Rangy init listener threw an exception. Continuing. Detail: " + getErrorDesc(ex);
                consoleLog(errorMessage);
            }
        }
    }

    function deprecationNotice(deprecated, replacement, module) {
        if (module) {
            deprecated += " in module " + module.name;
        }
        api.warn("DEPRECATED: " + deprecated + " is deprecated. Please use " +
        replacement + " instead.");
    }

    function createAliasForDeprecatedMethod(owner, deprecated, replacement, module) {
        owner[deprecated] = function() {
            deprecationNotice(deprecated, replacement, module);
            return owner[replacement].apply(owner, util.toArray(arguments));
        };
    }

    util.deprecationNotice = deprecationNotice;
    util.createAliasForDeprecatedMethod = createAliasForDeprecatedMethod;

    // Allow external scripts to initialize this library in case it's loaded after the document has loaded
    api.init = init;

    // Execute listener immediately if already initialized
    api.addInitListener = function(listener) {
        if (api.initialized) {
            listener(api);
        } else {
            initListeners.push(listener);
        }
    };

    var shimListeners = [];

    api.addShimListener = function(listener) {
        shimListeners.push(listener);
    };

    function shim(win) {
        win = win || window;
        init();

        // Notify listeners
        for (var i = 0, len = shimListeners.length; i < len; ++i) {
            shimListeners[i](win);
        }
    }

    if (isBrowser) {
        api.shim = api.createMissingNativeApi = shim;
        createAliasForDeprecatedMethod(api, "createMissingNativeApi", "shim");
    }

    function Module(name, dependencies, initializer) {
        this.name = name;
        this.dependencies = dependencies;
        this.initialized = false;
        this.supported = false;
        this.initializer = initializer;
    }

    Module.prototype = {
        init: function() {
            var requiredModuleNames = this.dependencies || [];
            for (var i = 0, len = requiredModuleNames.length, requiredModule, moduleName; i < len; ++i) {
                moduleName = requiredModuleNames[i];

                requiredModule = modules[moduleName];
                if (!requiredModule || !(requiredModule instanceof Module)) {
                    throw new Error("required module '" + moduleName + "' not found");
                }

                requiredModule.init();

                if (!requiredModule.supported) {
                    throw new Error("required module '" + moduleName + "' not supported");
                }
            }

            // Now run initializer
            this.initializer(this);
        },

        fail: function(reason) {
            this.initialized = true;
            this.supported = false;
            throw new Error(reason);
        },

        warn: function(msg) {
            api.warn("Module " + this.name + ": " + msg);
        },

        deprecationNotice: function(deprecated, replacement) {
            api.warn("DEPRECATED: " + deprecated + " in module " + this.name + " is deprecated. Please use " +
                replacement + " instead");
        },

        createError: function(msg) {
            return new Error("Error in Rangy " + this.name + " module: " + msg);
        }
    };

    function createModule(name, dependencies, initFunc) {
        var newModule = new Module(name, dependencies, function(module) {
            if (!module.initialized) {
                module.initialized = true;
                try {
                    initFunc(api, module);
                    module.supported = true;
                } catch (ex) {
                    var errorMessage = "Module '" + name + "' failed to load: " + getErrorDesc(ex);
                    consoleLog(errorMessage);
                    if (ex.stack) {
                        consoleLog(ex.stack);
                    }
                }
            }
        });
        modules[name] = newModule;
        return newModule;
    }

    api.createModule = function(name) {
        // Allow 2 or 3 arguments (second argument is an optional array of dependencies)
        var initFunc, dependencies;
        if (arguments.length == 2) {
            initFunc = arguments[1];
            dependencies = [];
        } else {
            initFunc = arguments[2];
            dependencies = arguments[1];
        }

        var module = createModule(name, dependencies, initFunc);

        // Initialize the module immediately if the core is already initialized
        if (api.initialized && api.supported) {
            module.init();
        }
    };

    api.createCoreModule = function(name, dependencies, initFunc) {
        createModule(name, dependencies, initFunc);
    };

    /*----------------------------------------------------------------------------------------------------------------*/

    // Ensure rangy.rangePrototype and rangy.selectionPrototype are available immediately

    function RangePrototype() {}
    api.RangePrototype = RangePrototype;
    api.rangePrototype = new RangePrototype();

    function SelectionPrototype() {}
    api.selectionPrototype = new SelectionPrototype();

    /*----------------------------------------------------------------------------------------------------------------*/

    // DOM utility methods used by Rangy
    api.createCoreModule("DomUtil", [], function(api, module) {
        var UNDEF = "undefined";
        var util = api.util;
        var getBody = util.getBody;

        // Perform feature tests
        if (!util.areHostMethods(document, ["createDocumentFragment", "createElement", "createTextNode"])) {
            module.fail("document missing a Node creation method");
        }

        if (!util.isHostMethod(document, "getElementsByTagName")) {
            module.fail("document missing getElementsByTagName method");
        }

        var el = document.createElement("div");
        if (!util.areHostMethods(el, ["insertBefore", "appendChild", "cloneNode"] ||
                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]))) {
            module.fail("Incomplete Element implementation");
        }

        // innerHTML is required for Range's createContextualFragment method
        if (!util.isHostProperty(el, "innerHTML")) {
            module.fail("Element is missing innerHTML property");
        }

        var textNode = document.createTextNode("test");
        if (!util.areHostMethods(textNode, ["splitText", "deleteData", "insertData", "appendData", "cloneNode"] ||
                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]) ||
                !util.areHostProperties(textNode, ["data"]))) {
            module.fail("Incomplete Text Node implementation");
        }

        /*----------------------------------------------------------------------------------------------------------------*/

        // Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been
        // able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that
        // contains just the document as a single element and the value searched for is the document.
        var arrayContains = /*Array.prototype.indexOf ?
            function(arr, val) {
                return arr.indexOf(val) > -1;
            }:*/

            function(arr, val) {
                var i = arr.length;
                while (i--) {
                    if (arr[i] === val) {
                        return true;
                    }
                }
                return false;
            };

        // Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI
        function isHtmlNamespace(node) {
            var ns;
            return typeof node.namespaceURI == UNDEF || ((ns = node.namespaceURI) === null || ns == "http://www.w3.org/1999/xhtml");
        }

        function parentElement(node) {
            var parent = node.parentNode;
            return (parent && parent.nodeType == 1) ? parent : null;
        }

        function getNodeIndex(node) {
            var i = 0;
            while( (node = node.previousSibling) ) {
                ++i;
            }
            return i;
        }

        function getNodeLength(node) {
            if (!node) {
                return 0;
            }
            switch (node.nodeType) {
                case 7:
                case 10:
                    return 0;
                case 3:
                case 8:
                    return node.length;
                default:
                    return node.childNodes.length;
            }
        }

        function getCommonAncestor(node1, node2) {
            var ancestors = [], n;
            for (n = node1; n; n = n.parentNode) {
                ancestors.push(n);
            }

            for (n = node2; n; n = n.parentNode) {
                if (arrayContains(ancestors, n)) {
                    return n;
                }
            }

            return null;
        }

        function isAncestorOf(ancestor, descendant, selfIsAncestor) {
            var n = selfIsAncestor ? descendant : descendant.parentNode;
            while (n) {
                if (n === ancestor) {
                    return true;
                } else {
                    n = n.parentNode;
                }
            }
            return false;
        }

        function isOrIsAncestorOf(ancestor, descendant) {
            return isAncestorOf(ancestor, descendant, true);
        }

        function getClosestAncestorIn(node, ancestor, selfIsAncestor) {
            var p, n = selfIsAncestor ? node : node.parentNode;
            while (n) {
                p = n.parentNode;
                if (p === ancestor) {
                    return n;
                }
                n = p;
            }
            return null;
        }

        function isCharacterDataNode(node) {
            if (!node) {
                return false;
            }
            var t = node.nodeType;
            return t == 3 || t == 4 || t == 8 ; // Text, CDataSection or Comment
        }

        function isTextOrCommentNode(node) {
            if (!node) {
                return false;
            }
            var t = node.nodeType;
            return t == 3 || t == 8 ; // Text or Comment
        }

        function insertAfter(node, precedingNode) {
            var nextNode = precedingNode.nextSibling, parent = precedingNode.parentNode;
            if (nextNode) {
                parent.insertBefore(node, nextNode);
            } else {
                parent.appendChild(node);
            }
            return node;
        }

        // Note that we cannot use splitText() because it is bugridden in IE 9.
        function splitDataNode(node, index, positionsToPreserve) {
            var newNode = node.cloneNode(false);
            newNode.deleteData(0, index);
            node.deleteData(index, node.length - index);
            insertAfter(newNode, node);

            // Preserve positions
            if (positionsToPreserve) {
                for (var i = 0, position; position = positionsToPreserve[i++]; ) {
                    // Handle case where position was inside the portion of node after the split point
                    if (position.node == node && position.offset > index) {
                        position.node = newNode;
                        position.offset -= index;
                    }
                    // Handle the case where the position is a node offset within node's parent
                    else if (position.node == node.parentNode && position.offset > getNodeIndex(node)) {
                        ++position.offset;
                    }
                }
            }
            return newNode;
        }

        function getDocument(node) {
            if (!node) {
                throw module.createError("getDocument: no document found for node");
            }
            if (node.nodeType == 9) {
                return node;
            } else if (typeof node.ownerDocument != UNDEF) {
                return node.ownerDocument;
            } else if (typeof node.document != UNDEF) {
                return node.document;
            } else if (node.parentNode) {
                return getDocument(node.parentNode);
            } else {
                throw module.createError("getDocument: no document found for node");
            }
        }

        function getWindow(node) {
            var doc = getDocument(node);
            if (typeof doc.defaultView != UNDEF) {
                return doc.defaultView;
            } else if (typeof doc.parentWindow != UNDEF) {
                return doc.parentWindow;
            } else {
                throw module.createError("Cannot get a window object for node");
            }
        }

        function getIframeDocument(iframeEl) {
            if (typeof iframeEl.contentDocument != UNDEF) {
                return iframeEl.contentDocument;
            } else if (typeof iframeEl.contentWindow != UNDEF) {
                return iframeEl.contentWindow.document;
            } else {
                throw module.createError("getIframeDocument: No Document object found for iframe element");
            }
        }

        function getIframeWindow(iframeEl) {
            if (typeof iframeEl.contentWindow != UNDEF) {
                return iframeEl.contentWindow;
            } else if (typeof iframeEl.contentDocument != UNDEF) {
                return iframeEl.contentDocument.defaultView;
            } else {
                throw module.createError("getIframeWindow: No Window object found for iframe element");
            }
        }

        // This looks bad. Is it worth it?
        function isWindow(obj) {
            return obj && util.isHostMethod(obj, "setTimeout") && util.isHostObject(obj, "document");
        }

        function getContentDocument(obj, module, methodName) {
            var doc;

            if (!obj) {
                doc = document;
            }

            // Test if a DOM node has been passed and obtain a document object for it if so
            else if (util.isHostProperty(obj, "nodeType")) {
                doc = (obj && obj.nodeType == 1 && obj.tagName.toLowerCase() == "iframe") ?
                    getIframeDocument(obj) : getDocument(obj);
            }

            // Test if the doc parameter appears to be a Window object
            else if (isWindow(obj)) {
                doc = obj.document;
            }

            if (!doc) {
                throw module.createError(methodName + "(): Parameter must be a Window object or DOM node");
            }

            return doc;
        }

        function getRootContainer(node) {
            var parent;
            while ( (parent = node.parentNode) ) {
                node = parent;
            }
            return node;
        }

        function comparePoints(nodeA, offsetA, nodeB, offsetB) {
            // See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing
            var nodeC, root, childA, childB, n;
            if (nodeA == nodeB) {
                // Case 1: nodes are the same
                return offsetA === offsetB ? 0 : (offsetA < offsetB) ? -1 : 1;
            } else if ( (nodeC = getClosestAncestorIn(nodeB, nodeA, true)) ) {
                // Case 2: node C (container B or an ancestor) is a child node of A
                return offsetA <= getNodeIndex(nodeC) ? -1 : 1;
            } else if ( (nodeC = getClosestAncestorIn(nodeA, nodeB, true)) ) {
                // Case 3: node C (container A or an ancestor) is a child node of B
                return getNodeIndex(nodeC) < offsetB  ? -1 : 1;
            } else {
                root = getCommonAncestor(nodeA, nodeB);
                if (!root) {
                    throw new Error("comparePoints error: nodes have no common ancestor");
                }

                // Case 4: containers are siblings or descendants of siblings
                childA = (nodeA === root) ? root : getClosestAncestorIn(nodeA, root, true);
                childB = (nodeB === root) ? root : getClosestAncestorIn(nodeB, root, true);

                if (childA === childB) {
                    // This shouldn't be possible
                    throw module.createError("comparePoints got to case 4 and childA and childB are the same!");
                } else {
                    n = root.firstChild;
                    while (n) {
                        if (n === childA) {
                            return -1;
                        } else if (n === childB) {
                            return 1;
                        }
                        n = n.nextSibling;
                    }
                }
            }
        }

        /*----------------------------------------------------------------------------------------------------------------*/

        // Test for IE's crash (IE 6/7) or exception (IE >= 8) when a reference to garbage-collected text node is queried
        var crashyTextNodes = false;

        function isBrokenNode(node) {
            var n;
            try {
                n = node.parentNode;
                return false;
            } catch (e) {
                return true;
            }
        }

        (function() {
            var el = document.createElement("b");
            el.innerHTML = "1";
            var textNode = el.firstChild;
            el.innerHTML = "<br />";
            crashyTextNodes = isBrokenNode(textNode);

            api.features.crashyTextNodes = crashyTextNodes;
        })();

        /*----------------------------------------------------------------------------------------------------------------*/

        function inspectNode(node) {
            if (!node) {
                return "[No node]";
            }
            if (crashyTextNodes && isBrokenNode(node)) {
                return "[Broken node]";
            }
            if (isCharacterDataNode(node)) {
                return '"' + node.data + '"';
            }
            if (node && node.nodeType == 1) {
                var idAttr = node.id ? ' id="' + node.id + '"' : "";
                return "<" + node.nodeName + idAttr + ">[index:" + getNodeIndex(node) + ",length:" + node.childNodes.length + "][" + (node.innerHTML || "[innerHTML not supported]").slice(0, 25) + "]";
            }
            return node.nodeName;
        }

        function fragmentFromNodeChildren(node) {
            var fragment = getDocument(node).createDocumentFragment(), child;
            while ( (child = node.firstChild) ) {
                fragment.appendChild(child);
            }
            return fragment;
        }

        var getComputedStyleProperty;
        if (typeof window.getComputedStyle != UNDEF) {
            getComputedStyleProperty = function(el, propName) {
                return getWindow(el).getComputedStyle(el, null)[propName];
            };
        } else if (typeof document.documentElement.currentStyle != UNDEF) {
            getComputedStyleProperty = function(el, propName) {
                return el.currentStyle ? el.currentStyle[propName] : "";
            };
        } else {
            module.fail("No means of obtaining computed style properties found");
        }

        function createTestElement(doc, html, contentEditable) {
            var body = getBody(doc);
            var el = doc.createElement("div");
            el.contentEditable = "" + !!contentEditable;
            if (html) {
                el.innerHTML = html;
            }

            // Insert the test element at the start of the body to prevent scrolling to the bottom in iOS (issue #292)
            var bodyFirstChild = body.firstChild;
            if (bodyFirstChild) {
                body.insertBefore(el, bodyFirstChild);
            } else {
                body.appendChild(el);
            }

            return el;
        }

        function removeNode(node) {
            return node.parentNode.removeChild(node);
        }

        function NodeIterator(root) {
            this.root = root;
            this._next = root;
        }

        NodeIterator.prototype = {
            _current: null,

            hasNext: function() {
                return !!this._next;
            },

            next: function() {
                var n = this._current = this._next;
                var child, next;
                if (this._current) {
                    child = n.firstChild;
                    if (child) {
                        this._next = child;
                    } else {
                        next = null;
                        while ((n !== this.root) && !(next = n.nextSibling)) {
                            n = n.parentNode;
                        }
                        this._next = next;
                    }
                }
                return this._current;
            },

            detach: function() {
                this._current = this._next = this.root = null;
            }
        };

        function createIterator(root) {
            return new NodeIterator(root);
        }

        function DomPosition(node, offset) {
            this.node = node;
            this.offset = offset;
        }

        DomPosition.prototype = {
            equals: function(pos) {
                return !!pos && this.node === pos.node && this.offset == pos.offset;
            },

            inspect: function() {
                return "[DomPosition(" + inspectNode(this.node) + ":" + this.offset + ")]";
            },

            toString: function() {
                return this.inspect();
            }
        };

        function DOMException(codeName) {
            this.code = this[codeName];
            this.codeName = codeName;
            this.message = "DOMException: " + this.codeName;
        }

        DOMException.prototype = {
            INDEX_SIZE_ERR: 1,
            HIERARCHY_REQUEST_ERR: 3,
            WRONG_DOCUMENT_ERR: 4,
            NO_MODIFICATION_ALLOWED_ERR: 7,
            NOT_FOUND_ERR: 8,
            NOT_SUPPORTED_ERR: 9,
            INVALID_STATE_ERR: 11,
            INVALID_NODE_TYPE_ERR: 24
        };

        DOMException.prototype.toString = function() {
            return this.message;
        };

        api.dom = {
            arrayContains: arrayContains,
            isHtmlNamespace: isHtmlNamespace,
            parentElement: parentElement,
            getNodeIndex: getNodeIndex,
            getNodeLength: getNodeLength,
            getCommonAncestor: getCommonAncestor,
            isAncestorOf: isAncestorOf,
            isOrIsAncestorOf: isOrIsAncestorOf,
            getClosestAncestorIn: getClosestAncestorIn,
            isCharacterDataNode: isCharacterDataNode,
            isTextOrCommentNode: isTextOrCommentNode,
            insertAfter: insertAfter,
            splitDataNode: splitDataNode,
            getDocument: getDocument,
            getWindow: getWindow,
            getIframeWindow: getIframeWindow,
            getIframeDocument: getIframeDocument,
            getBody: getBody,
            isWindow: isWindow,
            getContentDocument: getContentDocument,
            getRootContainer: getRootContainer,
            comparePoints: comparePoints,
            isBrokenNode: isBrokenNode,
            inspectNode: inspectNode,
            getComputedStyleProperty: getComputedStyleProperty,
            createTestElement: createTestElement,
            removeNode: removeNode,
            fragmentFromNodeChildren: fragmentFromNodeChildren,
            createIterator: createIterator,
            DomPosition: DomPosition
        };

        api.DOMException = DOMException;
    });

    /*----------------------------------------------------------------------------------------------------------------*/

    // Pure JavaScript implementation of DOM Range
    api.createCoreModule("DomRange", ["DomUtil"], function(api, module) {
        var dom = api.dom;
        var util = api.util;
        var DomPosition = dom.DomPosition;
        var DOMException = api.DOMException;

        var isCharacterDataNode = dom.isCharacterDataNode;
        var getNodeIndex = dom.getNodeIndex;
        var isOrIsAncestorOf = dom.isOrIsAncestorOf;
        var getDocument = dom.getDocument;
        var comparePoints = dom.comparePoints;
        var splitDataNode = dom.splitDataNode;
        var getClosestAncestorIn = dom.getClosestAncestorIn;
        var getNodeLength = dom.getNodeLength;
        var arrayContains = dom.arrayContains;
        var getRootContainer = dom.getRootContainer;
        var crashyTextNodes = api.features.crashyTextNodes;

        var removeNode = dom.removeNode;

        /*----------------------------------------------------------------------------------------------------------------*/

        // Utility functions

        function isNonTextPartiallySelected(node, range) {
            return (node && node.nodeType != 3) &&
                   (isOrIsAncestorOf(node, range.startContainer) || isOrIsAncestorOf(node, range.endContainer));
        }

        function getRangeDocument(range) {
            return range.document || getDocument(range.startContainer);
        }

        function getRangeRoot(range) {
            return getRootContainer(range.startContainer);
        }

        function getBoundaryBeforeNode(node) {
            return new DomPosition(node.parentNode, getNodeIndex(node));
        }

        function getBoundaryAfterNode(node) {
            return new DomPosition(node.parentNode, getNodeIndex(node) + 1);
        }

        function insertNodeAtPosition(node, n, o) {
            var firstNodeInserted = node && node.nodeType == 11 ? node.firstChild : node;
            if (isCharacterDataNode(n)) {
                if (o == n.length) {
                    dom.insertAfter(node, n);
                } else {
                    n.parentNode.insertBefore(node, o == 0 ? n : splitDataNode(n, o));
                }
            } else if (o >= n.childNodes.length) {
                n.appendChild(node);
            } else {
                n.insertBefore(node, n.childNodes[o]);
            }
            return firstNodeInserted;
        }

        function rangesIntersect(rangeA, rangeB, touchingIsIntersecting) {
            assertRangeValid(rangeA);
            assertRangeValid(rangeB);

            if (getRangeDocument(rangeB) != getRangeDocument(rangeA)) {
                throw new DOMException("WRONG_DOCUMENT_ERR");
            }

            var startComparison = comparePoints(rangeA.startContainer, rangeA.startOffset, rangeB.endContainer, rangeB.endOffset),
                endComparison = comparePoints(rangeA.endContainer, rangeA.endOffset, rangeB.startContainer, rangeB.startOffset);

            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
        }

        function cloneSubtree(iterator) {
            var partiallySelected;
            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
                partiallySelected = iterator.isPartiallySelectedSubtree();
                node = node.cloneNode(!partiallySelected);
                if (partiallySelected) {
                    subIterator = iterator.getSubtreeIterator();
                    node.appendChild(cloneSubtree(subIterator));
                    subIterator.detach();
                }

                if (node && node.nodeType == 10) { // DocumentType
                    throw new DOMException("HIERARCHY_REQUEST_ERR");
                }
                frag.appendChild(node);
            }
            return frag;
        }

        function iterateSubtree(rangeIterator, func, iteratorState) {
            var it, n;
            iteratorState = iteratorState || { stop: false };
            for (var node, subRangeIterator; node = rangeIterator.next(); ) {
                if (rangeIterator.isPartiallySelectedSubtree()) {
                    if (func(node) === false) {
                        iteratorState.stop = true;
                        return;
                    } else {
                        // The node is partially selected by the Range, so we can use a new RangeIterator on the portion of
                        // the node selected by the Range.
                        subRangeIterator = rangeIterator.getSubtreeIterator();
                        iterateSubtree(subRangeIterator, func, iteratorState);
                        subRangeIterator.detach();
                        if (iteratorState.stop) {
                            return;
                        }
                    }
                } else {
                    // The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its
                    // descendants
                    it = dom.createIterator(node);
                    while ( (n = it.next()) ) {
                        if (func(n) === false) {
                            iteratorState.stop = true;
                            return;
                        }
                    }
                }
            }
        }

        function deleteSubtree(iterator) {
            var subIterator;
            while (iterator.next()) {
                if (iterator.isPartiallySelectedSubtree()) {
                    subIterator = iterator.getSubtreeIterator();
                    deleteSubtree(subIterator);
                    subIterator.detach();
                } else {
                    iterator.remove();
                }
            }
        }

        function extractSubtree(iterator) {
            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {

                if (iterator.isPartiallySelectedSubtree()) {
                    node = node.cloneNode(false);
                    subIterator = iterator.getSubtreeIterator();
                    node.appendChild(extractSubtree(subIterator));
                    subIterator.detach();
                } else {
                    iterator.remove();
                }
                if (node && node.nodeType == 10) { // DocumentType
                    throw new DOMException("HIERARCHY_REQUEST_ERR");
                }
                frag.appendChild(node);
            }
            return frag;
        }

        function getNodesInRange(range, nodeTypes, filter) {
            var filterNodeTypes = !!(nodeTypes && nodeTypes.length), regex;
            var filterExists = !!filter;
            if (filterNodeTypes) {
                regex = new RegExp("^(" + nodeTypes.join("|") + ")$");
            }

            var nodes = [];
            iterateSubtree(new RangeIterator(range, false), function(node) {
                if (filterNodeTypes && node && !regex.test(node.nodeType)) {
                    return;
                }
                if (filterExists && !filter(node)) {
                    return;
                }
                // Don't include a boundary container if it is a character data node and the range does not contain any
                // of its character data. See issue 190.
                var sc = range.startContainer;
                if (node == sc && isCharacterDataNode(sc) && range.startOffset == sc.length) {
                    return;
                }

                var ec = range.endContainer;
                if (node == ec && isCharacterDataNode(ec) && range.endOffset == 0) {
                    return;
                }

                nodes.push(node);
            });
            return nodes;
        }

        function inspect(range) {
            var name = (typeof range.getName == "undefined") ? "Range" : range.getName();
            return "[" + name + "(" + dom.inspectNode(range.startContainer) + ":" + range.startOffset + ", " +
                    dom.inspectNode(range.endContainer) + ":" + range.endOffset + ")]";
        }

        /*----------------------------------------------------------------------------------------------------------------*/

        // RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)

        function RangeIterator(range, clonePartiallySelectedTextNodes) {
            this.range = range;
            this.clonePartiallySelectedTextNodes = clonePartiallySelectedTextNodes;


            if (!range.collapsed) {
                this.sc = range.startContainer;
                this.so = range.startOffset;
                this.ec = range.endContainer;
                this.eo = range.endOffset;
                var root = range.commonAncestorContainer;

                if (this.sc === this.ec && isCharacterDataNode(this.sc)) {
                    this.isSingleCharacterDataNode = true;
                    this._first = this._last = this._next = this.sc;
                } else {
                    this._first = this._next = (this.sc === root && !isCharacterDataNode(this.sc)) ?
                        this.sc.childNodes[this.so] : getClosestAncestorIn(this.sc, root, true);
                    this._last = (this.ec === root && !isCharacterDataNode(this.ec)) ?
                        this.ec.childNodes[this.eo - 1] : getClosestAncestorIn(this.ec, root, true);
                }
            }
        }

        RangeIterator.prototype = {
            _current: null,
            _next: null,
            _first: null,
            _last: null,
            isSingleCharacterDataNode: false,

            reset: function() {
                this._current = null;
                this._next = this._first;
            },

            hasNext: function() {
                return !!this._next;
            },

            next: function() {
                // Move to next node
                var current = this._current = this._next;
                if (current) {
                    this._next = (current !== this._last) ? current.nextSibling : null;

                    // Check for partially selected text nodes
                    if (isCharacterDataNode(current) && this.clonePartiallySelectedTextNodes) {
                        if (current === this.ec) {
                            (current = current.cloneNode(true)).deleteData(this.eo, current.length - this.eo);
                        }
                        if (this._current === this.sc) {
                            (current = current.cloneNode(true)).deleteData(0, this.so);
                        }
                    }
                }

                return current;
            },

            remove: function() {
                var current = this._current, start, end;

                if (isCharacterDataNode(current) && (current === this.sc || current === this.ec)) {
                    start = (current === this.sc) ? this.so : 0;
                    end = (current === this.ec) ? this.eo : current.length;
                    if (start != end) {
                        current.deleteData(start, end - start);
                    }
                } else {
                    if (current.parentNode) {
                        removeNode(current);
                    } else {
                    }
                }
            },

            // Checks if the current node is partially selected
            isPartiallySelectedSubtree: function() {
                var current = this._current;
                return isNonTextPartiallySelected(current, this.range);
            },

            getSubtreeIterator: function() {
                var subRange;
                if (this.isSingleCharacterDataNode) {
                    subRange = this.range.cloneRange();
                    subRange.collapse(false);
                } else {
                    subRange = new Range(getRangeDocument(this.range));
                    var current = this._current;
                    var startContainer = current, startOffset = 0, endContainer = current, endOffset = getNodeLength(current);

                    if (isOrIsAncestorOf(current, this.sc)) {
                        startContainer = this.sc;
                        startOffset = this.so;
                    }
                    if (isOrIsAncestorOf(current, this.ec)) {
                        endContainer = this.ec;
                        endOffset = this.eo;
                    }

                    updateBoundaries(subRange, startContainer, startOffset, endContainer, endOffset);
                }
                return new RangeIterator(subRange, this.clonePartiallySelectedTextNodes);
            },

            detach: function() {
                this.range = this._current = this._next = this._first = this._last = this.sc = this.so = this.ec = this.eo = null;
            }
        };

        /*----------------------------------------------------------------------------------------------------------------*/

        var beforeAfterNodeTypes = [1, 3, 4, 5, 7, 8, 10];
        var rootContainerNodeTypes = [2, 9, 11];
        var readonlyNodeTypes = [5, 6, 10, 12];
        var insertableNodeTypes = [1, 3, 4, 5, 7, 8, 10, 11];
        var surroundNodeTypes = [1, 3, 4, 5, 7, 8];

        function createAncestorFinder(nodeTypes) {
            return function(node, selfIsAncestor) {
                if (!node) {
                    return null;
                }
                var t, n = selfIsAncestor ? node : node.parentNode;
                while (n) {
                    t = n.nodeType;
                    if (arrayContains(nodeTypes, t)) {
                        return n;
                    }
                    n = n.parentNode;
                }
                return null;
            };
        }

        var getDocumentOrFragmentContainer = createAncestorFinder( [9, 11] );
        var getReadonlyAncestor = createAncestorFinder(readonlyNodeTypes);
        var getDocTypeNotationEntityAncestor = createAncestorFinder( [6, 10, 12] );

        function assertNoDocTypeNotationEntityAncestor(node, allowSelf) {
            if (getDocTypeNotationEntityAncestor(node, allowSelf)) {
                throw new DOMException("INVALID_NODE_TYPE_ERR");
            }
        }

        function assertValidNodeType(node, invalidTypes) {
            if (!node || !arrayContains(invalidTypes, node.nodeType)) {
                throw new DOMException("INVALID_NODE_TYPE_ERR");
            }
        }

        function assertValidOffset(node, offset) {
            if (offset < 0 || offset > (isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
                throw new DOMException("INDEX_SIZE_ERR");
            }
        }

        function assertSameDocumentOrFragment(node1, node2) {
            if (getDocumentOrFragmentContainer(node1, true) !== getDocumentOrFragmentContainer(node2, true)) {
                throw new DOMException("WRONG_DOCUMENT_ERR");
            }
        }

        function assertNodeNotReadOnly(node) {
            if (getReadonlyAncestor(node, true)) {
                throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");
            }
        }

        function assertNode(node, codeName) {
            if (!node) {
                throw new DOMException(codeName);
            }
        }

        function isValidOffset(node, offset) {
            return offset <= (isCharacterDataNode(node) ? node.length : node.childNodes.length);
        }

        function isRangeValid(range) {
            return (!!range.startContainer && !!range.endContainer &&
                    !(crashyTextNodes && (dom.isBrokenNode(range.startContainer) || dom.isBrokenNode(range.endContainer))) &&
                    getRootContainer(range.startContainer) == getRootContainer(range.endContainer) &&
                    isValidOffset(range.startContainer, range.startOffset) &&
                    isValidOffset(range.endContainer, range.endOffset));
        }

        function assertRangeValid(range) {
            if (!isRangeValid(range)) {
                throw new Error("Range error: Range is not valid. This usually happens after DOM mutation. Range: (" + range.inspect() + ")");
            }
        }

        /*----------------------------------------------------------------------------------------------------------------*/

        // Test the browser's innerHTML support to decide how to implement createContextualFragment
        var styleEl = document.createElement("style");
        var htmlParsingConforms = false;
        try {
            styleEl.innerHTML = "<b>x</b>";
            htmlParsingConforms = (styleEl.firstChild.nodeType == 3); // Opera incorrectly creates an element node
        } catch (e) {
            // IE 6 and 7 throw
        }

        api.features.htmlParsingConforms = htmlParsingConforms;

        var createContextualFragment = htmlParsingConforms ?

            // Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See
            // discussion and base code for this implementation at issue 67.
            // Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface
            // Thanks to Aleks Williams.
            function(fragmentStr) {
                // "Let node the context object's start's node."
                var node = this.startContainer;
                var doc = getDocument(node);

                // "If the context object's start's node is null, raise an INVALID_STATE_ERR
                // exception and abort these steps."
                if (!node) {
                    throw new DOMException("INVALID_STATE_ERR");
                }

                // "Let element be as follows, depending on node's interface:"
                // Document, Document Fragment: null
                var el = null;

                // "Element: node"
                if (node && node.nodeType == 1) {
                    el = node;

                // "Text, Comment: node's parentElement"
                } else if (isCharacterDataNode(node)) {
                    el = dom.parentElement(node);
                }

                // "If either element is null or element's ownerDocument is an HTML document
                // and element's local name is "html" and element's namespace is the HTML
                // namespace"
                if (el === null || (
                    el.nodeName == "HTML" &&
                    dom.isHtmlNamespace(getDocument(el).documentElement) &&
                    dom.isHtmlNamespace(el)
                )) {

                // "let element be a new Element with "body" as its local name and the HTML
                // namespace as its namespace.""
                    el = doc.createElement("body");
                } else {
                    el = el.cloneNode(false);
                }

                // "If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm."
                // "If the node's document is an XML document: Invoke the XML fragment parsing algorithm."
                // "In either case, the algorithm must be invoked with fragment as the input
                // and element as the context element."
                el.innerHTML = fragmentStr;

                // "If this raises an exception, then abort these steps. Otherwise, let new
                // children be the nodes returned."

                // "Let fragment be a new DocumentFragment."
                // "Append all new children to fragment."
                // "Return fragment."
                return dom.fragmentFromNodeChildren(el);
            } :

            // In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that
            // previous versions of Rangy used (with the exception of using a body element rather than a div)
            function(fragmentStr) {
                var doc = getRangeDocument(this);
                var el = doc.createElement("body");
                el.innerHTML = fragmentStr;

                return dom.fragmentFromNodeChildren(el);
            };

        function splitRangeBoundaries(range, positionsToPreserve) {
            assertRangeValid(range);

            var sc = range.startContainer, so = range.startOffset, ec = range.endContainer, eo = range.endOffset;
            var startEndSame = (sc === ec);

            if (isCharacterDataNode(ec) && eo > 0 && eo < ec.length) {
                splitDataNode(ec, eo, positionsToPreserve);
            }

            if (isCharacterDataNode(sc) && so > 0 && so < sc.length) {
                sc = splitDataNode(sc, so, positionsToPreserve);
                if (startEndSame) {
                    eo -= so;
                    ec = sc;
                } else if (ec == sc.parentNode && eo >= getNodeIndex(sc)) {
                    eo++;
                }
                so = 0;
            }
            range.setStartAndEnd(sc, so, ec, eo);
        }

        function rangeToHtml(range) {
            assertRangeValid(range);
            var container = range.commonAncestorContainer.parentNode.cloneNode(false);
            container.appendChild( range.cloneContents() );
            return container.innerHTML;
        }

        /*----------------------------------------------------------------------------------------------------------------*/

        var rangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
            "commonAncestorContainer"];

        var s2s = 0, s2e = 1, e2e = 2, e2s = 3;
        var n_b = 0, n_a = 1, n_b_a = 2, n_i = 3;

        util.extend(api.rangePrototype, {
            compareBoundaryPoints: function(how, range) {
                assertRangeValid(this);
                assertSameDocumentOrFragment(this.startContainer, range.startContainer);

                var nodeA, offsetA, nodeB, offsetB;
                var prefixA = (how == e2s || how == s2s) ? "start" : "end";
                var prefixB = (how == s2e || how == s2s) ? "start" : "end";
                nodeA = this[prefixA + "Container"];
                offsetA = this[prefixA + "Offset"];
                nodeB = range[prefixB + "Container"];
                offsetB = range[prefixB + "Offset"];
                return comparePoints(nodeA, offsetA, nodeB, offsetB);
            },

            insertNode: function(node) {
                assertRangeValid(this);
                assertValidNodeType(node, insertableNodeTypes);
                assertNodeNotReadOnly(this.startContainer);

                if (isOrIsAncestorOf(node, this.startContainer)) {
                    throw new DOMException("HIERARCHY_REQUEST_ERR");
                }

                // No check for whether the container of the start of the Range is of a type that does not allow
                // children of the type of node: the browser's DOM implementation should do this for us when we attempt
                // to add the node

                var firstNodeInserted = insertNodeAtPosition(node, this.startContainer, this.startOffset);
                this.setStartBefore(firstNodeInserted);
            },

            cloneContents: function() {
                assertRangeValid(this);

                var clone, frag;
                if (this.collapsed) {
                    return getRangeDocument(this).createDocumentFragment();
                } else {
                    if (this.startContainer === this.endContainer && isCharacterDataNode(this.startContainer)) {
                        clone = this.startContainer.cloneNode(true);
                        clone.data = clone.data.slice(this.startOffset, this.endOffset);
                        frag = getRangeDocument(this).createDocumentFragment();
                        frag.appendChild(clone);
                        return frag;
                    } else {
                        var iterator = new RangeIterator(this, true);
                        clone = cloneSubtree(iterator);
                        iterator.detach();
                    }
                    return clone;
                }
            },

            canSurroundContents: function() {
                assertRangeValid(this);
                assertNodeNotReadOnly(this.startContainer);
                assertNodeNotReadOnly(this.endContainer);

                // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
                // no non-text nodes.
                var iterator = new RangeIterator(this, true);
                var boundariesInvalid = (iterator._first && (isNonTextPartiallySelected(iterator._first, this)) ||
                        (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
                iterator.detach();
                return !boundariesInvalid;
            },

            surroundContents: function(node) {
                assertValidNodeType(node, surroundNodeTypes);

                if (!this.canSurroundContents()) {
                    throw new DOMException("INVALID_STATE_ERR");
                }

                // Extract the contents
                var content = this.extractContents();

                // Clear the children of the node
                if (node.hasChildNodes()) {
                    while (node.lastChild) {
                        node.removeChild(node.lastChild);
                    }
                }

                // Insert the new node and add the extracted contents
                insertNodeAtPosition(node, this.startContainer, this.startOffset);
                node.appendChild(content);

                this.selectNode(node);
            },

            cloneRange: function() {
                assertRangeValid(this);
                var range = new Range(getRangeDocument(this));
                var i = rangeProperties.length, prop;
                while (i--) {
                    prop = rangeProperties[i];
                    range[prop] = this[prop];
                }
                return range;
            },

            toString: function() {
                assertRangeValid(this);
                var sc = this.startContainer;
                if (sc === this.endContainer && isCharacterDataNode(sc)) {
                    return (sc && (sc.nodeType == 3 || sc.nodeType == 4)) ? sc.data.slice(this.startOffset, this.endOffset) : "";
                } else {
                    var textParts = [], iterator = new RangeIterator(this, true);
                    iterateSubtree(iterator, function(node) {
                        // Accept only text or CDATA nodes, not comments
                        if (node && (node.nodeType == 3 || node.nodeType == 4)) {
                            textParts.push(node.data);
                        }
                    });
                    iterator.detach();
                    return textParts.join("");
                }
            },

            // The methods below are all non-standard. The following batch were introduced by Mozilla but have since
            // been removed from Mozilla.

            compareNode: function(node) {
                assertRangeValid(this);

                var parent = node.parentNode;
                var nodeIndex = getNodeIndex(node);

                if (!parent) {
                    throw new DOMException("NOT_FOUND_ERR");
                }

                var startComparison = this.comparePoint(parent, nodeIndex),
                    endComparison = this.comparePoint(parent, nodeIndex + 1);

                if (startComparison < 0) { // Node starts before
                    return (endComparison > 0) ? n_b_a : n_b;
                } else {
                    return (endComparison > 0) ? n_a : n_i;
                }
            },

            comparePoint: function(node, offset) {
                assertRangeValid(this);
                assertNode(node, "HIERARCHY_REQUEST_ERR");
                assertSameDocumentOrFragment(node, this.startContainer);

                if (comparePoints(node, offset, this.startContainer, this.startOffset) < 0) {
                    return -1;
                } else if (comparePoints(node, offset, this.endContainer, this.endOffset) > 0) {
                    return 1;
                }
                return 0;
            },

            createContextualFragment: createContextualFragment,

            toHtml: function() {
                return rangeToHtml(this);
            },

            // touchingIsIntersecting determines whether this method considers a node that borders a range intersects
            // with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)
            intersectsNode: function(node, touchingIsIntersecting) {
                assertRangeValid(this);
                if (getRootContainer(node) != getRangeRoot(this)) {
                    return false;
                }

                var parent = node.parentNode, offset = getNodeIndex(node);
                if (!parent) {
                    return true;
                }

                var startComparison = comparePoints(parent, offset, this.endContainer, this.endOffset),
                    endComparison = comparePoints(parent, offset + 1, this.startContainer, this.startOffset);

                return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
            },

            isPointInRange: function(node, offset) {
                assertRangeValid(this);
                assertNode(node, "HIERARCHY_REQUEST_ERR");
                assertSameDocumentOrFragment(node, this.startContainer);

                return (comparePoints(node, offset, this.startContainer, this.startOffset) >= 0) &&
                       (comparePoints(node, offset, this.endContainer, this.endOffset) <= 0);
            },

            // The methods below are non-standard and invented by me.

            // Sharing a boundary start-to-end or end-to-start does not count as intersection.
            intersectsRange: function(range) {
                return rangesIntersect(this, range, false);
            },

            // Sharing a boundary start-to-end or end-to-start does count as intersection.
            intersectsOrTouchesRange: function(range) {
                return rangesIntersect(this, range, true);
            },

            intersection: function(range) {
                if (this.intersectsRange(range)) {
                    var startComparison = comparePoints(this.startContainer, this.startOffset, range.startContainer, range.startOffset),
                        endComparison = comparePoints(this.endContainer, this.endOffset, range.endContainer, range.endOffset);

                    var intersectionRange = this.cloneRange();
                    if (startComparison == -1) {
                        intersectionRange.setStart(range.startContainer, range.startOffset);
                    }
                    if (endComparison == 1) {
                        intersectionRange.setEnd(range.endContainer, range.endOffset);
                    }
                    return intersectionRange;
                }
                return null;
            },

            union: function(range) {
                if (this.intersectsOrTouchesRange(range)) {
                    var unionRange = this.cloneRange();
                    if (comparePoints(range.startContainer, range.startOffset, this.startContainer, this.startOffset) == -1) {
                        unionRange.setStart(range.startContainer, range.startOffset);
                    }
                    if (comparePoints(range.endContainer, range.endOffset, this.endContainer, this.endOffset) == 1) {
                        unionRange.setEnd(range.endContainer, range.endOffset);
                    }
                    return unionRange;
                } else {
                    throw new DOMException("Ranges do not intersect");
                }
            },

            containsNode: function(node, allowPartial) {
                if (allowPartial) {
                    return this.intersectsNode(node, false);
                } else {
                    return this.compareNode(node) == n_i;
                }
            },

            containsNodeContents: function(node) {
                return this.comparePoint(node, 0) >= 0 && this.comparePoint(node, getNodeLength(node)) <= 0;
            },

            containsRange: function(range) {
                var intersection = this.intersection(range);
                return intersection !== null && range.equals(intersection);
            },

            containsNodeText: function(node) {
                var nodeRange = this.cloneRange();
                nodeRange.selectNode(node);
                var textNodes = nodeRange.getNodes([3]);
                if (textNodes.length > 0) {
                    nodeRange.setStart(textNodes[0], 0);
                    var lastTextNode = textNodes.pop();
                    nodeRange.setEnd(lastTextNode, lastTextNode.length);
                    return this.containsRange(nodeRange);
                } else {
                    return this.containsNodeContents(node);
                }
            },

            getNodes: function(nodeTypes, filter) {
                assertRangeValid(this);
                return getNodesInRange(this, nodeTypes, filter);
            },

            getDocument: function() {
                return getRangeDocument(this);
            },

            collapseBefore: function(node) {
                this.setEndBefore(node);
                this.collapse(false);
            },

            collapseAfter: function(node) {
                this.setStartAfter(node);
                this.collapse(true);
            },

            getBookmark: function(containerNode) {
                var doc = getRangeDocument(this);
                var preSelectionRange = api.createRange(doc);
                containerNode = containerNode || dom.getBody(doc);
                preSelectionRange.selectNodeContents(containerNode);
                var range = this.intersection(preSelectionRange);
                var start = 0, end = 0;
                if (range) {
                    preSelectionRange.setEnd(range.startContainer, range.startOffset);
                    start = preSelectionRange.toString().length;
                    end = start + range.toString().length;
                }

                return {
                    start: start,
                    end: end,
                    containerNode: containerNode
                };
            },

            moveToBookmark: function(bookmark) {
                var containerNode = bookmark.containerNode;
                var charIndex = 0;
                this.setStart(containerNode, 0);
                this.collapse(true);
                var nodeStack = [containerNode], node, foundStart = false, stop = false;
                var nextCharIndex, i, childNodes;

                while (!stop && (node = nodeStack.pop())) {
                    if (node && node.nodeType == 3) {
                        nextCharIndex = charIndex + node.length;
                        if (!foundStart && bookmark.start >= charIndex && bookmark.start <= nextCharIndex) {
                            this.setStart(node, bookmark.start - charIndex);
                            foundStart = true;
                        }
                        if (foundStart && bookmark.end >= charIndex && bookmark.end <= nextCharIndex) {
                            this.setEnd(node, bookmark.end - charIndex);
                            stop = true;
                        }
                        charIndex = nextCharIndex;
                    } else {
                        childNodes = node.childNodes;
                        i = childNodes.length;
                        while (i--) {
                            nodeStack.push(childNodes[i]);
                        }
                    }
                }
            },

            getName: function() {
                return "DomRange";
            },

            equals: function(range) {
                return Range.rangesEqual(this, range);
            },

            isValid: function() {
                return isRangeValid(this);
            },

            inspect: function() {
                return inspect(this);
            },

            detach: function() {
                // In DOM4, detach() is now a no-op.
            }
        });

        function copyComparisonConstantsToObject(obj) {
            obj.START_TO_START = s2s;
            obj.START_TO_END = s2e;
            obj.END_TO_END = e2e;
            obj.END_TO_START = e2s;

            obj.NODE_BEFORE = n_b;
            obj.NODE_AFTER = n_a;
            obj.NODE_BEFORE_AND_AFTER = n_b_a;
            obj.NODE_INSIDE = n_i;
        }

        function copyComparisonConstants(constructor) {
            copyComparisonConstantsToObject(constructor);
            copyComparisonConstantsToObject(constructor.prototype);
        }

        function createRangeContentRemover(remover, boundaryUpdater) {
            return function() {
                assertRangeValid(this);

                var sc = this.startContainer, so = this.startOffset, root = this.commonAncestorContainer;

                var iterator = new RangeIterator(this, true);

                // Work out where to position the range after content removal
                var node, boundary;
                if (sc !== root) {
                    node = getClosestAncestorIn(sc, root, true);
                    boundary = getBoundaryAfterNode(node);
                    sc = boundary.node;
                    so = boundary.offset;
                }

                // Check none of the range is read-only
                iterateSubtree(iterator, assertNodeNotReadOnly);

                iterator.reset();

                // Remove the content
                var returnValue = remover(iterator);
                iterator.detach();

                // Move to the new position
                boundaryUpdater(this, sc, so, sc, so);

                return returnValue;
            };
        }

        function createPrototypeRange(constructor, boundaryUpdater) {
            function createBeforeAfterNodeSetter(isBefore, isStart) {
                return function(node) {
                    assertValidNodeType(node, beforeAfterNodeTypes);
                    assertValidNodeType(getRootContainer(node), rootContainerNodeTypes);

                    var boundary = (isBefore ? getBoundaryBeforeNode : getBoundaryAfterNode)(node);
                    (isStart ? setRangeStart : setRangeEnd)(this, boundary.node, boundary.offset);
                };
            }

            function setRangeStart(range, node, offset) {
                var ec = range.endContainer, eo = range.endOffset;
                if (node !== range.startContainer || offset !== range.startOffset) {
                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
                    // is after the current end. In either case, collapse the range to the new position
                    if (getRootContainer(node) != getRootContainer(ec) || comparePoints(node, offset, ec, eo) == 1) {
                        ec = node;
                        eo = offset;
                    }
                    boundaryUpdater(range, node, offset, ec, eo);
                }
            }

            function setRangeEnd(range, node, offset) {
                var sc = range.startContainer, so = range.startOffset;
                if (node !== range.endContainer || offset !== range.endOffset) {
                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
                    // is after the current end. In either case, collapse the range to the new position
                    if (getRootContainer(node) != getRootContainer(sc) || comparePoints(node, offset, sc, so) == -1) {
                        sc = node;
                        so = offset;
                    }
                    boundaryUpdater(range, sc, so, node, offset);
                }
            }

            // Set up inheritance
            var F = function() {};
            F.prototype = api.rangePrototype;
            constructor.prototype = new F();

            util.extend(constructor.prototype, {
                setStart: function(node, offset) {
                    assertNoDocTypeNotationEntityAncestor(node, true);
                    assertValidOffset(node, offset);

                    setRangeStart(this, node, offset);
                },

                setEnd: function(node, offset) {
                    assertNoDocTypeNotationEntityAncestor(node, true);
                    assertValidOffset(node, offset);

                    setRangeEnd(this, node, offset);
                },

                /**
                 * Convenience method to set a range's start and end boundaries. Overloaded as follows:
                 * - Two parameters (node, offset) creates a collapsed range at that position
                 * - Three parameters (node, startOffset, endOffset) creates a range contained with node starting at
                 *   startOffset and ending at endOffset
                 * - Four parameters (startNode, startOffset, endNode, endOffset) creates a range starting at startOffset in
                 *   startNode and ending at endOffset in endNode
                 */
                setStartAndEnd: function() {
                    var args = arguments;
                    var sc = args[0], so = args[1], ec = sc, eo = so;

                    switch (args.length) {
                        case 3:
                            eo = args[2];
                            break;
                        case 4:
                            ec = args[2];
                            eo = args[3];
                            break;
                    }

                    boundaryUpdater(this, sc, so, ec, eo);
                },

                setBoundary: function(node, offset, isStart) {
                    this["set" + (isStart ? "Start" : "End")](node, offset);
                },

                setStartBefore: createBeforeAfterNodeSetter(true, true),
                setStartAfter: createBeforeAfterNodeSetter(false, true),
                setEndBefore: createBeforeAfterNodeSetter(true, false),
                setEndAfter: createBeforeAfterNodeSetter(false, false),

                collapse: function(isStart) {
                    assertRangeValid(this);
                    if (isStart) {
                        boundaryUpdater(this, this.startContainer, this.startOffset, this.startContainer, this.startOffset);
                    } else {
                        boundaryUpdater(this, this.endContainer, this.endOffset, this.endContainer, this.endOffset);
                    }
                },

                selectNodeContents: function(node) {
                    assertNoDocTypeNotationEntityAncestor(node, true);

                    boundaryUpdater(this, node, 0, node, getNodeLength(node));
                },

                selectNode: function(node) {
                    assertNoDocTypeNotationEntityAncestor(node, false);
                    assertValidNodeType(node, beforeAfterNodeTypes);

                    var start = getBoundaryBeforeNode(node), end = getBoundaryAfterNode(node);
                    boundaryUpdater(this, start.node, start.offset, end.node, end.offset);
                },

                extractContents: createRangeContentRemover(extractSubtree, boundaryUpdater),

                deleteContents: createRangeContentRemover(deleteSubtree, boundaryUpdater),

                canSurroundContents: function() {
                    assertRangeValid(this);
                    assertNodeNotReadOnly(this.startContainer);
                    assertNodeNotReadOnly(this.endContainer);

                    // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
                    // no non-text nodes.
                    var iterator = new RangeIterator(this, true);
                    var boundariesInvalid = (iterator._first && isNonTextPartiallySelected(iterator._first, this) ||
                            (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
                    iterator.detach();
                    return !boundariesInvalid;
                },

                splitBoundaries: function() {
                    splitRangeBoundaries(this);
                },

                splitBoundariesPreservingPositions: function(positionsToPreserve) {
                    splitRangeBoundaries(this, positionsToPreserve);
                },

                normalizeBoundaries: function() {
                    assertRangeValid(this);

                    var sc = this.startContainer, so = this.startOffset, ec = this.endContainer, eo = this.endOffset;

                    var mergeForward = function(node) {
                        var sibling = node.nextSibling;
                        if (sibling && sibling.nodeType == node.nodeType) {
                            ec = node;
                            eo = node.length;
                            node.appendData(sibling.data);
                            removeNode(sibling);
                        }
                    };

                    var mergeBackward = function(node) {
                        var sibling = node.previousSibling;
                        if (sibling && sibling.nodeType == node.nodeType) {
                            sc = node;
                            var nodeLength = node.length;
                            so = sibling.length;
                            node.insertData(0, sibling.data);
                            removeNode(sibling);
                            if (sc == ec) {
                                eo += so;
                                ec = sc;
                            } else if (ec == node.parentNode) {
                                var nodeIndex = getNodeIndex(node);
                                if (eo == nodeIndex) {
                                    ec = node;
                                    eo = nodeLength;
                                } else if (eo > nodeIndex) {
                                    eo--;
                                }
                            }
                        }
                    };

                    var normalizeStart = true;
                    var sibling;

                    if (isCharacterDataNode(ec)) {
                        if (eo == ec.length) {
                            mergeForward(ec);
                        } else if (eo == 0) {
                            sibling = ec.previousSibling;
                            if (sibling && sibling.nodeType == ec.nodeType) {
                                eo = sibling.length;
                                if (sc == ec) {
                                    normalizeStart = false;
                                }
                                sibling.appendData(ec.data);
                                removeNode(ec);
                                ec = sibling;
                            }
                        }
                    } else {
                        if (eo > 0) {
                            var endNode = ec.childNodes[eo - 1];
                            if (endNode && isCharacterDataNode(endNode)) {
                                mergeForward(endNode);
                            }
                        }
                        normalizeStart = !this.collapsed;
                    }

                    if (normalizeStart) {
                        if (isCharacterDataNode(sc)) {
                            if (so == 0) {
                                mergeBackward(sc);
                            } else if (so == sc.length) {
                                sibling = sc.nextSibling;
                                if (sibling && sc && sibling.nodeType == sc.nodeType) {
                                    if (ec == sibling) {
                                        ec = sc;
                                        eo += sc.length;
                                    }
                                    sc.appendData(sibling.data);
                                    removeNode(sibling);
                                }
                            }
                        } else {
                            if (so < sc.childNodes.length) {
                                var startNode = sc.childNodes[so];
                                if (startNode && isCharacterDataNode(startNode)) {
                                    mergeBackward(startNode);
                                }
                            }
                        }
                    } else {
                        sc = ec;
                        so = eo;
                    }

                    boundaryUpdater(this, sc, so, ec, eo);
                },

                collapseToPoint: function(node, offset) {
                    assertNoDocTypeNotationEntityAncestor(node, true);
                    assertValidOffset(node, offset);
                    this.setStartAndEnd(node, offset);
                }
            });

            copyComparisonConstants(constructor);
        }

        /*----------------------------------------------------------------------------------------------------------------*/

        // Updates commonAncestorContainer and collapsed after boundary change
        function updateCollapsedAndCommonAncestor(range) {
            range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
            range.commonAncestorContainer = range.collapsed ?
                range.startContainer : dom.getCommonAncestor(range.startContainer, range.endContainer);
        }

        function updateBoundaries(range, startContainer, startOffset, endContainer, endOffset) {
            range.startContainer = startContainer;
            range.startOffset = startOffset;
            range.endContainer = endContainer;
            range.endOffset = endOffset;
            range.document = dom.getDocument(startContainer);

            updateCollapsedAndCommonAncestor(range);
        }

        function Range(doc) {
            this.startContainer = doc;
            this.startOffset = 0;
            this.endContainer = doc;
            this.endOffset = 0;
            this.document = doc;
            updateCollapsedAndCommonAncestor(this);
        }

        createPrototypeRange(Range, updateBoundaries);

        util.extend(Range, {
            rangeProperties: rangeProperties,
            RangeIterator: RangeIterator,
            copyComparisonConstants: copyComparisonConstants,
            createPrototypeRange: createPrototypeRange,
            inspect: inspect,
            toHtml: rangeToHtml,
            getRangeDocument: getRangeDocument,
            rangesEqual: function(r1, r2) {
                return r1.startContainer === r2.startContainer &&
                    r1.startOffset === r2.startOffset &&
                    r1.endContainer === r2.endContainer &&
                    r1.endOffset === r2.endOffset;
            }
        });

        api.DomRange = Range;
    });

    /*----------------------------------------------------------------------------------------------------------------*/

    // Wrappers for the browser's native DOM Range and/or TextRange implementation
    api.createCoreModule("WrappedRange", ["DomRange"], function(api, module) {
        var WrappedRange, WrappedTextRange;
        var dom = api.dom;
        var util = api.util;
        var DomPosition = dom.DomPosition;
        var DomRange = api.DomRange;
        var getBody = dom.getBody;
        var getContentDocument = dom.getContentDocument;
        var isCharacterDataNode = dom.isCharacterDataNode;


        /*----------------------------------------------------------------------------------------------------------------*/

        if (api.features.implementsDomRange) {
            // This is a wrapper around the browser's native DOM Range. It has two aims:
            // - Provide workarounds for specific browser bugs
            // - provide convenient extensions, which are inherited from Rangy's DomRange

            (function() {
                var rangeProto;
                var rangeProperties = DomRange.rangeProperties;

                function updateRangeProperties(range) {
                    var i = rangeProperties.length, prop;
                    while (i--) {
                        prop = rangeProperties[i];
                        range[prop] = range.nativeRange[prop];
                    }
                    // Fix for broken collapsed property in IE 9.
                    range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
                }

                function updateNativeRange(range, startContainer, startOffset, endContainer, endOffset) {
                    var startMoved = (range.startContainer !== startContainer || range.startOffset != startOffset);
                    var endMoved = (range.endContainer !== endContainer || range.endOffset != endOffset);
                    var nativeRangeDifferent = !range.equals(range.nativeRange);

                    // Always set both boundaries for the benefit of IE9 (see issue 35)
                    if (startMoved || endMoved || nativeRangeDifferent) {
                        range.setEnd(endContainer, endOffset);
                        range.setStart(startContainer, startOffset);
                    }
                }

                var createBeforeAfterNodeSetter;

                WrappedRange = function(range) {
                    if (!range) {
                        throw module.createError("WrappedRange: Range must be specified");
                    }
                    this.nativeRange = range;
                    updateRangeProperties(this);
                };

                DomRange.createPrototypeRange(WrappedRange, updateNativeRange);

                rangeProto = WrappedRange.prototype;

                rangeProto.selectNode = function(node) {
                    this.nativeRange.selectNode(node);
                    updateRangeProperties(this);
                };

                rangeProto.cloneContents = function() {
                    return this.nativeRange.cloneContents();
                };

                // Due to a long-standing Firefox bug that I have not been able to find a reliable way to detect,
                // insertNode() is never delegated to the native range.

                rangeProto.surroundContents = function(node) {
                    this.nativeRange.surroundContents(node);
                    updateRangeProperties(this);
                };

                rangeProto.collapse = function(isStart) {
                    this.nativeRange.collapse(isStart);
                    updateRangeProperties(this);
                };

                rangeProto.cloneRange = function() {
                    return new WrappedRange(this.nativeRange.cloneRange());
                };

                rangeProto.refresh = function() {
                    updateRangeProperties(this);
                };

                rangeProto.toString = function() {
                    return this.nativeRange.toString();
                };

                // Create test range and node for feature detection

                var testTextNode = document.createTextNode("test");
                getBody(document).appendChild(testTextNode);
                var range = document.createRange();

                /*--------------------------------------------------------------------------------------------------------*/

                // Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and
                // correct for it

                range.setStart(testTextNode, 0);
                range.setEnd(testTextNode, 0);

                try {
                    range.setStart(testTextNode, 1);

                    rangeProto.setStart = function(node, offset) {
                        this.nativeRange.setStart(node, offset);
                        updateRangeProperties(this);
                    };

                    rangeProto.setEnd = function(node, offset) {
                        this.nativeRange.setEnd(node, offset);
                        updateRangeProperties(this);
                    };

                    createBeforeAfterNodeSetter = function(name) {
                        return function(node) {
                            this.nativeRange[name](node);
                            updateRangeProperties(this);
                        };
                    };

                } catch(ex) {

                    rangeProto.setStart = function(node, offset) {
                        try {
                            this.nativeRange.setStart(node, offset);
                        } catch (ex) {
                            this.nativeRange.setEnd(node, offset);
                            this.nativeRange.setStart(node, offset);
                        }
                        updateRangeProperties(this);
                    };

                    rangeProto.setEnd = function(node, offset) {
                        try {
                            this.nativeRange.setEnd(node, offset);
                        } catch (ex) {
                            this.nativeRange.setStart(node, offset);
                            this.nativeRange.setEnd(node, offset);
                        }
                        updateRangeProperties(this);
                    };

                    createBeforeAfterNodeSetter = function(name, oppositeName) {
                        return function(node) {
                            try {
                                this.nativeRange[name](node);
                            } catch (ex) {
                                this.nativeRange[oppositeName](node);
                                this.nativeRange[name](node);
                            }
                            updateRangeProperties(this);
                        };
                    };
                }

                rangeProto.setStartBefore = createBeforeAfterNodeSetter("setStartBefore", "setEndBefore");
                rangeProto.setStartAfter = createBeforeAfterNodeSetter("setStartAfter", "setEndAfter");
                rangeProto.setEndBefore = createBeforeAfterNodeSetter("setEndBefore", "setStartBefore");
                rangeProto.setEndAfter = createBeforeAfterNodeSetter("setEndAfter", "setStartAfter");

                /*--------------------------------------------------------------------------------------------------------*/

                // Always use DOM4-compliant selectNodeContents implementation: it's simpler and less code than testing
                // whether the native implementation can be trusted
                rangeProto.selectNodeContents = function(node) {
                    this.setStartAndEnd(node, 0, dom.getNodeLength(node));
                };

                /*--------------------------------------------------------------------------------------------------------*/

                // Test for and correct WebKit bug that has the behaviour of compareBoundaryPoints round the wrong way for
                // constants START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738

                range.selectNodeContents(testTextNode);
                range.setEnd(testTextNode, 3);

                var range2 = document.createRange();
                range2.selectNodeContents(testTextNode);
                range2.setEnd(testTextNode, 4);
                range2.setStart(testTextNode, 2);

                if (range.compareBoundaryPoints(range.START_TO_END, range2) == -1 &&
                        range.compareBoundaryPoints(range.END_TO_START, range2) == 1) {
                    // This is the wrong way round, so correct for it

                    rangeProto.compareBoundaryPoints = function(type, range) {
                        range = range.nativeRange || range;
                        if (type == range.START_TO_END) {
                            type = range.END_TO_START;
                        } else if (type == range.END_TO_START) {
                            type = range.START_TO_END;
                        }
                        return this.nativeRange.compareBoundaryPoints(type, range);
                    };
                } else {
                    rangeProto.compareBoundaryPoints = function(type, range) {
                        return this.nativeRange.compareBoundaryPoints(type, range.nativeRange || range);
                    };
                }

                /*--------------------------------------------------------------------------------------------------------*/

                // Test for IE deleteContents() and extractContents() bug and correct it. See issue 107.

                var el = document.createElement("div");
                el.innerHTML = "123";
                var textNode = el.firstChild;
                var body = getBody(document);
                body.appendChild(el);

                range.setStart(textNode, 1);
                range.setEnd(textNode, 2);
                range.deleteContents();

                if (textNode.data == "13") {
                    // Behaviour is correct per DOM4 Range so wrap the browser's implementation of deleteContents() and
                    // extractContents()
                    rangeProto.deleteContents = function() {
                        this.nativeRange.deleteContents();
                        updateRangeProperties(this);
                    };

                    rangeProto.extractContents = function() {
                        var frag = this.nativeRange.extractContents();
                        updateRangeProperties(this);
                        return frag;
                    };
                } else {
                }

                body.removeChild(el);
                body = null;

                /*--------------------------------------------------------------------------------------------------------*/

                // Test for existence of createContextualFragment and delegate to it if it exists
                if (util.isHostMethod(range, "createContextualFragment")) {
                    rangeProto.createContextualFragment = function(fragmentStr) {
                        return this.nativeRange.createContextualFragment(fragmentStr);
                    };
                }

                /*--------------------------------------------------------------------------------------------------------*/

                // Clean up
                getBody(document).removeChild(testTextNode);

                rangeProto.getName = function() {
                    return "WrappedRange";
                };

                api.WrappedRange = WrappedRange;

                api.createNativeRange = function(doc) {
                    doc = getContentDocument(doc, module, "createNativeRange");
                    return doc.createRange();
                };
            })();
        }

        if (api.features.implementsTextRange) {
            /*
            This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()
            method. For example, in the following (where pipes denote the selection boundaries):

            <ul id="ul"><li id="a">| a </li><li id="b"> b |</li></ul>

            var range = document.selection.createRange();
            alert(range.parentElement().id); // Should alert "ul" but alerts "b"

            This method returns the common ancestor node of the following:
            - the parentElement() of the textRange
            - the parentElement() of the textRange after calling collapse(true)
            - the parentElement() of the textRange after calling collapse(false)
            */
            var getTextRangeContainerElement = function(textRange) {
                var parentEl = textRange.parentElement();
                var range = textRange.duplicate();
                range.collapse(true);
                var startEl = range.parentElement();
                range = textRange.duplicate();
                range.collapse(false);
                var endEl = range.parentElement();
                var startEndContainer = (startEl == endEl) ? startEl : dom.getCommonAncestor(startEl, endEl);

                return startEndContainer == parentEl ? startEndContainer : dom.getCommonAncestor(parentEl, startEndContainer);
            };

            var textRangeIsCollapsed = function(textRange) {
                return textRange.compareEndPoints("StartToEnd", textRange) == 0;
            };

            // Gets the boundary of a TextRange expressed as a node and an offset within that node. This function started
            // out as an improved version of code found in Tim Cameron Ryan's IERange (http://code.google.com/p/ierange/)
            // but has grown, fixing problems with line breaks in preformatted text, adding workaround for IE TextRange
            // bugs, handling for inputs and images, plus optimizations.
            var getTextRangeBoundaryPosition = function(textRange, wholeRangeContainerElement, isStart, isCollapsed, startInfo) {
                var workingRange = textRange.duplicate();
                workingRange.collapse(isStart);
                var containerElement = workingRange.parentElement();

                // Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so
                // check for that
                if (!dom.isOrIsAncestorOf(wholeRangeContainerElement, containerElement)) {
                    containerElement = wholeRangeContainerElement;
                }


                // Deal with nodes that cannot "contain rich HTML markup". In practice, this means form inputs, images and
                // similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx
                if (!containerElement.canHaveHTML) {
                    var pos = new DomPosition(containerElement.parentNode, dom.getNodeIndex(containerElement));
                    return {
                        boundaryPosition: pos,
                        nodeInfo: {
                            nodeIndex: pos.offset,
                            containerElement: pos.node
                        }
                    };
                }

                var workingNode = dom.getDocument(containerElement).createElement("span");

                // Workaround for HTML5 Shiv's insane violation of document.createElement(). See Rangy issue 104 and HTML5
                // Shiv issue 64: https://github.com/aFarkas/html5shiv/issues/64
                if (workingNode.parentNode) {
                    dom.removeNode(workingNode);
                }

                var comparison, workingComparisonType = isStart ? "StartToStart" : "StartToEnd";
                var previousNode, nextNode, boundaryPosition, boundaryNode;
                var start = (startInfo && startInfo.containerElement == containerElement) ? startInfo.nodeIndex : 0;
                var childNodeCount = containerElement.childNodes.length;
                var end = childNodeCount;

                // Check end first. Code within the loop assumes that the endth child node of the container is definitely
                // after the range boundary.
                var nodeIndex = end;

                while (true) {
                    if (nodeIndex == childNodeCount) {
                        containerElement.appendChild(workingNode);
                    } else {
                        containerElement.insertBefore(workingNode, containerElement.childNodes[nodeIndex]);
                    }
                    workingRange.moveToElementText(workingNode);
                    comparison = workingRange.compareEndPoints(workingComparisonType, textRange);
                    if (comparison == 0 || start == end) {
                        break;
                    } else if (comparison == -1) {
                        if (end == start + 1) {
                            // We know the endth child node is after the range boundary, so we must be done.
                            break;
                        } else {
                            start = nodeIndex;
                        }
                    } else {
                        end = (end == start + 1) ? start : nodeIndex;
                    }
                    nodeIndex = Math.floor((start + end) / 2);
                    containerElement.removeChild(workingNode);
                }


                // We've now reached or gone past the boundary of the text range we're interested in
                // so have identified the node we want
                boundaryNode = workingNode.nextSibling;

                if (comparison == -1 && boundaryNode && isCharacterDataNode(boundaryNode)) {
                    // This is a character data node (text, comment, cdata). The working range is collapsed at the start of
                    // the node containing the text range's boundary, so we move the end of the working range to the
                    // boundary point and measure the length of its text to get the boundary's offset within the node.
                    workingRange.setEndPoint(isStart ? "EndToStart" : "EndToEnd", textRange);

                    var offset;

                    if (/[\r\n]/.test(boundaryNode.data)) {
                        /*
                        For the particular case of a boundary within a text node containing rendered line breaks (within a
                        <pre> element, for example), we need a slightly complicated approach to get the boundary's offset in
                        IE. The facts:

                        - Each line break is represented as \r in the text node's data/nodeValue properties
                        - Each line break is represented as \r\n in the TextRange's 'text' property
                        - The 'text' property of the TextRange does not contain trailing line breaks

                        To get round the problem presented by the final fact above, we can use the fact that TextRange's
                        moveStart() and moveEnd() methods return the actual number of characters moved, which is not
                        necessarily the same as the number of characters it was instructed to move. The simplest approach is
                        to use this to store the characters moved when moving both the start and end of the range to the
                        start of the document body and subtracting the start offset from the end offset (the
                        "move-negative-gazillion" method). However, this is extremely slow when the document is large and
                        the range is near the end of it. Clearly doing the mirror image (i.e. moving the range boundaries to
                        the end of the document) has the same problem.

                        Another approach that works is to use moveStart() to move the start boundary of the range up to the
                        end boundary one character at a time and incrementing a counter with the value returned by the
                        moveStart() call. However, the check for whether the start boundary has reached the end boundary is
                        expensive, so this method is slow (although unlike "move-negative-gazillion" is largely unaffected
                        by the location of the range within the document).

                        The approach used below is a hybrid of the two methods above. It uses the fact that a string
                        containing the TextRange's 'text' property with each \r\n converted to a single \r character cannot
                        be longer than the text of the TextRange, so the start of the range is moved that length initially
                        and then a character at a time to make up for any trailing line breaks not contained in the 'text'
                        property. This has good performance in most situations compared to the previous two methods.
                        */
                        var tempRange = workingRange.duplicate();
                        var rangeLength = tempRange.text.replace(/\r\n/g, "\r").length;

                        offset = tempRange.moveStart("character", rangeLength);
                        while ( (comparison = tempRange.compareEndPoints("StartToEnd", tempRange)) == -1) {
                            offset++;
                            tempRange.moveStart("character", 1);
                        }
                    } else {
                        offset = workingRange.text.length;
                    }
                    boundaryPosition = new DomPosition(boundaryNode, offset);
                } else {

                    // If the boundary immediately follows a character data node and this is the end boundary, we should favour
                    // a position within that, and likewise for a start boundary preceding a character data node
                    previousNode = (isCollapsed || !isStart) && workingNode.previousSibling;
                    nextNode = (isCollapsed || isStart) && workingNode.nextSibling;
                    if (nextNode && isCharacterDataNode(nextNode)) {
                        boundaryPosition = new DomPosition(nextNode, 0);
                    } else if (previousNode && isCharacterDataNode(previousNode)) {
                        boundaryPosition = new DomPosition(previousNode, previousNode.data.length);
                    } else {
                        boundaryPosition = new DomPosition(containerElement, dom.getNodeIndex(workingNode));
                    }
                }

                // Clean up
                dom.removeNode(workingNode);

                return {
                    boundaryPosition: boundaryPosition,
                    nodeInfo: {
                        nodeIndex: nodeIndex,
                        containerElement: containerElement
                    }
                };
            };

            // Returns a TextRange representing the boundary of a TextRange expressed as a node and an offset within that
            // node. This function started out as an optimized version of code found in Tim Cameron Ryan's IERange
            // (http://code.google.com/p/ierange/)
            var createBoundaryTextRange = function(boundaryPosition, isStart) {
                var boundaryNode, boundaryParent, boundaryOffset = boundaryPosition.offset;
                var doc = dom.getDocument(boundaryPosition.node);
                var workingNode, childNodes, workingRange = getBody(doc).createTextRange();
                var nodeIsDataNode = isCharacterDataNode(boundaryPosition.node);

                if (nodeIsDataNode) {
                    boundaryNode = boundaryPosition.node;
                    boundaryParent = boundaryNode.parentNode;
                } else {
                    childNodes = boundaryPosition.node.childNodes;
                    boundaryNode = (boundaryOffset < childNodes.length) ? childNodes[boundaryOffset] : null;
                    boundaryParent = boundaryPosition.node;
                }

                // Position the range immediately before the node containing the boundary
                workingNode = doc.createElement("span");

                // Making the working element non-empty element persuades IE to consider the TextRange boundary to be within
                // the element rather than immediately before or after it
                workingNode.innerHTML = "&#feff;";

                // insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report
                // for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12
                if (boundaryNode) {
                    boundaryParent.insertBefore(workingNode, boundaryNode);
                } else {
                    boundaryParent.appendChild(workingNode);
                }

                workingRange.moveToElementText(workingNode);
                workingRange.collapse(!isStart);

                // Clean up
                boundaryParent.removeChild(workingNode);

                // Move the working range to the text offset, if required
                if (nodeIsDataNode) {
                    workingRange[isStart ? "moveStart" : "moveEnd"]("character", boundaryOffset);
                }

                return workingRange;
            };

            /*------------------------------------------------------------------------------------------------------------*/

            // This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a
            // prototype

            WrappedTextRange = function(textRange) {
                this.textRange = textRange;
                this.refresh();
            };

            WrappedTextRange.prototype = new DomRange(document);

            WrappedTextRange.prototype.refresh = function() {
                var start, end, startBoundary;

                // TextRange's parentElement() method cannot be trusted. getTextRangeContainerElement() works around that.
                var rangeContainerElement = getTextRangeContainerElement(this.textRange);

                if (textRangeIsCollapsed(this.textRange)) {
                    end = start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true,
                        true).boundaryPosition;
                } else {
                    startBoundary = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, false);
                    start = startBoundary.boundaryPosition;

                    // An optimization used here is that if the start and end boundaries have the same parent element, the
                    // search scope for the end boundary can be limited to exclude the portion of the element that precedes
                    // the start boundary
                    end = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, false, false,
                        startBoundary.nodeInfo).boundaryPosition;
                }

                this.setStart(start.node, start.offset);
                this.setEnd(end.node, end.offset);
            };

            WrappedTextRange.prototype.getName = function() {
                return "WrappedTextRange";
            };

            DomRange.copyComparisonConstants(WrappedTextRange);

            var rangeToTextRange = function(range) {
                if (range.collapsed) {
                    return createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
                } else {
                    var startRange = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
                    var endRange = createBoundaryTextRange(new DomPosition(range.endContainer, range.endOffset), false);
                    var textRange = getBody( DomRange.getRangeDocument(range) ).createTextRange();
                    textRange.setEndPoint("StartToStart", startRange);
                    textRange.setEndPoint("EndToEnd", endRange);
                    return textRange;
                }
            };

            WrappedTextRange.rangeToTextRange = rangeToTextRange;

            WrappedTextRange.prototype.toTextRange = function() {
                return rangeToTextRange(this);
            };

            api.WrappedTextRange = WrappedTextRange;

            // IE 9 and above have both implementations and Rangy makes both available. The next few lines sets which
            // implementation to use by default.
            if (!api.features.implementsDomRange || api.config.preferTextRange) {
                // Add WrappedTextRange as the Range property of the global object to allow expression like Range.END_TO_END to work
                var globalObj = (function(f) { return f("return this;")(); })(Function);
                if (typeof globalObj.Range == "undefined") {
                    globalObj.Range = WrappedTextRange;
                }

                api.createNativeRange = function(doc) {
                    doc = getContentDocument(doc, module, "createNativeRange");
                    return getBody(doc).createTextRange();
                };

                api.WrappedRange = WrappedTextRange;
            }
        }

        api.createRange = function(doc) {
            doc = getContentDocument(doc, module, "createRange");
            return new api.WrappedRange(api.createNativeRange(doc));
        };

        api.createRangyRange = function(doc) {
            doc = getContentDocument(doc, module, "createRangyRange");
            return new DomRange(doc);
        };

        util.createAliasForDeprecatedMethod(api, "createIframeRange", "createRange");
        util.createAliasForDeprecatedMethod(api, "createIframeRangyRange", "createRangyRange");

        api.addShimListener(function(win) {
            var doc = win.document;
            if (typeof doc.createRange == "undefined") {
                doc.createRange = function() {
                    return api.createRange(doc);
                };
            }
            doc = win = null;
        });
    });

    /*----------------------------------------------------------------------------------------------------------------*/

    // This module creates a selection object wrapper that conforms as closely as possible to the Selection specification
    // in the HTML Editing spec (http://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#selections)
    api.createCoreModule("WrappedSelection", ["DomRange", "WrappedRange"], function(api, module) {
        api.config.checkSelectionRanges = true;

        var BOOLEAN = "boolean";
        var NUMBER = "number";
        var dom = api.dom;
        var util = api.util;
        var isHostMethod = util.isHostMethod;
        var DomRange = api.DomRange;
        var WrappedRange = api.WrappedRange;
        var DOMException = api.DOMException;
        var DomPosition = dom.DomPosition;
        var getNativeSelection;
        var selectionIsCollapsed;
        var features = api.features;
        var CONTROL = "Control";
        var getDocument = dom.getDocument;
        var getBody = dom.getBody;
        var rangesEqual = DomRange.rangesEqual;


        // Utility function to support direction parameters in the API that may be a string ("backward", "backwards",
        // "forward" or "forwards") or a Boolean (true for backwards).
        function isDirectionBackward(dir) {
            return (typeof dir == "string") ? /^backward(s)?$/i.test(dir) : !!dir;
        }

        function getWindow(win, methodName) {
            if (!win) {
                return window;
            } else if (dom.isWindow(win)) {
                return win;
            } else if (win instanceof WrappedSelection) {
                return win.win;
            } else {
                var doc = dom.getContentDocument(win, module, methodName);
                return dom.getWindow(doc);
            }
        }

        function getWinSelection(winParam) {
            return getWindow(winParam, "getWinSelection").getSelection();
        }

        function getDocSelection(winParam) {
            return getWindow(winParam, "getDocSelection").document.selection;
        }

        function winSelectionIsBackward(sel) {
            var backward = false;
            if (sel.anchorNode) {
                backward = (dom.comparePoints(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset) == 1);
            }
            return backward;
        }

        // Test for the Range/TextRange and Selection features required
        // Test for ability to retrieve selection
        var implementsWinGetSelection = isHostMethod(window, "getSelection"),
            implementsDocSelection = util.isHostObject(document, "selection");

        features.implementsWinGetSelection = implementsWinGetSelection;
        features.implementsDocSelection = implementsDocSelection;

        var useDocumentSelection = implementsDocSelection && (!implementsWinGetSelection || api.config.preferTextRange);

        if (useDocumentSelection) {
            getNativeSelection = getDocSelection;
            api.isSelectionValid = function(winParam) {
                var doc = getWindow(winParam, "isSelectionValid").document, nativeSel = doc.selection;

                // Check whether the selection TextRange is actually contained within the correct document
                return (nativeSel.type != "None" || getDocument(nativeSel.createRange().parentElement()) == doc);
            };
        } else if (implementsWinGetSelection) {
            getNativeSelection = getWinSelection;
            api.isSelectionValid = function() {
                return true;
            };
        } else {
            module.fail("Neither document.selection or window.getSelection() detected.");
            return false;
        }

        api.getNativeSelection = getNativeSelection;

        var testSelection = getNativeSelection();

        // In Firefox, the selection is null in an iframe with display: none. See issue #138.
        if (!testSelection) {
            module.fail("Native selection was null (possibly issue 138?)");
            return false;
        }

        var testRange = api.createNativeRange(document);
        var body = getBody(document);

        // Obtaining a range from a selection
        var selectionHasAnchorAndFocus = util.areHostProperties(testSelection,
            ["anchorNode", "focusNode", "anchorOffset", "focusOffset"]);

        features.selectionHasAnchorAndFocus = selectionHasAnchorAndFocus;

        // Test for existence of native selection extend() method
        var selectionHasExtend = isHostMethod(testSelection, "extend");
        features.selectionHasExtend = selectionHasExtend;

        // Test if rangeCount exists
        var selectionHasRangeCount = (typeof testSelection.rangeCount == NUMBER);
        features.selectionHasRangeCount = selectionHasRangeCount;

        var selectionSupportsMultipleRanges = false;
        var collapsedNonEditableSelectionsSupported = true;

        var addRangeBackwardToNative = selectionHasExtend ?
            function(nativeSelection, range) {
                var doc = DomRange.getRangeDocument(range);
                var endRange = api.createRange(doc);
                endRange.collapseToPoint(range.endContainer, range.endOffset);
                nativeSelection.addRange(getNativeRange(endRange));
                nativeSelection.extend(range.startContainer, range.startOffset);
            } : null;

        if (util.areHostMethods(testSelection, ["addRange", "getRangeAt", "removeAllRanges"]) &&
                typeof testSelection.rangeCount == NUMBER && features.implementsDomRange) {

            (function() {
                // Previously an iframe was used but this caused problems in some circumstances in IE, so tests are
                // performed on the current document's selection. See issue 109.

                // Note also that if a selection previously existed, it is wiped and later restored by these tests. This
                // will result in the selection direction begin reversed if the original selection was backwards and the
                // browser does not support setting backwards selections (Internet Explorer, I'm looking at you).
                var sel = window.getSelection();
                if (sel) {
                    // Store the current selection
                    var originalSelectionRangeCount = sel.rangeCount;
                    var selectionHasMultipleRanges = (originalSelectionRangeCount > 1);
                    var originalSelectionRanges = [];
                    var originalSelectionBackward = winSelectionIsBackward(sel);
                    for (var i = 0; i < originalSelectionRangeCount; ++i) {
                        originalSelectionRanges[i] = sel.getRangeAt(i);
                    }

                    // Create some test elements
                    var testEl = dom.createTestElement(document, "", false);
                    var textNode = testEl.appendChild( document.createTextNode("\u00a0\u00a0\u00a0") );

                    // Test whether the native selection will allow a collapsed selection within a non-editable element
                    var r1 = document.createRange();

                    r1.setStart(textNode, 1);
                    r1.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(r1);
                    collapsedNonEditableSelectionsSupported = (sel.rangeCount == 1);
                    sel.removeAllRanges();

                    // Test whether the native selection is capable of supporting multiple ranges.
                    if (!selectionHasMultipleRanges) {
                        // Doing the original feature test here in Chrome 36 (and presumably later versions) prints a
                        // console error of "Discontiguous selection is not supported." that cannot be suppressed. There's
                        // nothing we can do about this while retaining the feature test so we have to resort to a browser
                        // sniff. I'm not happy about it. See
                        // https://code.google.com/p/chromium/issues/detail?id=399791
                        var chromeMatch = window.navigator.appVersion.match(/Chrome\/(.*?) /);
                        if (chromeMatch && parseInt(chromeMatch[1]) >= 36) {
                            selectionSupportsMultipleRanges = false;
                        } else {
                            var r2 = r1.cloneRange();
                            r1.setStart(textNode, 0);
                            r2.setEnd(textNode, 3);
                            r2.setStart(textNode, 2);
                            sel.addRange(r1);
                            sel.addRange(r2);
                            selectionSupportsMultipleRanges = (sel.rangeCount == 2);
                        }
                    }

                    // Clean up
                    dom.removeNode(testEl);
                    sel.removeAllRanges();

                    for (i = 0; i < originalSelectionRangeCount; ++i) {
                        if (i == 0 && originalSelectionBackward) {
                            if (addRangeBackwardToNative) {
                                addRangeBackwardToNative(sel, originalSelectionRanges[i]);
                            } else {
                                api.warn("Rangy initialization: original selection was backwards but selection has been restored forwards because the browser does not support Selection.extend");
                                sel.addRange(originalSelectionRanges[i]);
                            }
                        } else {
                            sel.addRange(originalSelectionRanges[i]);
                        }
                    }
                }
            })();
        }

        features.selectionSupportsMultipleRanges = selectionSupportsMultipleRanges;
        features.collapsedNonEditableSelectionsSupported = collapsedNonEditableSelectionsSupported;

        // ControlRanges
        var implementsControlRange = false, testControlRange;

        if (body && isHostMethod(body, "createControlRange")) {
            testControlRange = body.createControlRange();
            if (util.areHostProperties(testControlRange, ["item", "add"])) {
                implementsControlRange = true;
            }
        }
        features.implementsControlRange = implementsControlRange;

        // Selection collapsedness
        if (selectionHasAnchorAndFocus) {
            selectionIsCollapsed = function(sel) {
                return sel.anchorNode === sel.focusNode && sel.anchorOffset === sel.focusOffset;
            };
        } else {
            selectionIsCollapsed = function(sel) {
                return sel.rangeCount ? sel.getRangeAt(sel.rangeCount - 1).collapsed : false;
            };
        }

        function updateAnchorAndFocusFromRange(sel, range, backward) {
            var anchorPrefix = backward ? "end" : "start", focusPrefix = backward ? "start" : "end";
            sel.anchorNode = range[anchorPrefix + "Container"];
            sel.anchorOffset = range[anchorPrefix + "Offset"];
            sel.focusNode = range[focusPrefix + "Container"];
            sel.focusOffset = range[focusPrefix + "Offset"];
        }

        function updateAnchorAndFocusFromNativeSelection(sel) {
            var nativeSel = sel.nativeSelection;
            sel.anchorNode = nativeSel.anchorNode;
            sel.anchorOffset = nativeSel.anchorOffset;
            sel.focusNode = nativeSel.focusNode;
            sel.focusOffset = nativeSel.focusOffset;
        }

        function updateEmptySelection(sel) {
            sel.anchorNode = sel.focusNode = null;
            sel.anchorOffset = sel.focusOffset = 0;
            sel.rangeCount = 0;
            sel.isCollapsed = true;
            sel._ranges.length = 0;
        }

        function getNativeRange(range) {
            var nativeRange;
            if (range instanceof DomRange) {
                nativeRange = api.createNativeRange(range.getDocument());
                nativeRange.setEnd(range.endContainer, range.endOffset);
                nativeRange.setStart(range.startContainer, range.startOffset);
            } else if (range instanceof WrappedRange) {
                nativeRange = range.nativeRange;
            } else if (features.implementsDomRange && (range instanceof dom.getWindow(range.startContainer).Range)) {
                nativeRange = range;
            }
            return nativeRange;
        }

        function rangeContainsSingleElement(rangeNodes) {
            if (!rangeNodes.length || (rangeNodes[0] && rangeNodes[0].nodeType != 1)) {
                return false;
            }
            for (var i = 1, len = rangeNodes.length; i < len; ++i) {
                if (!dom.isAncestorOf(rangeNodes[0], rangeNodes[i])) {
                    return false;
                }
            }
            return true;
        }

        function getSingleElementFromRange(range) {
            var nodes = range.getNodes();
            if (!rangeContainsSingleElement(nodes)) {
                throw module.createError("getSingleElementFromRange: range " + range.inspect() + " did not consist of a single element");
            }
            return nodes[0];
        }

        // Simple, quick test which only needs to distinguish between a TextRange and a ControlRange
        function isTextRange(range) {
            return !!range && typeof range.text != "undefined";
        }

        function updateFromTextRange(sel, range) {
            // Create a Range from the selected TextRange
            var wrappedRange = new WrappedRange(range);
            sel._ranges = [wrappedRange];

            updateAnchorAndFocusFromRange(sel, wrappedRange, false);
            sel.rangeCount = 1;
            sel.isCollapsed = wrappedRange.collapsed;
        }

        function updateControlSelection(sel) {
            // Update the wrapped selection based on what's now in the native selection
            sel._ranges.length = 0;
            if (sel.docSelection.type == "None") {
                updateEmptySelection(sel);
            } else {
                var controlRange = sel.docSelection.createRange();
                if (isTextRange(controlRange)) {
                    // This case (where the selection type is "Control" and calling createRange() on the selection returns
                    // a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected
                    // ControlRange have been removed from the ControlRange and removed from the document.
                    updateFromTextRange(sel, controlRange);
                } else {
                    sel.rangeCount = controlRange.length;
                    var range, doc = getDocument(controlRange.item(0));
                    for (var i = 0; i < sel.rangeCount; ++i) {
                        range = api.createRange(doc);
                        range.selectNode(controlRange.item(i));
                        sel._ranges.push(range);
                    }
                    sel.isCollapsed = sel.rangeCount == 1 && sel._ranges[0].collapsed;
                    updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], false);
                }
            }
        }

        function addRangeToControlSelection(sel, range) {
            var controlRange = sel.docSelection.createRange();
            var rangeElement = getSingleElementFromRange(range);

            // Create a new ControlRange containing all the elements in the selected ControlRange plus the element
            // contained by the supplied range
            var doc = getDocument(controlRange.item(0));
            var newControlRange = getBody(doc).createControlRange();
            for (var i = 0, len = controlRange.length; i < len; ++i) {
                newControlRange.add(controlRange.item(i));
            }
            try {
                newControlRange.add(rangeElement);
            } catch (ex) {
                throw module.createError("addRange(): Element within the specified Range could not be added to control selection (does it have layout?)");
            }
            newControlRange.select();

            // Update the wrapped selection based on what's now in the native selection
            updateControlSelection(sel);
        }

        var getSelectionRangeAt;

        if (isHostMethod(testSelection, "getRangeAt")) {
            // try/catch is present because getRangeAt() must have thrown an error in some browser and some situation.
            // Unfortunately, I didn't write a comment about the specifics and am now scared to take it out. Let that be a
            // lesson to us all, especially me.
            getSelectionRangeAt = function(sel, index) {
                try {
                    return sel.getRangeAt(index);
                } catch (ex) {
                    return null;
                }
            };
        } else if (selectionHasAnchorAndFocus) {
            getSelectionRangeAt = function(sel) {
                var doc = getDocument(sel.anchorNode);
                var range = api.createRange(doc);
                range.setStartAndEnd(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset);

                // Handle the case when the selection was selected backwards (from the end to the start in the
                // document)
                if (range.collapsed !== this.isCollapsed) {
                    range.setStartAndEnd(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset);
                }

                return range;
            };
        }

        function WrappedSelection(selection, docSelection, win) {
            this.nativeSelection = selection;
            this.docSelection = docSelection;
            this._ranges = [];
            this.win = win;
            this.refresh();
        }

        WrappedSelection.prototype = api.selectionPrototype;

        function deleteProperties(sel) {
            sel.win = sel.anchorNode = sel.focusNode = sel._ranges = null;
            sel.rangeCount = sel.anchorOffset = sel.focusOffset = 0;
            sel.detached = true;
        }

        var cachedRangySelections = [];

        function actOnCachedSelection(win, action) {
            var i = cachedRangySelections.length, cached, sel;
            while (i--) {
                cached = cachedRangySelections[i];
                sel = cached.selection;
                if (action == "deleteAll") {
                    deleteProperties(sel);
                } else if (cached.win == win) {
                    if (action == "delete") {
                        cachedRangySelections.splice(i, 1);
                        return true;
                    } else {
                        return sel;
                    }
                }
            }
            if (action == "deleteAll") {
                cachedRangySelections.length = 0;
            }
            return null;
        }

        var getSelection = function(win) {
            // Check if the parameter is a Rangy Selection object
            if (win && win instanceof WrappedSelection) {
                win.refresh();
                return win;
            }

            win = getWindow(win, "getNativeSelection");

            var sel = actOnCachedSelection(win);
            var nativeSel = getNativeSelection(win), docSel = implementsDocSelection ? getDocSelection(win) : null;
            if (sel) {
                sel.nativeSelection = nativeSel;
                sel.docSelection = docSel;
                sel.refresh();
            } else {
                sel = new WrappedSelection(nativeSel, docSel, win);
                cachedRangySelections.push( { win: win, selection: sel } );
            }
            return sel;
        };

        api.getSelection = getSelection;

        util.createAliasForDeprecatedMethod(api, "getIframeSelection", "getSelection");

        var selProto = WrappedSelection.prototype;

        function createControlSelection(sel, ranges) {
            // Ensure that the selection becomes of type "Control"
            var doc = getDocument(ranges[0].startContainer);
            var controlRange = getBody(doc).createControlRange();
            for (var i = 0, el, len = ranges.length; i < len; ++i) {
                el = getSingleElementFromRange(ranges[i]);
                try {
                    controlRange.add(el);
                } catch (ex) {
                    throw module.createError("setRanges(): Element within one of the specified Ranges could not be added to control selection (does it have layout?)");
                }
            }
            controlRange.select();

            // Update the wrapped selection based on what's now in the native selection
            updateControlSelection(sel);
        }

        // Selecting a range
        if (!useDocumentSelection && selectionHasAnchorAndFocus && util.areHostMethods(testSelection, ["removeAllRanges", "addRange"])) {
            selProto.removeAllRanges = function() {
                this.nativeSelection.removeAllRanges();
                updateEmptySelection(this);
            };

            var addRangeBackward = function(sel, range) {
                addRangeBackwardToNative(sel.nativeSelection, range);
                sel.refresh();
            };

            if (selectionHasRangeCount) {
                selProto.addRange = function(range, direction) {
                    if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
                        addRangeToControlSelection(this, range);
                    } else {
                        if (isDirectionBackward(direction) && selectionHasExtend) {
                            addRangeBackward(this, range);
                        } else {
                            var previousRangeCount;
                            if (selectionSupportsMultipleRanges) {
                                previousRangeCount = this.rangeCount;
                            } else {
                                this.removeAllRanges();
                                previousRangeCount = 0;
                            }
                            // Clone the native range so that changing the selected range does not affect the selection.
                            // This is contrary to the spec but is the only way to achieve consistency between browsers. See
                            // issue 80.
                            var clonedNativeRange = getNativeRange(range).cloneRange();
                            try {
                                this.nativeSelection.addRange(clonedNativeRange);
                            } catch (ex) {
                            }

                            // Check whether adding the range was successful
                            this.rangeCount = this.nativeSelection.rangeCount;

                            if (this.rangeCount == previousRangeCount + 1) {
                                // The range was added successfully

                                // Check whether the range that we added to the selection is reflected in the last range extracted from
                                // the selection
                                if (api.config.checkSelectionRanges) {
                                    var nativeRange = getSelectionRangeAt(this.nativeSelection, this.rangeCount - 1);
                                    if (nativeRange && !rangesEqual(nativeRange, range)) {
                                        // Happens in WebKit with, for example, a selection placed at the start of a text node
                                        range = new WrappedRange(nativeRange);
                                    }
                                }
                                this._ranges[this.rangeCount - 1] = range;
                                updateAnchorAndFocusFromRange(this, range, selectionIsBackward(this.nativeSelection));
                                this.isCollapsed = selectionIsCollapsed(this);
                            } else {
                                // The range was not added successfully. The simplest thing is to refresh
                                this.refresh();
                            }
                        }
                    }
                };
            } else {
                selProto.addRange = function(range, direction) {
                    if (isDirectionBackward(direction) && selectionHasExtend) {
                        addRangeBackward(this, range);
                    } else {
                        this.nativeSelection.addRange(getNativeRange(range));
                        this.refresh();
                    }
                };
            }

            selProto.setRanges = function(ranges) {
                if (implementsControlRange && implementsDocSelection && ranges.length > 1) {
                    createControlSelection(this, ranges);
                } else {
                    this.removeAllRanges();
                    for (var i = 0, len = ranges.length; i < len; ++i) {
                        this.addRange(ranges[i]);
                    }
                }
            };
        } else if (isHostMethod(testSelection, "empty") && isHostMethod(testRange, "select") &&
                   implementsControlRange && useDocumentSelection) {

            selProto.removeAllRanges = function() {
                // Added try/catch as fix for issue #21
                try {
                    this.docSelection.empty();

                    // Check for empty() not working (issue #24)
                    if (this.docSelection.type != "None") {
                        // Work around failure to empty a control selection by instead selecting a TextRange and then
                        // calling empty()
                        var doc;
                        if (this.anchorNode) {
                            doc = getDocument(this.anchorNode);
                        } else if (this.docSelection.type == CONTROL) {
                            var controlRange = this.docSelection.createRange();
                            if (controlRange.length) {
                                doc = getDocument( controlRange.item(0) );
                            }
                        }
                        if (doc) {
                            var textRange = getBody(doc).createTextRange();
                            textRange.select();
                            this.docSelection.empty();
                        }
                    }
                } catch(ex) {}
                updateEmptySelection(this);
            };

            selProto.addRange = function(range) {
                if (this.docSelection.type == CONTROL) {
                    addRangeToControlSelection(this, range);
                } else {
                    api.WrappedTextRange.rangeToTextRange(range).select();
                    this._ranges[0] = range;
                    this.rangeCount = 1;
                    this.isCollapsed = this._ranges[0].collapsed;
                    updateAnchorAndFocusFromRange(this, range, false);
                }
            };

            selProto.setRanges = function(ranges) {
                this.removeAllRanges();
                var rangeCount = ranges.length;
                if (rangeCount > 1) {
                    createControlSelection(this, ranges);
                } else if (rangeCount) {
                    this.addRange(ranges[0]);
                }
            };
        } else {
            module.fail("No means of selecting a Range or TextRange was found");
            return false;
        }

        selProto.getRangeAt = function(index) {
            if (index < 0 || index >= this.rangeCount) {
                throw new DOMException("INDEX_SIZE_ERR");
            } else {
                // Clone the range to preserve selection-range independence. See issue 80.
                return this._ranges[index].cloneRange();
            }
        };

        var refreshSelection;

        if (useDocumentSelection) {
            refreshSelection = function(sel) {
                var range;
                if (api.isSelectionValid(sel.win)) {
                    range = sel.docSelection.createRange();
                } else {
                    range = getBody(sel.win.document).createTextRange();
                    range.collapse(true);
                }

                if (sel.docSelection.type == CONTROL) {
                    updateControlSelection(sel);
                } else if (isTextRange(range)) {
                    updateFromTextRange(sel, range);
                } else {
                    updateEmptySelection(sel);
                }
            };
        } else if (isHostMethod(testSelection, "getRangeAt") && typeof testSelection.rangeCount == NUMBER) {
            refreshSelection = function(sel) {
                if (implementsControlRange && implementsDocSelection && sel.docSelection.type == CONTROL) {
                    updateControlSelection(sel);
                } else {
                    sel._ranges.length = sel.rangeCount = sel.nativeSelection.rangeCount;
                    if (sel.rangeCount) {
                        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                            sel._ranges[i] = new api.WrappedRange(sel.nativeSelection.getRangeAt(i));
                        }
                        updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], selectionIsBackward(sel.nativeSelection));
                        sel.isCollapsed = selectionIsCollapsed(sel);
                    } else {
                        updateEmptySelection(sel);
                    }
                }
            };
        } else if (selectionHasAnchorAndFocus && typeof testSelection.isCollapsed == BOOLEAN && typeof testRange.collapsed == BOOLEAN && features.implementsDomRange) {
            refreshSelection = function(sel) {
                var range, nativeSel = sel.nativeSelection;
                if (nativeSel.anchorNode) {
                    range = getSelectionRangeAt(nativeSel, 0);
                    sel._ranges = [range];
                    sel.rangeCount = 1;
                    updateAnchorAndFocusFromNativeSelection(sel);
                    sel.isCollapsed = selectionIsCollapsed(sel);
                } else {
                    updateEmptySelection(sel);
                }
            };
        } else {
            module.fail("No means of obtaining a Range or TextRange from the user's selection was found");
            return false;
        }

        selProto.refresh = function(checkForChanges) {
            var oldRanges = checkForChanges ? this._ranges.slice(0) : null;
            var oldAnchorNode = this.anchorNode, oldAnchorOffset = this.anchorOffset;

            refreshSelection(this);
            if (checkForChanges) {
                // Check the range count first
                var i = oldRanges.length;
                if (i != this._ranges.length) {
                    return true;
                }

                // Now check the direction. Checking the anchor position is the same is enough since we're checking all the
                // ranges after this
                if (this.anchorNode != oldAnchorNode || this.anchorOffset != oldAnchorOffset) {
                    return true;
                }

                // Finally, compare each range in turn
                while (i--) {
                    if (!rangesEqual(oldRanges[i], this._ranges[i])) {
                        return true;
                    }
                }
                return false;
            }
        };

        // Removal of a single range
        var removeRangeManually = function(sel, range) {
            var ranges = sel.getAllRanges();
            sel.removeAllRanges();
            for (var i = 0, len = ranges.length; i < len; ++i) {
                if (!rangesEqual(range, ranges[i])) {
                    sel.addRange(ranges[i]);
                }
            }
            if (!sel.rangeCount) {
                updateEmptySelection(sel);
            }
        };

        if (implementsControlRange && implementsDocSelection) {
            selProto.removeRange = function(range) {
                if (this.docSelection.type == CONTROL) {
                    var controlRange = this.docSelection.createRange();
                    var rangeElement = getSingleElementFromRange(range);

                    // Create a new ControlRange containing all the elements in the selected ControlRange minus the
                    // element contained by the supplied range
                    var doc = getDocument(controlRange.item(0));
                    var newControlRange = getBody(doc).createControlRange();
                    var el, removed = false;
                    for (var i = 0, len = controlRange.length; i < len; ++i) {
                        el = controlRange.item(i);
                        if (el !== rangeElement || removed) {
                            newControlRange.add(controlRange.item(i));
                        } else {
                            removed = true;
                        }
                    }
                    newControlRange.select();

                    // Update the wrapped selection based on what's now in the native selection
                    updateControlSelection(this);
                } else {
                    removeRangeManually(this, range);
                }
            };
        } else {
            selProto.removeRange = function(range) {
                removeRangeManually(this, range);
            };
        }

        // Detecting if a selection is backward
        var selectionIsBackward;
        if (!useDocumentSelection && selectionHasAnchorAndFocus && features.implementsDomRange) {
            selectionIsBackward = winSelectionIsBackward;

            selProto.isBackward = function() {
                return selectionIsBackward(this);
            };
        } else {
            selectionIsBackward = selProto.isBackward = function() {
                return false;
            };
        }

        // Create an alias for backwards compatibility. From 1.3, everything is "backward" rather than "backwards"
        selProto.isBackwards = selProto.isBackward;

        // Selection stringifier
        // This is conformant to the old HTML5 selections draft spec but differs from WebKit and Mozilla's implementation.
        // The current spec does not yet define this method.
        selProto.toString = function() {
            var rangeTexts = [];
            for (var i = 0, len = this.rangeCount; i < len; ++i) {
                rangeTexts[i] = "" + this._ranges[i];
            }
            return rangeTexts.join("");
        };

        function assertNodeInSameDocument(sel, node) {
            if (sel.win.document != getDocument(node)) {
                throw new DOMException("WRONG_DOCUMENT_ERR");
            }
        }

        // No current browser conforms fully to the spec for this method, so Rangy's own method is always used
        selProto.collapse = function(node, offset) {
            assertNodeInSameDocument(this, node);
            var range = api.createRange(node);
            range.collapseToPoint(node, offset);
            this.setSingleRange(range);
            this.isCollapsed = true;
        };

        selProto.collapseToStart = function() {
            if (this.rangeCount) {
                var range = this._ranges[0];
                this.collapse(range.startContainer, range.startOffset);
            } else {
                throw new DOMException("INVALID_STATE_ERR");
            }
        };

        selProto.collapseToEnd = function() {
            if (this.rangeCount) {
                var range = this._ranges[this.rangeCount - 1];
                this.collapse(range.endContainer, range.endOffset);
            } else {
                throw new DOMException("INVALID_STATE_ERR");
            }
        };

        // The spec is very specific on how selectAllChildren should be implemented and not all browsers implement it as
        // specified so the native implementation is never used by Rangy.
        selProto.selectAllChildren = function(node) {
            assertNodeInSameDocument(this, node);
            var range = api.createRange(node);
            range.selectNodeContents(node);
            this.setSingleRange(range);
        };

        selProto.deleteFromDocument = function() {
            // Sepcial behaviour required for IE's control selections
            if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
                var controlRange = this.docSelection.createRange();
                var element;
                while (controlRange.length) {
                    element = controlRange.item(0);
                    controlRange.remove(element);
                    dom.removeNode(element);
                }
                this.refresh();
            } else if (this.rangeCount) {
                var ranges = this.getAllRanges();
                if (ranges.length) {
                    this.removeAllRanges();
                    for (var i = 0, len = ranges.length; i < len; ++i) {
                        ranges[i].deleteContents();
                    }
                    // The spec says nothing about what the selection should contain after calling deleteContents on each
                    // range. Firefox moves the selection to where the final selected range was, so we emulate that
                    this.addRange(ranges[len - 1]);
                }
            }
        };

        // The following are non-standard extensions
        selProto.eachRange = function(func, returnValue) {
            for (var i = 0, len = this._ranges.length; i < len; ++i) {
                if ( func( this.getRangeAt(i) ) ) {
                    return returnValue;
                }
            }
        };

        selProto.getAllRanges = function() {
            var ranges = [];
            this.eachRange(function(range) {
                ranges.push(range);
            });
            return ranges;
        };

        selProto.setSingleRange = function(range, direction) {
            this.removeAllRanges();
            this.addRange(range, direction);
        };

        selProto.callMethodOnEachRange = function(methodName, params) {
            var results = [];
            this.eachRange( function(range) {
                results.push( range[methodName].apply(range, params || []) );
            } );
            return results;
        };

        function createStartOrEndSetter(isStart) {
            return function(node, offset) {
                var range;
                if (this.rangeCount) {
                    range = this.getRangeAt(0);
                    range["set" + (isStart ? "Start" : "End")](node, offset);
                } else {
                    range = api.createRange(this.win.document);
                    range.setStartAndEnd(node, offset);
                }
                this.setSingleRange(range, this.isBackward());
            };
        }

        selProto.setStart = createStartOrEndSetter(true);
        selProto.setEnd = createStartOrEndSetter(false);

        // Add select() method to Range prototype. Any existing selection will be removed.
        api.rangePrototype.select = function(direction) {
            getSelection( this.getDocument() ).setSingleRange(this, direction);
        };

        selProto.changeEachRange = function(func) {
            var ranges = [];
            var backward = this.isBackward();

            this.eachRange(function(range) {
                func(range);
                ranges.push(range);
            });

            this.removeAllRanges();
            if (backward && ranges.length == 1) {
                this.addRange(ranges[0], "backward");
            } else {
                this.setRanges(ranges);
            }
        };

        selProto.containsNode = function(node, allowPartial) {
            return this.eachRange( function(range) {
                return range.containsNode(node, allowPartial);
            }, true ) || false;
        };

        selProto.getBookmark = function(containerNode) {
            return {
                backward: this.isBackward(),
                rangeBookmarks: this.callMethodOnEachRange("getBookmark", [containerNode])
            };
        };

        selProto.moveToBookmark = function(bookmark) {
            var selRanges = [];
            for (var i = 0, rangeBookmark, range; rangeBookmark = bookmark.rangeBookmarks[i++]; ) {
                range = api.createRange(this.win);
                range.moveToBookmark(rangeBookmark);
                selRanges.push(range);
            }
            if (bookmark.backward) {
                this.setSingleRange(selRanges[0], "backward");
            } else {
                this.setRanges(selRanges);
            }
        };

        selProto.saveRanges = function() {
            return {
                backward: this.isBackward(),
                ranges: this.callMethodOnEachRange("cloneRange")
            };
        };

        selProto.restoreRanges = function(selRanges) {
            this.removeAllRanges();
            for (var i = 0, range; range = selRanges.ranges[i]; ++i) {
                this.addRange(range, (selRanges.backward && i == 0));
            }
        };

        selProto.toHtml = function() {
            var rangeHtmls = [];
            this.eachRange(function(range) {
                rangeHtmls.push( DomRange.toHtml(range) );
            });
            return rangeHtmls.join("");
        };

        if (features.implementsTextRange) {
            selProto.getNativeTextRange = function() {
                var sel, textRange;
                if ( (sel = this.docSelection) ) {
                    var range = sel.createRange();
                    if (isTextRange(range)) {
                        return range;
                    } else {
                        throw module.createError("getNativeTextRange: selection is a control selection");
                    }
                } else if (this.rangeCount > 0) {
                    return api.WrappedTextRange.rangeToTextRange( this.getRangeAt(0) );
                } else {
                    throw module.createError("getNativeTextRange: selection contains no range");
                }
            };
        }

        function inspect(sel) {
            var rangeInspects = [];
            var anchor = new DomPosition(sel.anchorNode, sel.anchorOffset);
            var focus = new DomPosition(sel.focusNode, sel.focusOffset);
            var name = (typeof sel.getName == "function") ? sel.getName() : "Selection";

            if (typeof sel.rangeCount != "undefined") {
                for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                    rangeInspects[i] = DomRange.inspect(sel.getRangeAt(i));
                }
            }
            return "[" + name + "(Ranges: " + rangeInspects.join(", ") +
                    ")(anchor: " + anchor.inspect() + ", focus: " + focus.inspect() + "]";
        }

        selProto.getName = function() {
            return "WrappedSelection";
        };

        selProto.inspect = function() {
            return inspect(this);
        };

        selProto.detach = function() {
            actOnCachedSelection(this.win, "delete");
            deleteProperties(this);
        };

        WrappedSelection.detachAll = function() {
            actOnCachedSelection(null, "deleteAll");
        };

        WrappedSelection.inspect = inspect;
        WrappedSelection.isDirectionBackward = isDirectionBackward;

        api.Selection = WrappedSelection;

        api.selectionPrototype = selProto;

        api.addShimListener(function(win) {
            if (typeof win.getSelection == "undefined") {
                win.getSelection = function() {
                    return getSelection(win);
                };
            }
            win = null;
        });
    });
    

    /*----------------------------------------------------------------------------------------------------------------*/

    // Wait for document to load before initializing
    var docReady = false;

    var loadHandler = function(e) {
        if (!docReady) {
            docReady = true;
            if (!api.initialized && api.config.autoInitialize) {
                init();
            }
        }
    };

    if (isBrowser) {
        // Test whether the document has already been loaded and initialize immediately if so
        if (document.readyState == "complete") {
            loadHandler();
        } else {
            if (isHostMethod(document, "addEventListener")) {
                document.addEventListener("DOMContentLoaded", loadHandler, false);
            }

            // Add a fallback in case the DOMContentLoaded event isn't supported
            addListener(window, "load", loadHandler);
        }
    }

    return api;
}, this);

/**
 * Class Applier module for Rangy.
 * Adds, removes and toggles classes on Ranges and Selections
 *
 * Part of Rangy, a cross-browser JavaScript range and selection library
 * https://github.com/timdown/rangy
 *
 * Depends on Rangy core.
 *
 * Copyright 2015, Tim Down
 * Licensed under the MIT license.
 * Version: 1.3.1-dev
 * Build date: 20 May 2015
 */
(function(factory, root) {
    if (typeof define == "function" && define.amd) {
        // AMD. Register as an anonymous module with a dependency on Rangy.
        define(["./rangy-core"], factory);
    } else if (typeof module != "undefined" && typeof exports == "object") {
        // Node/CommonJS style
        module.exports = factory( require("rangy") );
    } else {
        // No AMD or CommonJS support so we use the rangy property of root (probably the global variable)
        factory(root.rangy);
    }
})(function(rangy) {
    rangy.createModule("ClassApplier", ["WrappedSelection"], function(api, module) {
        var dom = api.dom;
        var DomPosition = dom.DomPosition;
        var contains = dom.arrayContains;
        var util = api.util;
        var forEach = util.forEach;


        var defaultTagName = "span";
        var createElementNSSupported = util.isHostMethod(document, "createElementNS");

        function each(obj, func) {
            for (var i in obj) {
                if (obj.hasOwnProperty(i)) {
                    if (func(i, obj[i]) === false) {
                        return false;
                    }
                }
            }
            return true;
        }

        function trim(str) {
            return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
        }

        function classNameContainsClass(fullClassName, className) {
            return !!fullClassName && new RegExp("(?:^|\\s)" + className + "(?:\\s|$)").test(fullClassName);
        }

        // Inefficient, inelegant nonsense for IE's svg element, which has no classList and non-HTML className implementation
        function hasClass(el, className) {
            if (typeof el.classList == "object") {
                return el.classList.contains(className);
            } else {
                var classNameSupported = (typeof el.className == "string");
                var elClass = classNameSupported ? el.className : el.getAttribute("class");
                return classNameContainsClass(elClass, className);
            }
        }

        function addClass(el, className) {
            if (/\s+/.test(className)) {
                var classes = className.split(/\s+/);
                for (var i = 0, len = classes.length; i < len; ++i) {
                    addClass(el, classes[i]);
                }
            } else if (typeof el.classList == "object") {
                el.classList.add(className);
            } else {
                var classNameSupported = (typeof el.className == "string");
                var elClass = classNameSupported ? el.className : el.getAttribute("class");
                if (elClass) {
                    if (!classNameContainsClass(elClass, className)) {
                        elClass += " " + className;
                    }
                } else {
                    elClass = className;
                }
                if (classNameSupported) {
                    el.className = elClass;
                } else {
                    el.setAttribute("class", elClass);
                }
            }
        }

        var removeClass = (function() {
            function replacer(matched, whiteSpaceBefore, whiteSpaceAfter) {
                return (whiteSpaceBefore && whiteSpaceAfter) ? " " : "";
            }

            return function(el, className) {
                if (typeof el.classList == "object") {
                    el.classList.remove(className);
                } else {
                    var classNameSupported = (typeof el.className == "string");
                    var elClass = classNameSupported ? el.className : el.getAttribute("class");
                    elClass = elClass.replace(new RegExp("(^|\\s)" + className + "(\\s|$)"), replacer);
                    if (classNameSupported) {
                        el.className = elClass;
                    } else {
                        el.setAttribute("class", elClass);
                    }
                }
            };
        })();

        function getClass(el) {
            var classNameSupported = (typeof el.className == "string");
            return classNameSupported ? el.className : el.getAttribute("class");
        }

        function sortClassName(className) {
            return className && className.split(/\s+/).sort().join(" ");
        }

        function getSortedClassName(el) {
            return sortClassName( getClass(el) );
        }

        function haveSameClasses(el1, el2) {
            return getSortedClassName(el1) == getSortedClassName(el2);
        }

        function hasAllClasses(el, className) {
            var classes = className.split(/\s+/);
            for (var i = 0, len = classes.length; i < len; ++i) {
                if (!hasClass(el, trim(classes[i]))) {
                    return false;
                }
            }
            return true;
        }

        function canTextBeStyled(textNode) {
            var parent = textNode.parentNode;
            return (parent && parent.nodeType == 1 && !/^(textarea|style|script|select|iframe)$/i.test(parent.nodeName));
        }

        function movePosition(position, oldParent, oldIndex, newParent, newIndex) {
            var posNode = position.node, posOffset = position.offset;
            var newNode = posNode, newOffset = posOffset;

            if (posNode == newParent && posOffset > newIndex) {
                ++newOffset;
            }

            if (posNode == oldParent && (posOffset == oldIndex  || posOffset == oldIndex + 1)) {
                newNode = newParent;
                newOffset += newIndex - oldIndex;
            }

            if (posNode == oldParent && posOffset > oldIndex + 1) {
                --newOffset;
            }

            position.node = newNode;
            position.offset = newOffset;
        }

        function movePositionWhenRemovingNode(position, parentNode, index) {
            if (position.node == parentNode && position.offset > index) {
                --position.offset;
            }
        }

        function movePreservingPositions(node, newParent, newIndex, positionsToPreserve) {
            // For convenience, allow newIndex to be -1 to mean "insert at the end".
            if (newIndex == -1) {
                newIndex = newParent.childNodes.length;
            }

            var oldParent = node.parentNode;
            var oldIndex = dom.getNodeIndex(node);

            forEach(positionsToPreserve, function(position) {
                movePosition(position, oldParent, oldIndex, newParent, newIndex);
            });

            // Now actually move the node.
            if (newParent.childNodes.length == newIndex) {
                newParent.appendChild(node);
            } else {
                newParent.insertBefore(node, newParent.childNodes[newIndex]);
            }
        }

        function removePreservingPositions(node, positionsToPreserve) {

            var oldParent = node.parentNode;
            var oldIndex = dom.getNodeIndex(node);

            forEach(positionsToPreserve, function(position) {
                movePositionWhenRemovingNode(position, oldParent, oldIndex);
            });

            dom.removeNode(node);
        }

        function moveChildrenPreservingPositions(node, newParent, newIndex, removeNode, positionsToPreserve) {
            var child, children = [];
            while ( (child = node.firstChild) ) {
                movePreservingPositions(child, newParent, newIndex++, positionsToPreserve);
                children.push(child);
            }
            if (removeNode) {
                removePreservingPositions(node, positionsToPreserve);
            }
            return children;
        }

        function replaceWithOwnChildrenPreservingPositions(element, positionsToPreserve) {
            return moveChildrenPreservingPositions(element, element.parentNode, dom.getNodeIndex(element), true, positionsToPreserve);
        }

        function rangeSelectsAnyText(range, textNode) {
            var textNodeRange = range.cloneRange();
            textNodeRange.selectNodeContents(textNode);

            var intersectionRange = textNodeRange.intersection(range);
            var text = intersectionRange ? intersectionRange.toString() : "";

            return text != "";
        }

        function getEffectiveTextNodes(range, filter) {
            var nodes = range.getNodes([3], filter);

            // Optimization as per issue 145

            // Remove non-intersecting text nodes from the start of the range
            var start = 0, node;
            while ( (node = nodes[start]) && !rangeSelectsAnyText(range, node) ) {
                ++start;
            }

            // Remove non-intersecting text nodes from the start of the range
            var end = nodes.length - 1;
            while ( (node = nodes[end]) && !rangeSelectsAnyText(range, node) ) {
                --end;
            }

            return nodes.slice(start, end + 1);
        }

        function elementsHaveSameNonClassAttributes(el1, el2) {
            if (el1.attributes.length != el2.attributes.length) return false;
            for (var i = 0, len = el1.attributes.length, attr1, attr2, name; i < len; ++i) {
                attr1 = el1.attributes[i];
                name = attr1.name;
                if (name != "class") {
                    attr2 = el2.attributes.getNamedItem(name);
                    if ( (attr1 === null) != (attr2 === null) ) return false;
                    if (attr1.specified != attr2.specified) return false;
                    if (attr1.specified && attr1.nodeValue !== attr2.nodeValue) return false;
                }
            }
            return true;
        }

        function elementHasNonClassAttributes(el, exceptions) {
            for (var i = 0, len = el.attributes.length, attrName; i < len; ++i) {
                attrName = el.attributes[i].name;
                if ( !(exceptions && contains(exceptions, attrName)) && el.attributes[i].specified && attrName != "class") {
                    return true;
                }
            }
            return false;
        }

        var getComputedStyleProperty = dom.getComputedStyleProperty;
        var isEditableElement = (function() {
            var testEl = document.createElement("div");
            return typeof testEl.isContentEditable == "boolean" ?
                function (node) {
                    return node && node.nodeType == 1 && node.isContentEditable;
                } :
                function (node) {
                    if (!node || node.nodeType != 1 || node.contentEditable == "false") {
                        return false;
                    }
                    return node.contentEditable == "true" || isEditableElement(node.parentNode);
                };
        })();

        function isEditingHost(node) {
            var parent;
            return node && node.nodeType == 1 &&
                (( (parent = node.parentNode) && parent.nodeType == 9 && parent.designMode == "on") ||
                (isEditableElement(node) && !isEditableElement(node.parentNode)));
        }

        function isEditable(node) {
            return (isEditableElement(node) || (node.nodeType != 1 && isEditableElement(node.parentNode))) && !isEditingHost(node);
        }

        var inlineDisplayRegex = /^inline(-block|-table)?$/i;

        function isNonInlineElement(node) {
            return node && node.nodeType == 1 && !inlineDisplayRegex.test(getComputedStyleProperty(node, "display"));
        }

        // White space characters as defined by HTML 4 (http://www.w3.org/TR/html401/struct/text.html)
        var htmlNonWhiteSpaceRegex = /[^\r\n\t\f \u200B]/;

        function isUnrenderedWhiteSpaceNode(node) {
            if (node.data.length == 0) {
                return true;
            }
            if (htmlNonWhiteSpaceRegex.test(node.data)) {
                return false;
            }
            var cssWhiteSpace = getComputedStyleProperty(node.parentNode, "whiteSpace");
            switch (cssWhiteSpace) {
                case "pre":
                case "pre-wrap":
                case "-moz-pre-wrap":
                    return false;
                case "pre-line":
                    if (/[\r\n]/.test(node.data)) {
                        return false;
                    }
            }

            // We now have a whitespace-only text node that may be rendered depending on its context. If it is adjacent to a
            // non-inline element, it will not be rendered. This seems to be a good enough definition.
            return isNonInlineElement(node.previousSibling) || isNonInlineElement(node.nextSibling);
        }

        function getRangeBoundaries(ranges) {
            var positions = [], i, range;
            for (i = 0; range = ranges[i++]; ) {
                positions.push(
                    new DomPosition(range.startContainer, range.startOffset),
                    new DomPosition(range.endContainer, range.endOffset)
                );
            }
            return positions;
        }

        function updateRangesFromBoundaries(ranges, positions) {
            for (var i = 0, range, start, end, len = ranges.length; i < len; ++i) {
                range = ranges[i];
                start = positions[i * 2];
                end = positions[i * 2 + 1];
                range.setStartAndEnd(start.node, start.offset, end.node, end.offset);
            }
        }

        function isSplitPoint(node, offset) {
            if (dom.isCharacterDataNode(node)) {
                if (offset == 0) {
                    return !!node.previousSibling;
                } else if (offset == node.length) {
                    return !!node.nextSibling;
                } else {
                    return true;
                }
            }

            return offset > 0 && offset < node.childNodes.length;
        }

        function splitNodeAt(node, descendantNode, descendantOffset, positionsToPreserve) {
            var newNode, parentNode;
            var splitAtStart = (descendantOffset == 0);

            if (dom.isAncestorOf(descendantNode, node)) {
                return node;
            }

            if (dom.isCharacterDataNode(descendantNode)) {
                var descendantIndex = dom.getNodeIndex(descendantNode);
                if (descendantOffset == 0) {
                    descendantOffset = descendantIndex;
                } else if (descendantOffset == descendantNode.length) {
                    descendantOffset = descendantIndex + 1;
                } else {
                    throw module.createError("splitNodeAt() should not be called with offset in the middle of a data node (" +
                        descendantOffset + " in " + descendantNode.data);
                }
                descendantNode = descendantNode.parentNode;
            }

            if (isSplitPoint(descendantNode, descendantOffset)) {
                // descendantNode is now guaranteed not to be a text or other character node
                newNode = descendantNode.cloneNode(false);
                parentNode = descendantNode.parentNode;
                if (newNode.id) {
                    newNode.removeAttribute("id");
                }
                var child, newChildIndex = 0;

                while ( (child = descendantNode.childNodes[descendantOffset]) ) {
                    movePreservingPositions(child, newNode, newChildIndex++, positionsToPreserve);
                }
                movePreservingPositions(newNode, parentNode, dom.getNodeIndex(descendantNode) + 1, positionsToPreserve);
                return (descendantNode == node) ? newNode : splitNodeAt(node, parentNode, dom.getNodeIndex(newNode), positionsToPreserve);
            } else if (node != descendantNode) {
                newNode = descendantNode.parentNode;

                // Work out a new split point in the parent node
                var newNodeIndex = dom.getNodeIndex(descendantNode);

                if (!splitAtStart) {
                    newNodeIndex++;
                }
                return splitNodeAt(node, newNode, newNodeIndex, positionsToPreserve);
            }
            return node;
        }

        function areElementsMergeable(el1, el2) {
            return el1.namespaceURI == el2.namespaceURI &&
                el1.tagName.toLowerCase() == el2.tagName.toLowerCase() &&
                haveSameClasses(el1, el2) &&
                elementsHaveSameNonClassAttributes(el1, el2) &&
                getComputedStyleProperty(el1, "display") == "inline" &&
                getComputedStyleProperty(el2, "display") == "inline";
        }

        function createAdjacentMergeableTextNodeGetter(forward) {
            var siblingPropName = forward ? "nextSibling" : "previousSibling";

            return function(textNode, checkParentElement) {
                var el = textNode.parentNode;
                var adjacentNode = textNode[siblingPropName];
                if (adjacentNode) {
                    // Can merge if the node's previous/next sibling is a text node
                    if (adjacentNode && adjacentNode.nodeType == 3) {
                        return adjacentNode;
                    }
                } else if (checkParentElement) {
                    // Compare text node parent element with its sibling
                    adjacentNode = el[siblingPropName];
                    if (adjacentNode && adjacentNode.nodeType == 1 && areElementsMergeable(el, adjacentNode)) {
                        var adjacentNodeChild = adjacentNode[forward ? "firstChild" : "lastChild"];
                        if (adjacentNodeChild && adjacentNodeChild.nodeType == 3) {
                            return adjacentNodeChild;
                        }
                    }
                }
                return null;
            };
        }

        var getPreviousMergeableTextNode = createAdjacentMergeableTextNodeGetter(false),
            getNextMergeableTextNode = createAdjacentMergeableTextNodeGetter(true);


        function Merge(firstNode) {
            this.isElementMerge = (firstNode && firstNode.nodeType == 1);
            this.textNodes = [];
            var firstTextNode = this.isElementMerge ? firstNode.lastChild : firstNode;
            if (firstTextNode) {
                this.textNodes[0] = firstTextNode;
            }
        }

        Merge.prototype = {
            doMerge: function(positionsToPreserve) {
                var textNodes = this.textNodes;
                var firstTextNode = textNodes[0];
                if (textNodes.length > 1) {
                    var firstTextNodeIndex = dom.getNodeIndex(firstTextNode);
                    var textParts = [], combinedTextLength = 0, textNode, parent;
                    forEach(textNodes, function(textNode, i) {
                        parent = textNode.parentNode;
                        if (i > 0) {
                            parent.removeChild(textNode);
                            if (!parent.hasChildNodes()) {
                                dom.removeNode(parent);
                            }
                            if (positionsToPreserve) {
                                forEach(positionsToPreserve, function(position) {
                                    // Handle case where position is inside the text node being merged into a preceding node
                                    if (position.node == textNode) {
                                        position.node = firstTextNode;
                                        position.offset += combinedTextLength;
                                    }
                                    // Handle case where both text nodes precede the position within the same parent node
                                    if (position.node == parent && position.offset > firstTextNodeIndex) {
                                        --position.offset;
                                        if (position.offset == firstTextNodeIndex + 1 && i < len - 1) {
                                            position.node = firstTextNode;
                                            position.offset = combinedTextLength;
                                        }
                                    }
                                });
                            }
                        }
                        textParts[i] = textNode.data;
                        combinedTextLength += textNode.data.length;
                    });
                    firstTextNode.data = textParts.join("");
                }
                return firstTextNode.data;
            },

            getLength: function() {
                var i = this.textNodes.length, len = 0;
                while (i--) {
                    len += this.textNodes[i].length;
                }
                return len;
            },

            toString: function() {
                var textParts = [];
                forEach(this.textNodes, function(textNode, i) {
                    textParts[i] = "'" + textNode.data + "'";
                });
                return "[Merge(" + textParts.join(",") + ")]";
            }
        };

        var optionProperties = ["elementTagName", "ignoreWhiteSpace", "applyToEditableOnly", "useExistingElements",
            "removeEmptyElements", "onElementCreate", "nodeFilter", "elementPostProcessCallback"];


        // TODO: Populate this with every attribute name that corresponds to a property with a different name. Really??
        var attrNamesForProperties = {};

        function ClassApplier(className, options, tagNames) {
            var normalize, i, len, propName, applier = this;
            applier.cssClass = applier.className = className; // cssClass property is for backward compatibility

            var elementPropertiesFromOptions = null, elementAttributes = {};

            // Initialize from options object
            if (typeof options == "object" && options !== null) {
                if (typeof options.elementTagName !== "undefined") {
                    options.elementTagName = options.elementTagName.toLowerCase();
                }
                tagNames = options.tagNames;
                elementPropertiesFromOptions = options.elementProperties;
                elementAttributes = options.elementAttributes;

                for (i = 0; propName = optionProperties[i++]; ) {
                    if (options.hasOwnProperty(propName)) {
                        applier[propName] = options[propName];
                    }
                }
                normalize = options.normalize;
            } else {
                normalize = options;
            }

            // Backward compatibility: the second parameter can also be a Boolean indicating to normalize after unapplying
            applier.normalize = (typeof normalize == "undefined") ? true : normalize;

            // Initialize element properties and attribute exceptions
            applier.attrExceptions = [];
            var el = document.createElement(applier.elementTagName);
            applier.elementProperties = applier.copyPropertiesToElement(elementPropertiesFromOptions, el, true);
            each(elementAttributes, function(attrName, attrValue) {
                applier.attrExceptions.push(attrName);
                // Ensure each attribute value is a string
                elementAttributes[attrName] = "" + attrValue;
            });
            applier.elementAttributes = elementAttributes;

            applier.elementSortedClassName = applier.elementProperties.hasOwnProperty("className") ?
                sortClassName(applier.elementProperties.className + " " + className) : className;

            // Initialize tag names
            applier.applyToAnyTagName = false;
            var type = typeof tagNames;
            if (type == "string") {
                if (tagNames == "*") {
                    applier.applyToAnyTagName = true;
                } else {
                    applier.tagNames = trim(tagNames.toLowerCase()).split(/\s*,\s*/);
                }
            } else if (type == "object" && typeof tagNames.length == "number") {
                applier.tagNames = [];
                for (i = 0, len = tagNames.length; i < len; ++i) {
                    if (tagNames[i] == "*") {
                        applier.applyToAnyTagName = true;
                    } else {
                        applier.tagNames.push(tagNames[i].toLowerCase());
                    }
                }
            } else {
                applier.tagNames = [applier.elementTagName];
            }
        }

        ClassApplier.prototype = {
            elementTagName: defaultTagName,
            elementProperties: {},
            elementAttributes: {},
            ignoreWhiteSpace: true,
            applyToEditableOnly: false,
            useExistingElements: true,
            removeEmptyElements: true,
            onElementCreate: null,

            copyPropertiesToElement: function(props, el, createCopy) {
                var s, elStyle, elProps = {}, elPropsStyle, propValue, elPropValue, attrName;

                for (var p in props) {
                    if (props.hasOwnProperty(p)) {
                        propValue = props[p];
                        elPropValue = el[p];

                        // Special case for class. The copied properties object has the applier's class as well as its own
                        // to simplify checks when removing styling elements
                        if (p == "className") {
                            addClass(el, propValue);
                            addClass(el, this.className);
                            el[p] = sortClassName(el[p]);
                            if (createCopy) {
                                elProps[p] = propValue;
                            }
                        }

                        // Special case for style
                        else if (p == "style") {
                            elStyle = elPropValue;
                            if (createCopy) {
                                elProps[p] = elPropsStyle = {};
                            }
                            for (s in props[p]) {
                                if (props[p].hasOwnProperty(s)) {
                                    elStyle[s] = propValue[s];
                                    if (createCopy) {
                                        elPropsStyle[s] = elStyle[s];
                                    }
                                }
                            }
                            this.attrExceptions.push(p);
                        } else {
                            el[p] = propValue;
                            // Copy the property back from the dummy element so that later comparisons to check whether
                            // elements may be removed are checking against the right value. For example, the href property
                            // of an element returns a fully qualified URL even if it was previously assigned a relative
                            // URL.
                            if (createCopy) {
                                elProps[p] = el[p];

                                // Not all properties map to identically-named attributes
                                attrName = attrNamesForProperties.hasOwnProperty(p) ? attrNamesForProperties[p] : p;
                                this.attrExceptions.push(attrName);
                            }
                        }
                    }
                }

                return createCopy ? elProps : "";
            },

            copyAttributesToElement: function(attrs, el) {
                for (var attrName in attrs) {
                    if (attrs.hasOwnProperty(attrName) && !/^class(?:Name)?$/i.test(attrName)) {
                        el.setAttribute(attrName, attrs[attrName]);
                    }
                }
            },

            appliesToElement: function(el) {
                return contains(this.tagNames, el.tagName.toLowerCase());
            },

            getEmptyElements: function(range) {
                var applier = this;
                return range.getNodes([1], function(el) {
                    return applier.appliesToElement(el) && !el.hasChildNodes();
                });
            },

            getNonTextElements: function(range) {
                var applier = this;
                return range.getNodes([1], function (el) {
                    return /img|svg|iframe|audio|video/i.test(el.tagName.toLowerCase());
                });
            },

            hasClass: function(node) {
                return node && node.nodeType == 1 &&
                    (this.applyToAnyTagName || this.appliesToElement(node)) &&
                    hasClass(node, this.className);
            },

            getSelfOrAncestorWithClass: function(node) {
                while (node) {
                    if (this.hasClass(node)) {
                        return node;
                    }
                    node = node.parentNode;
                }
                return null;
            },

            isModifiable: function(node) {
                return !this.applyToEditableOnly || isEditable(node);
            },

            // White space adjacent to an unwrappable node can be ignored for wrapping
            isIgnorableWhiteSpaceNode: function(node) {
                return this.ignoreWhiteSpace && node && node.nodeType == 3 && isUnrenderedWhiteSpaceNode(node);
            },

            // Normalizes nodes after applying a class to a Range.
            postApply: function(textNodes, range, positionsToPreserve, isUndo) {
                var firstNode = textNodes[0], lastNode = textNodes[textNodes.length - 1];

                var merges = [], currentMerge;

                var rangeStartNode = firstNode, rangeEndNode = lastNode;
                var rangeStartOffset = 0, rangeEndOffset = lastNode.length;

                var textNode, precedingTextNode;

                // Check for every required merge and create a Merge object for each
                forEach(textNodes, function(textNode) {
                    precedingTextNode = getPreviousMergeableTextNode(textNode, !isUndo);
                    if (precedingTextNode) {
                        if (!currentMerge) {
                            currentMerge = new Merge(precedingTextNode);
                            merges.push(currentMerge);
                        }
                        currentMerge.textNodes.push(textNode);
                        if (textNode === firstNode) {
                            rangeStartNode = currentMerge.textNodes[0];
                            rangeStartOffset = rangeStartNode.length;
                        }
                        if (textNode === lastNode) {
                            rangeEndNode = currentMerge.textNodes[0];
                            rangeEndOffset = currentMerge.getLength();
                        }
                    } else {
                        currentMerge = null;
                    }
                });

                // Test whether the first node after the range needs merging
                var nextTextNode = getNextMergeableTextNode(lastNode, !isUndo);

                if (nextTextNode) {
                    if (!currentMerge) {
                        currentMerge = new Merge(lastNode);
                        merges.push(currentMerge);
                    }
                    currentMerge.textNodes.push(nextTextNode);
                }

                // Apply the merges
                if (merges.length) {
                    for (i = 0, len = merges.length; i < len; ++i) {
                        merges[i].doMerge(positionsToPreserve);
                    }

                    // Set the range boundaries
                    range.setStartAndEnd(rangeStartNode, rangeStartOffset, rangeEndNode, rangeEndOffset);
                }
            },

            createContainer: function(parentNode) {
                var doc = dom.getDocument(parentNode);
                var namespace;
                var el = createElementNSSupported && !dom.isHtmlNamespace(parentNode) && (namespace = parentNode.namespaceURI) ?
                    doc.createElementNS(parentNode.namespaceURI, this.elementTagName) :
                    doc.createElement(this.elementTagName);

                this.copyPropertiesToElement(this.elementProperties, el, false);
                this.copyAttributesToElement(this.elementAttributes, el);
                addClass(el, this.className);
                if (this.onElementCreate) {
                    this.onElementCreate(el, this);
                }
                return el;
            },

            elementHasProperties: function(el, props) {
                var applier = this;
                return each(props, function(p, propValue) {
                    if (p == "className") {
                        // For checking whether we should reuse an existing element, we just want to check that the element
                        // has all the classes specified in the className property. When deciding whether the element is
                        // removable when unapplying a class, there is separate special handling to check whether the
                        // element has extra classes so the same simple check will do.
                        return hasAllClasses(el, propValue);
                    } else if (typeof propValue == "object") {
                        if (!applier.elementHasProperties(el[p], propValue)) {
                            return false;
                        }
                    } else if (el[p] !== propValue) {
                        return false;
                    }
                });
            },

            elementHasAttributes: function(el, attrs) {
                return each(attrs, function(name, value) {
                    if (el.getAttribute(name) !== value) {
                        return false;
                    }
                });
            },

            applyToTextNode: function(textNode, positionsToPreserve, indexPosition, lastNodePosition) {

                // Check whether the text node can be styled. Text within a <style> or <script> element, for example,
                // should not be styled. See issue 283.
                if (canTextBeStyled(textNode)) {
                    var parent = textNode.parentNode;

                    if (parent.childNodes.length == 1 &&
                        this.useExistingElements &&
                        this.appliesToElement(parent) &&
                        this.elementHasProperties(parent, this.elementProperties) &&
                        this.elementHasAttributes(parent, this.elementAttributes)) {

                        addClass(parent, this.className);
                    } else {
                        var textNodeParent = textNode.parentNode;
                        parent = this.createContainer(textNodeParent);
                        textNodeParent.insertBefore(parent, textNode);
                        parent.appendChild(textNode);

                    }

                    if (this.elementPostProcessCallback) {
                        this.elementPostProcessCallback(parent, indexPosition, lastNodePosition);
                    }
                }

            },

            isRemovable: function(el) {
                return el.tagName.toLowerCase() == this.elementTagName &&
                    getSortedClassName(el) == this.elementSortedClassName &&
                    this.elementHasProperties(el, this.elementProperties) &&
                    !elementHasNonClassAttributes(el, this.attrExceptions) &&
                    this.elementHasAttributes(el, this.elementAttributes) &&
                    this.isModifiable(el);
            },

            isEmptyContainer: function(el) {
                var childNodeCount = el.childNodes.length;
                return el && el.nodeType == 1 &&
                    this.isRemovable(el) &&
                    (childNodeCount == 0 || (childNodeCount == 1 && this.isEmptyContainer(el.firstChild)));
            },

            removeEmptyContainers: function(range) {
                var applier = this;
                var nodesToRemove = range.getNodes([1], function(el) {
                    return applier.isEmptyContainer(el);
                });

                var rangesToPreserve = [range];
                var positionsToPreserve = getRangeBoundaries(rangesToPreserve);

                forEach(nodesToRemove, function(node) {
                    removePreservingPositions(node, positionsToPreserve);
                });

                // Update the range from the preserved boundary positions
                updateRangesFromBoundaries(rangesToPreserve, positionsToPreserve);
            },

            undoToTextNode: function(textNode, range, ancestorWithClass, positionsToPreserve) {
                if (!range.containsNode(ancestorWithClass)) {
                    // Split out the portion of the ancestor from which we can remove the class
                    //var parent = ancestorWithClass.parentNode, index = dom.getNodeIndex(ancestorWithClass);
                    var ancestorRange = range.cloneRange();
                    ancestorRange.selectNode(ancestorWithClass);
                    if (ancestorRange.isPointInRange(range.endContainer, range.endOffset)) {
                        splitNodeAt(ancestorWithClass, range.endContainer, range.endOffset, positionsToPreserve);
                        range.setEndAfter(ancestorWithClass);
                    }
                    if (ancestorRange.isPointInRange(range.startContainer, range.startOffset)) {
                        ancestorWithClass = splitNodeAt(ancestorWithClass, range.startContainer, range.startOffset, positionsToPreserve);
                    }
                }

                if (this.isRemovable(ancestorWithClass)) {
                    replaceWithOwnChildrenPreservingPositions(ancestorWithClass, positionsToPreserve);
                } else {
                    removeClass(ancestorWithClass, this.className);
                }
            },

            splitAncestorWithClass: function(container, offset, positionsToPreserve) {
                var ancestorWithClass = this.getSelfOrAncestorWithClass(container);
                if (ancestorWithClass) {
                    splitNodeAt(ancestorWithClass, container, offset, positionsToPreserve);
                }
            },

            undoToAncestor: function(ancestorWithClass, positionsToPreserve) {
                if (this.isRemovable(ancestorWithClass)) {
                    replaceWithOwnChildrenPreservingPositions(ancestorWithClass, positionsToPreserve);
                } else {
                    removeClass(ancestorWithClass, this.className);
                }
            },

            applyToRange: function(range, rangesToPreserve, nonTextFlag) {
                var applier = this;
                rangesToPreserve = rangesToPreserve || [];

                // Create an array of range boundaries to preserve
                var positionsToPreserve = getRangeBoundaries(rangesToPreserve || []);

                range.splitBoundariesPreservingPositions(positionsToPreserve);

                if (nonTextFlag) {
                    var nonTextElements = applier.getNonTextElements(range);
                    forEach(nonTextElements, function(el) {
                        addClass(el, applier.className);
                    });
                }

                // Tidy up the DOM by removing empty containers
                if (applier.removeEmptyElements) {
                    applier.removeEmptyContainers(range);
                }

                var textNodes = getEffectiveTextNodes(range, applier.nodeFilter);

                if (textNodes.length) {
                    var lastNodePosition = textNodes.length - 1;
                    forEach(textNodes, function(textNode, i) {
                        if (!applier.isIgnorableWhiteSpaceNode(textNode) && !applier.getSelfOrAncestorWithClass(textNode) &&
                                applier.isModifiable(textNode)) {
                            applier.applyToTextNode(textNode, positionsToPreserve, i, lastNodePosition);
                        }
                    });
                    var lastTextNode = textNodes[textNodes.length - 1];
                    range.setStartAndEnd(textNodes[0], 0, lastTextNode, lastTextNode.length);
                    if (applier.normalize) {
                        applier.postApply(textNodes, range, positionsToPreserve, false);
                    }

                    // Update the ranges from the preserved boundary positions
                    updateRangesFromBoundaries(rangesToPreserve, positionsToPreserve);
                }

                // Apply classes to any appropriate empty elements
                var emptyElements = applier.getEmptyElements(range);

                forEach(emptyElements, function(el) {
                    addClass(el, applier.className);
                });
            },

            applyToRanges: function(ranges) {

                var i = ranges.length;
                while (i--) {
                    this.applyToRange(ranges[i], ranges);
                }


                return ranges;
            },

            applyToSelection: function(win) {
                var sel = api.getSelection(win);
                sel.setRanges( this.applyToRanges(sel.getAllRanges()) );
            },

            undoToRange: function(range, rangesToPreserve) {
                var applier = this;
                // Create an array of range boundaries to preserve
                rangesToPreserve = rangesToPreserve || [];
                var positionsToPreserve = getRangeBoundaries(rangesToPreserve);


                range.splitBoundariesPreservingPositions(positionsToPreserve);

                // Tidy up the DOM by removing empty containers
                if (applier.removeEmptyElements) {
                    applier.removeEmptyContainers(range, positionsToPreserve);
                }

                var textNodes = getEffectiveTextNodes(range, applier.nodeFilter);
                var textNode, ancestorWithClass;
                var lastTextNode = textNodes[textNodes.length - 1];

                if (textNodes.length) {
                    applier.splitAncestorWithClass(range.endContainer, range.endOffset, positionsToPreserve);
                    applier.splitAncestorWithClass(range.startContainer, range.startOffset, positionsToPreserve);
                    for (var i = 0, len = textNodes.length; i < len; ++i) {
                        textNode = textNodes[i];
                        ancestorWithClass = applier.getSelfOrAncestorWithClass(textNode);
                        if (ancestorWithClass && applier.isModifiable(textNode)) {
                            applier.undoToAncestor(ancestorWithClass, positionsToPreserve);
                        }
                    }
                    // Ensure the range is still valid
                    range.setStartAndEnd(textNodes[0], 0, lastTextNode, lastTextNode.length);


                    if (applier.normalize) {
                        applier.postApply(textNodes, range, positionsToPreserve, true);
                    }

                    // Update the ranges from the preserved boundary positions
                    updateRangesFromBoundaries(rangesToPreserve, positionsToPreserve);
                }

                // Remove class from any appropriate empty elements
                var emptyElements = applier.getEmptyElements(range);

                forEach(emptyElements, function(el) {
                    removeClass(el, applier.className);
                });
            },

            undoToRanges: function(ranges) {
                // Get ranges returned in document order
                var i = ranges.length;

                while (i--) {
                    this.undoToRange(ranges[i], ranges);
                }

                return ranges;
            },

            undoToSelection: function(win) {
                var sel = api.getSelection(win);
                var ranges = api.getSelection(win).getAllRanges();
                this.undoToRanges(ranges);
                sel.setRanges(ranges);
            },

            isAppliedToRange: function(range) {
                if (range.collapsed || range.toString() == "") {
                    return !!this.getSelfOrAncestorWithClass(range.commonAncestorContainer);
                } else {
                    var textNodes = range.getNodes( [3] );
                    if (textNodes.length)
                    for (var i = 0, textNode; textNode = textNodes[i++]; ) {
                        if (!this.isIgnorableWhiteSpaceNode(textNode) && rangeSelectsAnyText(range, textNode) &&
                                this.isModifiable(textNode) && !this.getSelfOrAncestorWithClass(textNode)) {
                            return false;
                        }
                    }
                    return true;
                }
            },

            isAppliedToRanges: function(ranges) {
                var i = ranges.length;
                if (i == 0) {
                    return false;
                }
                while (i--) {
                    if (!this.isAppliedToRange(ranges[i])) {
                        return false;
                    }
                }
                return true;
            },

            isAppliedToSelection: function(win) {
                var sel = api.getSelection(win);
                return this.isAppliedToRanges(sel.getAllRanges());
            },

            toggleRange: function(range) {
                if (this.isAppliedToRange(range)) {
                    this.undoToRange(range);
                } else {
                    this.applyToRange(range);
                }
            },

            toggleSelection: function(win) {
                if (this.isAppliedToSelection(win)) {
                    this.undoToSelection(win);
                } else {
                    this.applyToSelection(win);
                }
            },

            getElementsWithClassIntersectingRange: function(range) {
                var elements = [];
                var applier = this;
                range.getNodes([3], function(textNode) {
                    var el = applier.getSelfOrAncestorWithClass(textNode);
                    if (el && !contains(elements, el)) {
                        elements.push(el);
                    }
                });
                return elements;
            },

            detach: function() {}
        };

        function createClassApplier(className, options, tagNames) {
            return new ClassApplier(className, options, tagNames);
        }

        ClassApplier.util = {
            hasClass: hasClass,
            addClass: addClass,
            removeClass: removeClass,
            getClass: getClass,
            hasSameClasses: haveSameClasses,
            hasAllClasses: hasAllClasses,
            replaceWithOwnChildren: replaceWithOwnChildrenPreservingPositions,
            elementsHaveSameNonClassAttributes: elementsHaveSameNonClassAttributes,
            elementHasNonClassAttributes: elementHasNonClassAttributes,
            splitNodeAt: splitNodeAt,
            isEditableElement: isEditableElement,
            isEditingHost: isEditingHost,
            isEditable: isEditable
        };

        api.CssClassApplier = api.ClassApplier = ClassApplier;
        api.createClassApplier = createClassApplier;
        util.createAliasForDeprecatedMethod(api, "createCssClassApplier", "createClassApplier", module);
    });

    return rangy;
}, this);



(function() {

    window.ePubAnnotation = {
        // auto increments on version bump
        version: '10.6.0'
    };

})();



(function(api, rangy) {
    api.utils = {
        isTextNode: isTextNode,
        isElementNode: isElementNode,
        containingElement: containingElement,
        getActiveSelection: getActiveSelection,
        clearSelection: clearSelection,
        hasClass: hasClass,
        firstNonIgnorableParent: firstNonIgnorableParent,
        isIgnorable: isIgnorable,
        isSkippable: isSkippable,
        detectIE: detectIE,
        /**
         * ignorableClassName should be added to any elements that clients add to the dom that wrap
         * existing content.  Annotation cfi string will be generated walking the children of the ignorable
         * element as if it were not added to the content.
         */
        ignorableClassName: 'mhe-annotations-ignorable',
        /**
         * skippableClassName should be added to any elements that clients inserts into the dom when we want the
         * element and all its children to be skipped as if it were never added to the dom.
         */
        skippableClassName: 'mhe-annotations-skippable',
    };

    function hasClass(element, cls) {
        return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    }

    /**
     *
     * @param {Node} node
     * @param {boolean} filterBlanks
     */
    function isTextNode(node, filterBlanks) {
        var isText = node && node.nodeType === Node.TEXT_NODE;

        if (isText && filterBlanks) {
            var text = node.nodeValue;
            text = text && text.replace(/[\u0020\t]{2,}/g, '\u0020')
                               .replace(/(\u0020*\n\u0020*)+/g, '\u0020');

            if ((text === '\u0020') || (text === '')) {
                return false;
            }


        }

        return isText;
    }

    function isElementNode(node) {
        return node && node.nodeType === Node.ELEMENT_NODE;
    }

    function isIgnorable(node) {
        if (api.Highlighter &&
            api.Highlighter.globalBaseClass &&
            isElementNode(node) &&
            node.tagName.toUpperCase() === 'MARK' &&
            hasClass(node, api.Highlighter.globalBaseClass)) {
            return true;
        }

        if (hasClass(node, api.ttsClasses.utteranceIgnorableClass)) {
            return true;
        }

        if (hasClass(node, api.utils.ignorableClassName)) {
            return true;
        }

        return false;
    }

    function isSkippable(node) {

        //Only text or element nodes are to be considered
        //per http://www.idpf.org/epub/linking/cfi/epub-cfi.html#sec-path-child-ref
        if (!(isTextNode(node) || isElementNode(node))) {
            return true;
        }

        if (!node.tagName ||
            !(node.tagName.toUpperCase() === 'SPAN' ||
            node.tagName.toUpperCase() === 'DIV')) {
                //shortcut - this is not a skippable node if its not a span or div
                return false;
        }

        //Is this the MathJax Message node?
        if (node.id === 'MathJax_Message') {
            return true;
        }

        if (hasClass(node, api.utils.skippableClassName)) {
            return true;
        }

        //Does this have one of the MathJax classes to skip?
        var ignore = false;
        var kMathJaxClassesToSkip = [
            'MathJax_Preview',
            'MathJax_SVG_Display',
            'MathJax_SVG'
        ];

        kMathJaxClassesToSkip.forEach(function(aClass) {
            if (hasClass(node, aClass)) {
                ignore = true;
            }
        });

        if (ignore) {
            return true;
        }

        //Finally, is this the div with a 'MathJax_SVG_Hidden' child
        if (node.tagName.toUpperCase() === 'DIV') {
            for (var i = 0; i < node.childNodes.length; i++) {
                if (node.childNodes[i].id === 'MathJax_SVG_Hidden') {
                    return true;
                }
            }
        }

        return false;
    }

    //Returns the first ancestor of the given element that is not ignorable
    //(or the element itself if it is not ignorable)
    function firstNonIgnorableParent(elem) {
        var element = elem;
        while (element && isIgnorable(element)) {
            element = element.parentElement;
        }

        return element;
    }

    //Private utility for getting the nearest element node for a given node,
    //or the node itself, if it is an Element node
    function containingElement(node) {
        var el = node;
        while (el && el.nodeType !== 1) {
            el = el.parentNode;
        }

        return el;
    }

    function getActiveSelection(doc) {
        return rangy.getSelection(doc);
    }

    function clearSelection(doc) {
        var selection = getActiveSelection(doc);
        if (selection) {
            selection.removeAllRanges();
        }
    }

    function detectIE() {
        var ua = window.navigator.userAgent;
        if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident/') > -1) {
            return true;
        }
        return false;
    }

})(window.ePubAnnotation, window.rangy);



(function(api, utils) {
    function returnFalse() { return false; }

    function NodeTraversal(isIgnorableCallback, isSkippableCallback) {

        this.isIgnorable = isIgnorableCallback || returnFalse;
        this.isSkippable = isSkippableCallback || returnFalse;
    }

    NodeTraversal.prototype.getFirstChildNode = function(node) {
        node = node.firstChild;

        if (node && this.isIgnorable(node)) {
            return this.getFirstChildNode(node);
        }

        if (node && this.isSkippable(node)) {
            return this.getNextNodeSibling(node);
        }

        return node;
    };

    NodeTraversal.prototype.getLastChildNode = function(node) {
        node = node.lastChild;

        if (node && this.isIgnorable(node)) {
            return this.getLastChildNode(node);
        }

        if (node && this.isSkippable(node)) {
            return this.getPrevNodeSibling(node);
        }

        return node;
    };

    NodeTraversal.prototype.getParentNode = function(node) {
        while (node && node.parentNode) {
            node = node.parentNode;
            if (!this.isIgnorable(node)) {
                return node;
            }
        }
    };

    NodeTraversal.prototype.getNextNodeSibling = function(node, suppressStitching) {
        var parent;
        var isText = node && utils.isTextNode(node);
        var stitchTextNodes = !suppressStitching;
        var shouldStitch = false;

        while (node) {
            //Ugly - capture parent before advancing to a potentially null sibling
            parent = node.parentNode;
            node = node.nextSibling;

            if (node && this.isIgnorable(node)) {
                //If sibling is ignorable, step into it
                node = this.getFirstChildNode(node);

                if (node) {
                    //Set parent to the ignorable
                    parent = node.parentNode;
                    shouldStitch = true;
                }
            }

            if (node && this.isSkippable(node)) {
                //If sibling is skippable, step over it
                node = this.getNextNodeSibling(node);

                if (node) {
                    //Set parent to the ignorable
                    parent = node.parentNode;
                    shouldStitch = true;
                }

            }

            if (node) {
                if (stitchTextNodes && shouldStitch && isText && utils.isTextNode(node)) {
                    shouldStitch = false;
                    continue;
                }

                return node;
            }

            if (!node && parent && this.isIgnorable(parent)) {
                //If out of siblings, but our parent is ignorable,
                //start walking the parent's siblings
                node = parent;
                shouldStitch = true;
            }
        }
    };

    ///if suppressStitching is true, we return every text node, even it it was
    ///broken by an ignorable
    ///
    NodeTraversal.prototype.getPrevNodeSibling = function(node, suppressStitching) {
        var parent;
        var isText = utils.isTextNode(node);
        var stitchTextNodes = !suppressStitching;
        var shouldStitch = false;

        while (node) {
            //Ugly - capture parent before advancing to a potentially null sibling
            parent = node.parentNode;
            node = node.previousSibling;

            if (node && this.isIgnorable(node)) {
                //If sibling is ignorable, step into it
                node = this.getLastChildNode(node);

                if (node) {
                    //Set parent to the ignorable
                    parent = node.parentNode;
                    shouldStitch = true;
                }
            }

            if (node && this.isSkippable(node)) {
                //If sibling is ignorable, step over it
                node = this.getPrevNodeSibling(node);

                if (node) {
                    //Set parent to the ignorable
                    parent = node.parentNode;
                    shouldStitch = true;
                }
            }

            if (node) {
                if (stitchTextNodes && shouldStitch && isText && utils.isTextNode(node)) {
                    shouldStitch = false;
                    continue;
                }

                return node;
            }

            if (!node && parent && this.isIgnorable(parent)) {
                //If out of siblings, but our parent is ignorable,
                //start walking the parent's siblings
                node = parent;
                shouldStitch = true;
            }
        }
    };

    NodeTraversal.prototype.getNextElementSibling = function(node) {
        node = this.getNextNodeSibling(node);

        while (node && !utils.isElementNode(node)) {
            node = this.getNextNodeSibling(node);
        }

        return node;
    };

    NodeTraversal.prototype.getPrevElementSibling = function(node) {
        node = this.getPrevNodeSibling(node);

        while (node && !utils.isElementNode(node)) {
            node = this.getPrevNodeSibling(node);
        }

        return node;
    };

    NodeTraversal.prototype.getNextTextNodeSibling = function(node, suppressStitching) {
        node = this.getNextNodeSibling(node, suppressStitching);

        while (node && !utils.isTextNode(node)) {
            node = this.getNextNodeSibling(node, suppressStitching);
        }
        return node;
    };

    //Not used or needed by any clients at this time
    // NodeTraversal.prototype.getPrevTextNodeSibling = function(node, suppressStitching) {
    //     node = this.getPrevNodeSibling(node, suppressStitching);
    //
    //     while (node && !utils.isTextNode(node)) {
    //         node = this.getPrevNodeSibling(node, suppressStitching);
    //     }
    //     return node;
    // };


    NodeTraversal.prototype.getFirstChildElement = function(node) {
        node = this.getFirstChildNode(node);

        while (node) {
            if (utils.isElementNode(node)) {
                return node;
            }

            node = this.getNextNodeSibling(node);
        }
    };

    NodeTraversal.prototype.firstChildIsElement = function(node) {
        node = this.getFirstChildNode(node);
        if (node) {
            return utils.isElementNode(node);
        }

        return false;
    };

    NodeTraversal.prototype.nextSiblingIsElement = function(node) {
        node = this.getNextNodeSibling(node);

        if (node) {
            return utils.isElementNode(node);
        }

        return false;
    };

    api.NodeTraversal = NodeTraversal;

})(window.ePubAnnotation, window.ePubAnnotation.utils);



(function(api, NodeTraversal, utils) {

    // //DEBUG LOGGING UTILS
    // function debug(node) {
    //     if (!node) {
    //         return '_NULL_';
    //     }
    //
    //     if (utils.isTextNode(node)) {
    //         return '<#text:' + node.textContent + '>';
    //     } else {
    //         return '<' + node.tagName + '>';
    //     }
    // }
    // function debugLog(node) {
    //     console.log(debug(node));
    // }    //

    api.cfi = {
        generateBasePath: generateBasePath,

        lastParentIdFromCFIString: lastParentIdFromCFIString,
        spineIndexFromCFIString: spineIndexFromCFIString,
        spineIdFromCFIString: spineIdFromCFIString,

        cfiStringFromSpineIndex: cfiStringFromSpineIndex,
        cfiStringFromNode: cfiStringFromNode,

        cfiStringFromRange: cfiStringFromRange,
        rangeFromCFIString: rangeFromCFIString,

        //Legacy implementations will be added here
        legacy: {},

        getVersion: getVersion,

    };

    var versionErrorMessage = 'Unknown legacy annotation lib version requested:';

    //Add a method to check whether an error was a Legacy Version Error,
    //which is more severe than other errors
    api.isLegacyVersionError = function(e) {
        return e.message && e.message.indexOf(versionErrorMessage) !== -1;
    };

    //Utility for returning the right API based on optionalLegacyVersion
    //if optionalLegacyVersion is undefined, it returns the modern one
    function getVersion(optionalLegacyVersion) {
        if (!optionalLegacyVersion) {
            //Default to the latest version
            return api.cfi;
        }

        var requestedVersion = api.cfi.legacy[optionalLegacyVersion];

        if (!requestedVersion) {
            throw new Error(versionErrorMessage + optionalLegacyVersion);
        }
        return requestedVersion;
    }

    var nt = new NodeTraversal(utils.isIgnorable, utils.isSkippable);

    //Vocabulary:
    // epubcfi(     Wrapper Prefix
    // )            Wrapper Suffix
    // epubcfi(XXX!YYY)  XXX = basePath, YYY = pagePath

    //Assumes wrapper has been removed
    function withBasePathRemoved(cfiString) {
        return cfiString.split('!')[1];
    }

    function withBasePathAdded(pagePath, base) {
        return base + '!' + pagePath;
    }

    function withSyntaxWrapperAdded(cfiString) {
        return 'epubcfi(' + cfiString + ')';
    }

    function withSyntaxWrapperRemoved(cfiString) {
        if(cfiString.indexOf('epubcfi(') === 0 && cfiString[cfiString.length-1] === ')') {
          // Remove intial epubcfi( and ending )
          return cfiString.slice(8, cfiString.length-1);
        }

        return cfiString;
    }

    //consumes the passed in element step
    //startingElement represents the parent node that the step refers to
    //Return value is the child element that the step specifies
    //NULL return represents an invalid step
    function walkElementStep(step, startingElement, doc) {
        var nodeIter = nt.getFirstChildElement(startingElement);
        var count = step.index - 2;

        while (nodeIter && (count > 0)) {
            nodeIter = nt.getNextElementSibling(nodeIter);
            count = count - 2;
        }

        return nodeIter;
    }

    //consumes the passed in text step
    //startingElement represents the parent node that the step refers to
    //Return value is the child text node that the step specifies (unless there is
    //no text node at that position - see note)
    //
    //NOTE: If steps lead to a non-existing text node (legal in Cfi spec),
    //then return either the next element sibling, or the prev element sibling,
    // or the parent element. (in that order)   In this case, it is an element,
    // not a text node that is returned.
    function walkTextStep(step, startingElement, doc) {
        var nodeIter = startingElement;
        var count = step.index - 1;

        if (count === 0) {
            if (nt.firstChildIsElement(nodeIter)) {
                //There is no text node at this position
                //return the first child element itself
                return nt.getFirstChildElement(nodeIter);
            } else {
                //We've found the first child
                return nt.getFirstChildNode(nodeIter);
            }
        }

        //Here, we need to walk the children
        if (nt.firstChildIsElement(nodeIter)) {
            //There is no text node as the first child
            //go to the next one and decrease count
            count = count - 2;
            nodeIter = nt.getFirstChildElement(nodeIter);
        } else {
            //move nodeIter to the first (text) node prior to beginning the loop
            nodeIter = nt.getFirstChildNode(nodeIter);
        }

        //Now walk the element siblings
        while (nodeIter && count > 0) {
            nodeIter = nt.getNextElementSibling(nodeIter);
            count = count - 2;
        }

        //Here we're pointing to the element just before the desired text
        //element, unless there is no text element
        if (nt.nextSiblingIsElement(nodeIter)) {
            //There is no text element
            return nt.getNextElementSibling(nodeIter);
        } else {
            //Return the next text sibling following nodeIter
            //This might also return NULL if nodeIter is the final element in
            //the children, in which case we return either the previous sibling
            //or the parent
            return nt.getNextTextNodeSibling(nodeIter) ||
                nt.getPrevElementSibling(nodeIter) ||
                nt.getParentNode(nodeIter);
        }
    }

    //Returns the node arrived at after following the steps
    //NOTE: Node may be null if the steps point to a text position that
    //does not contain a text node
    function nodeFromSteps(steps, startingElement, doc) {
        var count, step;
        var stepsCopy = [];
        var nodeIter = startingElement || doc.getElementsByTagName('html')[0];

        // Playback starts at the last id'd element (EPR-1621)
        for (var i = steps.length - 1; i >= 0; i--) {
            step = steps[i];
            if (step.id) {
                nodeIter = doc.getElementById(step.id);
                break;
            }
            stepsCopy.unshift(step);
        }

        while (stepsCopy.length > 0) {
            if (!nodeIter) {
                throw new Error('Bad CFI Path');
            }

            step = stepsCopy.shift();

            if (step.type === 'element') {
                nodeIter = walkElementStep(step, nodeIter, doc);
            } else if (step.type === 'text') {
                nodeIter = walkTextStep(step, nodeIter, doc);
            }
        }

        return nodeIter;
    }

    function stepsFromPathString(string) {

        /*
        * Regex: starts from "/", ends before ":" (offset) or next "/", e.g.
        * "/4/4[data-uuid-56e363d0138444b8bc4c6bbe96e5e5f7]/1:23" =>
        * ["/4", "/4[data-uuid-56e363d0138444b8bc4c6bbe96e5e5f7]", "/1"]
        * should work with test location assertions, e.g. "/4/4/1:23[once, more]"
        */
        var pathSteps = string.match(/(\/[^:\/]+)/g);
        if (!pathSteps) {
            return [];
        }

        var steps = pathSteps.map(function(step) {

            var index = parseInt(step.substring(1), 10);
            var idMatch = step.match(/\[(.+)\]/);

            return {
                type: (index % 2 === 0) ? 'element' : 'text',
                id: idMatch && idMatch[1],
                index: index
            };

        });

        return steps;
    }

    function charOffsetFromPathString(string) {
        return parseInt(string.split(':')[1]);
    }

    /**
     * Position is a discrete position in a page.  A CFI may be made up of one
     * Position instance, or two (if it describes a range with a start and and end)
     * Position can either be instantiated with a node and offset, or PATH_STRING
     * part of a CFI: epubcfi({DOC_STRING}!{PATH_STRING})
     *
     * @param {[type]} item   [description]
     * @param {[type]} offset [description]
     */
    function Position(item, offset) {
        this.path = [];
        this.charOffset = 0;

        if (item && item.nodeName) {  //TODO - better way to sniff for node?
            var node = item;

            node = this._consumeCharCount(node, offset);

            node = this._consumeTextPath(node);
            this._consumeElementPath(node);

        } else if (typeof item === 'string') {
            this.path = stepsFromPathString(item);
            this.charOffset = charOffsetFromPathString(item);
        }

    }


    ///////
    // The following 3 methods are private instantiation helpers

    //Assume node here is a text node.  Returns the text node (or, if text nodes were
    //elided, the earliest one. (furthest left in a l-r set of siblings))
    Position.prototype._consumeCharCount = function(node, startingOffset) {
        var runningOffset = startingOffset || 0;
        var toReturn = node;

        //For element nodes, we count children based on offset
        if (utils.isElementNode(node)) {

            if (startingOffset === undefined) {
                return node;
            }

            node = nt.getFirstChildNode(node);
            if (!node) {
                //if no children, we should just return the parent node
                return toReturn;
            }

            for (var i = 0; i < startingOffset; i++) {
                node = nt.getNextNodeSibling(node);
            }
            this.charOffset = 0;
            return node;
        }

        //For text nodes, we count text offset, which may involve walking into
        //adjacent nodes.
        while (node) {
            //TODO make this look just like the code that plays back the offset
            node = nt.getPrevNodeSibling(node, true);

            if (node && utils.isTextNode(node)) {
                //it's a text node, concat with the current count
                runningOffset += node.length;
                toReturn = node; //record the last known good one
                continue;
            } else {
                break;
            }
        }

        this.charOffset = runningOffset;
        return toReturn;
    };

    //Assume node here is a text node.  Creates the path step to it, returning the
    //parent element
    Position.prototype._consumeTextPath = function(node) {

        //There is no text path
        if (utils.isElementNode(node)) {
            return node;
        }

        var count = 1;
        var lastSibling = node;

        while (node) {
            node = nt.getPrevElementSibling(node);
            if (node) {
                count += 2;
                lastSibling = node;
            }
        }

        this.path.unshift({
            type: 'text',
            index: count
        });

        return nt.getParentNode(lastSibling);
    };

    Position.prototype._consumeElementPath = function(node) {
        var iter, parentIter = node;
        var id;
        var count = 0;
        var keepGoing = true;
        while (parentIter && parentIter.parentNode && parentIter.parentNode.nodeType !== 9) {
            id = parentIter.id;
            count = 2;
            iter = parentIter;

            //Do one step:
            while (iter) {
                iter = nt.getPrevNodeSibling(iter);

                if (iter && utils.isElementNode(iter)) {
                    count += 2;
                }
            }

            this.path.unshift({
                type: 'element',
                id: id,
                index: count
            });

            parentIter = nt.getParentNode(parentIter);
        }

    };

    Position.prototype.createCFISuffix = function() {
        var path = pathStringFromSteps(this.path);

        //If there's no path at all, we assume we want to add a text offset.
        //If there is a path, we only add a text offset if the last step is a text node
        if ((this.path.length === 0) ||
            (this.path[this.path.length-1].type === 'text')) {
            path += ':' + this.charOffset;
        }

        //TODO: Better way to factor this?  It's possible to get Mathjax-added
        //ids in our assertion text.  We don't want that.  This regex removes any
        //assertion ids that begin with 'MathJax'
        return path.replace(/\[MathJax[^\]]*\]/,'');
    };

    Position.prototype.createCFIString = function(basePath) {
        var str = this.createCFISuffix();

        str = withBasePathAdded(str, basePath);

        return withSyntaxWrapperAdded(str);
    };

    //Returns the node that this Position is in.
    //guaranteed to either return a node or throw.  Clients can be assured of non-null return
    //
    //If the position refers to a non-existing text node, the node returned is
    //an element node 'near' the given positon: It returns either the next element
    //sibling, or the prev element sibling, or the parent element. (in that order)
    Position.prototype.getNode = function(doc) {
        return nodeFromSteps(this.path, null, doc);
    };

    //Sets the passed in range start position to this Position
    Position.prototype.setRangeStart = function(range, doc) {
        var offset = this.charOffset;
        var node = this.getNode(doc);

        if (utils.isTextNode(node)) {
            while (node && (offset > node.length)) {
                offset -= node.length;
                node = nt.getNextTextNodeSibling(node, true);
            }
        }

        range.setStart(node, offset);
    };

    //Sets the passed in range end position to this Position
    Position.prototype.setRangeEnd = function(range, doc) {
        var offset = this.charOffset;
        var node = this.getNode(doc);

        if (utils.isTextNode(node)) {
            while (node && (offset > node.length)) {
                offset -= node.length;
                node = nt.getNextTextNodeSibling(node, true);
            }
        }

        range.setEnd(node, offset);
    };

    function pathStringFromSteps(steps) {
        return steps
            .map(function(step) {
                var idString = (step.id) ? ('[' + step.id + ']') : '';

                return '/' + step.index + idString;
            }).join('');
    }

    //////// PUBLIC METHODS ////////////

    // Given a range, create a CFI String using the basePath as the content
    // document specifier part.
    function cfiStringFromRange(range, basePath) {
        var start = new Position(range.startContainer, range.startOffset);
        var end = new Position(range.endContainer, range.endOffset);

        var common = [];
        var keepGoing = true;

        while (true) {
            if (start.path.length === 0 || end.path.length === 0) {
                break;
            }

            if (start.path[0].index !== end.path[0].index) {
                break;
            }

            common.push(start.path.shift());
            end.path.shift();
        }

        var str =  [
            pathStringFromSteps(common),
            start.createCFISuffix(),
            end.createCFISuffix()
        ].join(',');

        str = withBasePathAdded(str, basePath);

        return withSyntaxWrapperAdded(str);
    }


    //Given a CFI String, return a range.
    function rangeFromCFIString(cfiString, doc) {
        var curDoc = doc || document;

        cfiString = withSyntaxWrapperRemoved(cfiString);
        cfiString = withBasePathRemoved(cfiString);

        var rangeFragments = cfiString.split(',');
        var range = curDoc.createRange();
        if (rangeFragments.length === 3) {
            var startString = rangeFragments[0] + rangeFragments[1];
            var endString = rangeFragments[0] + rangeFragments[2];

            var startLoc = new Position(startString);
            var endLoc = new Position(endString);

            startLoc.setRangeStart(range, curDoc);
            endLoc.setRangeEnd(range, curDoc);


        } else if (rangeFragments.length === 1) {
            var loc = new Position(rangeFragments[0]);
            loc.setRangeStart(range, curDoc);
            loc.setRangeEnd(range, curDoc);
        }

        return range;
    }

    /**
     * Generates the CFI Base path for a given spine itemId
     *
     * @param  {Number} spineIndex 0-based index of the spine in the content document
     *                             (this is almost always 2)
     * @param  {Number} itemIndex  0-based index of the item in the spine
     * @param  {String} itemId     optional id of the item
     * @return {String}            cfi base path
     */
    function generateBasePath(spineIndex, itemIndex, itemId) {
        // Make sure input is integer
        spineIndex = parseInt(spineIndex);
        itemIndex = parseInt(itemIndex);

        // Add one to spineIndex
        spineIndex = (spineIndex + 1) * 2;

        // Start CFI String
        var ret = ['/', spineIndex, '/', (itemIndex + 1) * 2].join('');

        // Add id if available
        if (itemId) {
            ret = [ret, '[', itemId, ']'].join('');
        }

        // Return CFI String
        return ret;
    }

    function cfiStringFromSpineIndex(itemIndex, itemId) {
        var basePath = generateBasePath(2, itemIndex, itemId);

        return [
            'epubcfi(',
            basePath,
            '!/4/1:0',
            ')'
        ].join('');
    }

    function lastParentIdFromCFIString(cfiString) {
        var regex = /\[([^\]]+)\]/g;
        var pagePath = cfiString.split('!')[1];

        if (!pagePath) {
            return null;
        }

        var ids = pagePath.match(regex);

        if (!(ids && ids.length)) {
            return null;
        }

        var lastId = ids[ids.length-1];

        return regex.exec([lastId])[1];
    }

    function spineIndexFromCFIString(cfiString) {
        cfiString = withSyntaxWrapperRemoved(cfiString);
        var basePath = cfiString.split('!')[0];
        var steps = stepsFromPathString(basePath);

        if (!steps.length) {
            return null;
        }

        return (steps[steps.length-1].index / 2) - 1;
    }

    function spineIdFromCFIString(cfiString) {
        cfiString = withSyntaxWrapperRemoved(cfiString);
        var basePath = cfiString.split('!')[0];
        var steps = stepsFromPathString(basePath);

        if (!steps.length) {
            return null;
        }

        return steps[steps.length-1].id;
    }

    function cfiStringFromNode(node, basePath) {
        //TODO common source with `nodeFromSteps()`
        //Forward to first legal start node
        while (node) {
            if (nt.isIgnorable(node)) {
                node = nt.getFirstChildNode(node);
                continue;
            } else if (nt.isSkippable(node)) {
                node = nt.getNextNodeSibling(node);
                continue;
            } else {
                //This node is good
                break;
            }
        }

        if (!node) {
            throw new Error('cfiStringFromNode failed to find legal starting node');
        }

        var position = new Position(node);

        return position.createCFIString(basePath);
    }


})(
    window.ePubAnnotation,
    window.ePubAnnotation.NodeTraversal,
    window.ePubAnnotation.utils
);



//It is required that this follow the cfi.js during the concatenation step
(function(api, NodeTraversal, utils) {
    api.cfi.legacy.v5 = {
        generateBasePath: generateBasePath,

        lastParentIdFromCFIString: lastParentIdFromCFIString,
        spineIndexFromCFIString: spineIndexFromCFIString,

        cfiStringFromSpineIndex: cfiStringFromSpineIndex,
        cfiStringFromNode: cfiStringFromNode,

        cfiStringFromRange: cfiStringFromRange,
        rangeFromCFIString: rangeFromCFIString
    };

    //Copy in the legacy `utils.isSkippable()`  as it existed in v 5.0.2
    var legacyIsSkippable = function(node) {

        if (!node.tagName ||
            !(node.tagName.toUpperCase() === 'SPAN' ||
            node.tagName.toUpperCase() === 'DIV')) {
                //shortcut - this is not a skippable node if its not a span or div
                return false;
        }

        //Is this the MathJax Message node?
        if (node.id === 'MathJax_Message') {
            return true;
        }

        //Does this have one of the MathJax classes to skip?
        var ignore = false;
        var kMathJaxClassesToSkip = [
            'MathJax_Preview',
            'MathJax_SVG_Display'
        ];

        kMathJaxClassesToSkip.forEach(function(aClass) {
            if (utils.hasClass(node, aClass)) {
                ignore = true;
            }
        });

        if (ignore) {
            return true;
        }

        //Finally, is this the div with a 'MathJax_SVG_Hidden' child
        if (node.tagName.toUpperCase() === 'DIV') {
            for (var i = 0; i < node.childNodes.length; i++) {
                if (node.childNodes[i].id === 'MathJax_SVG_Hidden') {
                    return true;
                }
            }
        }

        return false;

    };

    var nt = new NodeTraversal(utils.isIgnorable, legacyIsSkippable);

    //Vocabulary:
    // epubcfi(     Wrapper Prefix
    // )            Wrapper Suffix
    // epubcfi(XXX!YYY)  XXX = basePath, YYY = pagePath

    //Assumes wrapper has been removed
    function withBasePathRemoved(cfiString) {
        return cfiString.split('!')[1];
    }

    function withBasePathAdded(pagePath, base) {
        return base + '!' + pagePath;
    }

    function withSyntaxWrapperAdded(cfiString) {
        return 'epubcfi(' + cfiString + ')';
    }

    function withSyntaxWrapperRemoved(cfiString) {
        if(cfiString.indexOf('epubcfi(') === 0 && cfiString[cfiString.length-1] === ')') {
          // Remove intial epubcfi( and ending )
          return cfiString.slice(8, cfiString.length-1);
        }

        return cfiString;
    }


    function nodeFromSteps(steps, startingElement, doc) {
        var count, step;
        var stepsCopy = [];
        var nodeIter = startingElement || doc.getElementsByTagName('html')[0];

        // Playback starts at the last id'd element (EPR-1621)
        for (var i = steps.length - 1; i >= 0; i--) {
            step = steps[i];
            if (step.id) {
                nodeIter = doc.getElementById(step.id);
                break;
            }
            stepsCopy.unshift(step);
        }

        while (stepsCopy.length > 0) {
            if (!nodeIter) {
                throw new Error('Bad CFI Path');
            }

            step = stepsCopy.shift();

            if (step.type === 'element') {
                nodeIter = nt.getFirstChildElement(nodeIter);
                count = step.index - 2;

                while (nodeIter && (count > 0)) {
                    nodeIter = nt.getNextElementSibling(nodeIter);
                    count = count - 2;
                }
            } else if (step.type === 'text') {
                if (!utils.isTextNode(nodeIter)) {
                    nodeIter = nt.getFirstChildNode(nodeIter);

                    if (nodeIter && !utils.isTextNode(nodeIter)) {
                        nodeIter = nt.getNextTextNodeSibling(nodeIter);
                    }
                }

                count = step.index - 1;

                while (nodeIter && count > 0) {
                    nodeIter = nt.getNextTextNodeSibling(nodeIter);
                    count = count - 2;
                }
            }
        }

        return nodeIter;
    }

    function stepsFromPathString(string) {

        /*
        * Regex: starts from "/", ends before ":" (offset) or next "/", e.g.
        * "/4/4[data-uuid-56e363d0138444b8bc4c6bbe96e5e5f7]/1:23" =>
        * ["/4", "/4[data-uuid-56e363d0138444b8bc4c6bbe96e5e5f7]", "/1"]
        * should work with test location assertions, e.g. "/4/4/1:23[once, more]"
        */
        var pathSteps = string.match(/(\/[^:\/]+)/g);
        if (!pathSteps) {
            return [];
        }

        var steps = pathSteps.map(function(step) {

            var index = parseInt(step.substring(1), 10);
            var idMatch = step.match(/\[(.+)\]/);

            return {
                type: (index % 2 === 0) ? 'element' : 'text',
                id: idMatch && idMatch[1],
                index: index
            };

        });

        return steps;
    }

    function charOffsetFromPathString(string) {
        return parseInt(string.split(':')[1]);
    }

    /**
     * Position is a discrete position in a page.  A CFI may be made up of one
     * Position instance, or two (if it describes a range with a start and and end)
     * Position can either be instantiated with a node and offset, or PATH_STRING
     * part of a CFI: epubcfi({DOC_STRING}!{PATH_STRING})
     *
     * @param {[type]} item   [description]
     * @param {[type]} offset [description]
     */
    function Position(item, offset) {
        this.path = [];
        this.charOffset = 0;

        if (item && item.nodeName) {  //TODO - better way to sniff for node?
            var node = item;

            node = this._consumeCharCount(node, offset);

            node = this._consumeTextPath(node);
            this._consumeElementPath(node);

        } else if (typeof item === 'string') {
            this.path = stepsFromPathString(item);
            this.charOffset = charOffsetFromPathString(item);
        }

    }

//DEBUG LOGGING UTIL
    // function debug(node) {
    //     if (!node) {
    //         return '_NULL_';
    //     }
    //
    //     if (utils.isTextNode(node)) {
    //         return '<#text:' + node.textContent + '>';
    //     } else {
    //         return '<' + node.tagName + '>';
    //     }
    // }

    ///////
    // The following 3 methods are private instantiation helpers

    //Assume node here is a text node.  Returns the text node (or, if text nodes were
    //elided, the earliest one. (furthest left in a l-r set of siblings))
    Position.prototype._consumeCharCount = function(node, startingOffset) {
        var runningOffset = startingOffset || 0;
        var toReturn = node;

        //For element nodes, we count children based on offset
        if (utils.isElementNode(node)) {

            if (startingOffset === undefined) {
                return node;
            }

            node = nt.getFirstChildNode(node);
            if (!node) {
                //if no children, we should just return the parent node
                return toReturn;
            }

            for (var i = 0; i < startingOffset; i++) {
                node = nt.getNextNodeSibling(node);
            }
            this.charOffset = 0;
            return node;
        }

        //For text nodes, we count text offset, which may involve walking into
        //adjacent nodes.
        while (node) {
            //TODO make this look just like the code that plays back the offset
            node = nt.getPrevNodeSibling(node, true);

            if (node && utils.isTextNode(node)) {
                //it's a text node, concat with the current count
                runningOffset += node.length;
                toReturn = node; //record the last known good one
                continue;
            } else {
                break;
            }
        }

        this.charOffset = runningOffset;
        return toReturn;
    };

    //Assume node here is a text node.  Creates the path step to it, returning the
    //parent element
    Position.prototype._consumeTextPath = function(node) {

        //There is no text path
        if (utils.isElementNode(node)) {
            return node;
        }

        var count = 1;
        var lastSibling = node;

        while (node) {
            node = nt.getPrevNodeSibling(node);
            if (node && utils.isTextNode(node)) {
                count += 2;
                lastSibling = node;
            }
        }

        this.path.unshift({
            type: 'text',
            index: count
        });

        return nt.getParentNode(lastSibling);
    };

    Position.prototype._consumeElementPath = function(node) {
        var iter, parentIter = node;
        var id;
        var count = 0;
        var keepGoing = true;
        while (parentIter && parentIter.parentNode && parentIter.parentNode.nodeType !== 9) {
            id = parentIter.id;
            count = 2;
            iter = parentIter;

            //Do one step:
            while (iter) {
                iter = nt.getPrevNodeSibling(iter);

                if (iter && utils.isElementNode(iter)) {
                    count += 2;
                }
            }

            this.path.unshift({
                type: 'element',
                id: id,
                index: count
            });

            parentIter = nt.getParentNode(parentIter);
        }

    };

    Position.prototype.createCFISuffix = function() {
        var path = pathStringFromSteps(this.path);

        //If there's no path at all, we assume we want to add a text offset.
        //If there is a path, we only add a text offset if the last step is a text node
        if ((this.path.length === 0) ||
            (this.path[this.path.length-1].type === 'text')) {
            path += ':' + this.charOffset;
        }

        //TODO: Better way to factor this?  It's possible to get Mathjax-added
        //ids in our assertion text.  We don't want that.  This regex removes any
        //assertion ids that begin with 'MathJax'
        return path.replace(/\[MathJax[^\]]*\]/,'');
    };

    Position.prototype.createCFIString = function(basePath) {
        var str = this.createCFISuffix();

        str = withBasePathAdded(str, basePath);

        return withSyntaxWrapperAdded(str);
    };

    //Returns the node that this Position is in
    //guaranteed to either return a node or throw.  Clients can be assured of non-null return
    Position.prototype.getNode = function(doc) {
        return nodeFromSteps(this.path, null, doc);
    };

    //Sets the passed in range start position to this Position
    Position.prototype.setRangeStart = function(range, doc) {
        var offset = this.charOffset;
        var node = this.getNode(doc);

        if (utils.isTextNode(node)) {
            while (node && (offset > node.length)) {
                offset -= node.length;
                node = nt.getNextTextNodeSibling(node, true);
            }
        }

        range.setStart(node, offset);
    };

    //Sets the passed in range end position to this Position
    Position.prototype.setRangeEnd = function(range, doc) {
        var offset = this.charOffset;
        var node = this.getNode(doc);

        if (utils.isTextNode(node)) {
            while (node && (offset > node.length)) {
                offset -= node.length;
                node = nt.getNextTextNodeSibling(node, true);
            }
        }

        range.setEnd(node, offset);
    };

    function pathStringFromSteps(steps) {
        return steps
            .map(function(step) {
                var idString = (step.id) ? ('[' + step.id + ']') : '';

                return '/' + step.index + idString;
            }).join('');
    }

    //////// PUBLIC METHODS ////////////

    // Given a range, create a CFI String using the basePath as the content
    // document specifier part.
    function cfiStringFromRange(range, basePath) {
        var start = new Position(range.startContainer, range.startOffset);
        var end = new Position(range.endContainer, range.endOffset);

        var common = [];
        var keepGoing = true;

        while (true) {
            if (start.path.length === 0 || end.path.length === 0) {
                break;
            }

            if (start.path[0].index !== end.path[0].index) {
                break;
            }

            common.push(start.path.shift());
            end.path.shift();
        }

        var str =  [
            pathStringFromSteps(common),
            start.createCFISuffix(),
            end.createCFISuffix()
        ].join(',');

        str = withBasePathAdded(str, basePath);

        return withSyntaxWrapperAdded(str);
    }


    //Given a CFI String, return a range.
    function rangeFromCFIString(cfiString, doc) {
        var curDoc = doc || document;

        cfiString = withSyntaxWrapperRemoved(cfiString);
        cfiString = withBasePathRemoved(cfiString);

        var rangeFragments = cfiString.split(',');
        var range = curDoc.createRange();
        if (rangeFragments.length === 3) {
            var startString = rangeFragments[0] + rangeFragments[1];
            var endString = rangeFragments[0] + rangeFragments[2];

            var startLoc = new Position(startString);
            var endLoc = new Position(endString);

            startLoc.setRangeStart(range, curDoc);
            endLoc.setRangeEnd(range, curDoc);


        } else if (rangeFragments.length === 1) {
            var loc = new Position(rangeFragments[0]);
            loc.setRangeStart(range, curDoc);
            loc.setRangeEnd(range, curDoc);
        }

        return range;
    }

    /**
     * Generates the CFI Base path for a given spine itemId
     *
     * @param  {Number} spineIndex 0-based index of the spine in the content document
     *                             (this is almost always 2)
     * @param  {Number} itemIndex  0-based index of the item in the spine
     * @param  {String} itemId     optional id of the item
     * @return {String}            cfi base path
     */
    function generateBasePath(spineIndex, itemIndex, itemId) {
        // Make sure input is integer
        spineIndex = parseInt(spineIndex);
        itemIndex = parseInt(itemIndex);

        // Add one to spineIndex
        spineIndex = (spineIndex + 1) * 2;

        // Start CFI String
        var ret = ['/', spineIndex, '/', (itemIndex + 1) * 2].join('');

        // Add id if available
        if (itemId) {
            ret = [ret, '[', itemId, ']'].join('');
        }

        // Return CFI String
        return ret;
    }

    function cfiStringFromSpineIndex(itemIndex, itemId) {
        var basePath = generateBasePath(2, itemIndex, itemId);

        return [
            'epubcfi(',
            basePath,
            '!/4/1:0',
            ')'
        ].join('');
    }

    function lastParentIdFromCFIString(cfiString) {
        var regex = /\[([^\]]+)\]/g;
        var pagePath = cfiString.split('!')[1];

        if (!pagePath) {
            return null;
        }

        var ids = pagePath.match(regex);

        if (!(ids && ids.length)) {
            return null;
        }

        var lastId = ids[ids.length-1];

        return regex.exec([lastId])[1];
    }

    function spineIndexFromCFIString(cfiString){
        cfiString = withSyntaxWrapperRemoved(cfiString);
        var basePath = cfiString.split('!')[0];
        var steps = stepsFromPathString(basePath);

        if (!steps.length) {
            return null;
        }

        return (steps[steps.length-1].index / 2) - 1;
    }

    function cfiStringFromNode(node, basePath) {
        //TODO common source with `nodeFromSteps()`
        //Forward to first legal start node
        while (node) {
            if (nt.isIgnorable(node)) {
                node = nt.getFirstChildNode(node);
                continue;
            } else if (nt.isSkippable(node)) {
                node = nt.getNextNodeSibling(node);
                continue;
            } else {
                //This node is good
                break;
            }
        }

        if (!node) {
            throw new Error('cfiStringFromNode failed to find legal starting node');
        }

        var position = new Position(node);

        return position.createCFIString(basePath);
    }


})(
    window.ePubAnnotation,
    window.ePubAnnotation.NodeTraversal,
    window.ePubAnnotation.utils
);



//It is required that this follow the cfi.js during the concatenation step
(function(api, NodeTraversal, utils) {
    api.cfi.legacy.v6 = {
        generateBasePath: generateBasePath,

        lastParentIdFromCFIString: lastParentIdFromCFIString,
        spineIndexFromCFIString: spineIndexFromCFIString,
        spineIdFromCFIString: spineIdFromCFIString,

        cfiStringFromSpineIndex: cfiStringFromSpineIndex,
        cfiStringFromNode: cfiStringFromNode,

        cfiStringFromRange: cfiStringFromRange,
        rangeFromCFIString: rangeFromCFIString,

        getVersion: getVersion,

    };

    //Copy in the legacy `utils.isSkippable()`  as it existed in v 7.6.0
    //and its required helpers
    function hasClass(element, cls) {
        return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    }

    function isTextNode(node) {
        return node && node.nodeType === Node.TEXT_NODE;
    }

    function isElementNode(node) {
        return node && node.nodeType === Node.ELEMENT_NODE;
    }

    function isSkippable(node) {

        //Only text or element nodes are to be considered
        //per http://www.idpf.org/epub/linking/cfi/epub-cfi.html#sec-path-child-ref
        if (!(isTextNode(node) || isElementNode(node))) {
            return true;
        }

        if (!node.tagName ||
            !(node.tagName.toUpperCase() === 'SPAN' ||
            node.tagName.toUpperCase() === 'DIV')) {
                //shortcut - this is not a skippable node if its not a span or div
                return false;
        }

        //Is this the MathJax Message node?
        if (node.id === 'MathJax_Message') {
            return true;
        }

        //Does this have one of the MathJax classes to skip?
        var ignore = false;
        var kMathJaxClassesToSkip = [
            'MathJax_Preview',
            'MathJax_SVG_Display'
        ];

        kMathJaxClassesToSkip.forEach(function(aClass) {
            if (hasClass(node, aClass)) {
                ignore = true;
            }
        });

        if (ignore) {
            return true;
        }

        //Finally, is this the div with a 'MathJax_SVG_Hidden' child
        if (node.tagName.toUpperCase() === 'DIV') {
            for (var i = 0; i < node.childNodes.length; i++) {
                if (node.childNodes[i].id === 'MathJax_SVG_Hidden') {
                    return true;
                }
            }
        }

        return false;
    }

    var versionErrorMessage = 'Unknown legacy annotation lib version requested:';

    //Add a method to check whether an error was a Legacy Version Error,
    //which is more severe than other errors
    api.isLegacyVersionError = function(e) {
        return e.message && e.message.indexOf(versionErrorMessage) !== -1;
    };

    //Utility for returning the right API based on optionalLegacyVersion
    //if optionalLegacyVersion is undefined, it returns the modern one
    function getVersion(optionalLegacyVersion) {
        if (!optionalLegacyVersion) {
            //Default to the latest version
            return api.cfi;
        }

        var requestedVersion = api.cfi.legacy[optionalLegacyVersion];

        if (!requestedVersion) {
            throw new Error(versionErrorMessage + optionalLegacyVersion);
        }
        return requestedVersion;
    }

    var nt = new NodeTraversal(utils.isIgnorable, isSkippable);

    //Vocabulary:
    // epubcfi(     Wrapper Prefix
    // )            Wrapper Suffix
    // epubcfi(XXX!YYY)  XXX = basePath, YYY = pagePath

    //Assumes wrapper has been removed
    function withBasePathRemoved(cfiString) {
        return cfiString.split('!')[1];
    }

    function withBasePathAdded(pagePath, base) {
        return base + '!' + pagePath;
    }

    function withSyntaxWrapperAdded(cfiString) {
        return 'epubcfi(' + cfiString + ')';
    }

    function withSyntaxWrapperRemoved(cfiString) {
        if(cfiString.indexOf('epubcfi(') === 0 && cfiString[cfiString.length-1] === ')') {
          // Remove intial epubcfi( and ending )
          return cfiString.slice(8, cfiString.length-1);
        }

        return cfiString;
    }

    //consumes the passed in element step
    //startingElement represents the parent node that the step refers to
    //Return value is the child element that the step specifies
    //NULL return represents an invalid step
    function walkElementStep(step, startingElement, doc) {
        var nodeIter = nt.getFirstChildElement(startingElement);
        var count = step.index - 2;

        while (nodeIter && (count > 0)) {
            nodeIter = nt.getNextElementSibling(nodeIter);
            count = count - 2;
        }

        return nodeIter;
    }

    //consumes the passed in text step
    //startingElement represents the parent node that the step refers to
    //Return value is the child text node that the step specifies (unless there is
    //no text node at that position - see note)
    //
    //NOTE: If steps lead to a non-existing text node (legal in Cfi spec),
    //then return either the next element sibling, or the prev element sibling,
    // or the parent element. (in that order)   In this case, it is an element,
    // not a text node that is returned.
    function walkTextStep(step, startingElement, doc) {
        var nodeIter = startingElement;
        var count = step.index - 1;

        if (count === 0) {
            if (nt.firstChildIsElement(nodeIter)) {
                //There is no text node at this position
                //return the first child element itself
                return nt.getFirstChildElement(nodeIter);
            } else {
                //We've found the first child
                return nt.getFirstChildNode(nodeIter);
            }
        }

        //Here, we need to walk the children
        if (nt.firstChildIsElement(nodeIter)) {
            //There is no text node as the first child
            //go to the next one and decrease count
            count = count - 2;
            nodeIter = nt.getFirstChildElement(nodeIter);
        } else {
            //move nodeIter to the first (text) node prior to beginning the loop
            nodeIter = nt.getFirstChildNode(nodeIter);
        }

        //Now walk the element siblings
        while (nodeIter && count > 0) {
            nodeIter = nt.getNextElementSibling(nodeIter);
            count = count - 2;
        }

        //Here we're pointing to the element just before the desired text
        //element, unless there is no text element
        if (nt.nextSiblingIsElement(nodeIter)) {
            //There is no text element
            return nt.getNextElementSibling(nodeIter);
        } else {
            //Return the next text sibling following nodeIter
            //This might also return NULL if nodeIter is the final element in
            //the children, in which case we return either the previous sibling
            //or the parent
            return nt.getNextTextNodeSibling(nodeIter) ||
                nt.getPrevElementSibling(nodeIter) ||
                nt.getParentNode(nodeIter);
        }
    }

    //Returns the node arrived at after following the steps
    //NOTE: Node may be null if the steps point to a text position that
    //does not contain a text node
    function nodeFromSteps(steps, startingElement, doc) {
        var count, step;
        var stepsCopy = [];
        var nodeIter = startingElement || doc.getElementsByTagName('html')[0];

        // Playback starts at the last id'd element (EPR-1621)
        for (var i = steps.length - 1; i >= 0; i--) {
            step = steps[i];
            if (step.id) {
                nodeIter = doc.getElementById(step.id);
                break;
            }
            stepsCopy.unshift(step);
        }

        while (stepsCopy.length > 0) {
            if (!nodeIter) {
                throw new Error('Bad CFI Path');
            }

            step = stepsCopy.shift();

            if (step.type === 'element') {
                nodeIter = walkElementStep(step, nodeIter, doc);
            } else if (step.type === 'text') {
                nodeIter = walkTextStep(step, nodeIter, doc);
            }
        }

        return nodeIter;
    }

    function stepsFromPathString(string) {

        /*
        * Regex: starts from "/", ends before ":" (offset) or next "/", e.g.
        * "/4/4[data-uuid-56e363d0138444b8bc4c6bbe96e5e5f7]/1:23" =>
        * ["/4", "/4[data-uuid-56e363d0138444b8bc4c6bbe96e5e5f7]", "/1"]
        * should work with test location assertions, e.g. "/4/4/1:23[once, more]"
        */
        var pathSteps = string.match(/(\/[^:\/]+)/g);
        if (!pathSteps) {
            return [];
        }

        var steps = pathSteps.map(function(step) {

            var index = parseInt(step.substring(1), 10);
            var idMatch = step.match(/\[(.+)\]/);

            return {
                type: (index % 2 === 0) ? 'element' : 'text',
                id: idMatch && idMatch[1],
                index: index
            };

        });

        return steps;
    }

    function charOffsetFromPathString(string) {
        return parseInt(string.split(':')[1]);
    }

    /**
     * Position is a discrete position in a page.  A CFI may be made up of one
     * Position instance, or two (if it describes a range with a start and and end)
     * Position can either be instantiated with a node and offset, or PATH_STRING
     * part of a CFI: epubcfi({DOC_STRING}!{PATH_STRING})
     *
     * @param {[type]} item   [description]
     * @param {[type]} offset [description]
     */
    function Position(item, offset) {
        this.path = [];
        this.charOffset = 0;

        if (item && item.nodeName) {  //TODO - better way to sniff for node?
            var node = item;

            node = this._consumeCharCount(node, offset);

            node = this._consumeTextPath(node);
            this._consumeElementPath(node);

        } else if (typeof item === 'string') {
            this.path = stepsFromPathString(item);
            this.charOffset = charOffsetFromPathString(item);
        }

    }


    ///////
    // The following 3 methods are private instantiation helpers

    //Assume node here is a text node.  Returns the text node (or, if text nodes were
    //elided, the earliest one. (furthest left in a l-r set of siblings))
    Position.prototype._consumeCharCount = function(node, startingOffset) {
        var runningOffset = startingOffset || 0;
        var toReturn = node;

        //For element nodes, we count children based on offset
        if (utils.isElementNode(node)) {

            if (startingOffset === undefined) {
                return node;
            }

            node = nt.getFirstChildNode(node);
            if (!node) {
                //if no children, we should just return the parent node
                return toReturn;
            }

            for (var i = 0; i < startingOffset; i++) {
                node = nt.getNextNodeSibling(node);
            }
            this.charOffset = 0;
            return node;
        }

        //For text nodes, we count text offset, which may involve walking into
        //adjacent nodes.
        while (node) {
            //TODO make this look just like the code that plays back the offset
            node = nt.getPrevNodeSibling(node, true);

            if (node && utils.isTextNode(node)) {
                //it's a text node, concat with the current count
                runningOffset += node.length;
                toReturn = node; //record the last known good one
                continue;
            } else {
                break;
            }
        }

        this.charOffset = runningOffset;
        return toReturn;
    };

    //Assume node here is a text node.  Creates the path step to it, returning the
    //parent element
    Position.prototype._consumeTextPath = function(node) {

        //There is no text path
        if (utils.isElementNode(node)) {
            return node;
        }

        var count = 1;
        var lastSibling = node;

        while (node) {
            node = nt.getPrevElementSibling(node);
            if (node) {
                count += 2;
                lastSibling = node;
            }
        }

        this.path.unshift({
            type: 'text',
            index: count
        });

        return nt.getParentNode(lastSibling);
    };

    Position.prototype._consumeElementPath = function(node) {
        var iter, parentIter = node;
        var id;
        var count = 0;
        var keepGoing = true;
        while (parentIter && parentIter.parentNode && parentIter.parentNode.nodeType !== 9) {
            id = parentIter.id;
            count = 2;
            iter = parentIter;

            //Do one step:
            while (iter) {
                iter = nt.getPrevNodeSibling(iter);

                if (iter && utils.isElementNode(iter)) {
                    count += 2;
                }
            }

            this.path.unshift({
                type: 'element',
                id: id,
                index: count
            });

            parentIter = nt.getParentNode(parentIter);
        }

    };

    Position.prototype.createCFISuffix = function() {
        var path = pathStringFromSteps(this.path);

        //If there's no path at all, we assume we want to add a text offset.
        //If there is a path, we only add a text offset if the last step is a text node
        if ((this.path.length === 0) ||
            (this.path[this.path.length-1].type === 'text')) {
            path += ':' + this.charOffset;
        }

        //TODO: Better way to factor this?  It's possible to get Mathjax-added
        //ids in our assertion text.  We don't want that.  This regex removes any
        //assertion ids that begin with 'MathJax'
        return path.replace(/\[MathJax[^\]]*\]/,'');
    };

    Position.prototype.createCFIString = function(basePath) {
        var str = this.createCFISuffix();

        str = withBasePathAdded(str, basePath);

        return withSyntaxWrapperAdded(str);
    };

    //Returns the node that this Position is in.
    //guaranteed to either return a node or throw.  Clients can be assured of non-null return
    //
    //If the position refers to a non-existing text node, the node returned is
    //an element node 'near' the given positon: It returns either the next element
    //sibling, or the prev element sibling, or the parent element. (in that order)
    Position.prototype.getNode = function(doc) {
        return nodeFromSteps(this.path, null, doc);
    };

    //Sets the passed in range start position to this Position
    Position.prototype.setRangeStart = function(range, doc) {
        var offset = this.charOffset;
        var node = this.getNode(doc);

        if (utils.isTextNode(node)) {
            while (node && (offset > node.length)) {
                offset -= node.length;
                node = nt.getNextTextNodeSibling(node, true);
            }
        }

        range.setStart(node, offset);
    };

    //Sets the passed in range end position to this Position
    Position.prototype.setRangeEnd = function(range, doc) {
        var offset = this.charOffset;
        var node = this.getNode(doc);

        if (utils.isTextNode(node)) {
            while (node && (offset > node.length)) {
                offset -= node.length;
                node = nt.getNextTextNodeSibling(node, true);
            }
        }

        range.setEnd(node, offset);
    };

    function pathStringFromSteps(steps) {
        return steps
            .map(function(step) {
                var idString = (step.id) ? ('[' + step.id + ']') : '';

                return '/' + step.index + idString;
            }).join('');
    }

    //////// PUBLIC METHODS ////////////

    // Given a range, create a CFI String using the basePath as the content
    // document specifier part.
    function cfiStringFromRange(range, basePath) {
        var start = new Position(range.startContainer, range.startOffset);
        var end = new Position(range.endContainer, range.endOffset);

        var common = [];
        var keepGoing = true;

        while (true) {
            if (start.path.length === 0 || end.path.length === 0) {
                break;
            }

            if (start.path[0].index !== end.path[0].index) {
                break;
            }

            common.push(start.path.shift());
            end.path.shift();
        }

        var str =  [
            pathStringFromSteps(common),
            start.createCFISuffix(),
            end.createCFISuffix()
        ].join(',');

        str = withBasePathAdded(str, basePath);

        return withSyntaxWrapperAdded(str);
    }


    //Given a CFI String, return a range.
    function rangeFromCFIString(cfiString, doc) {
        var curDoc = doc || document;

        cfiString = withSyntaxWrapperRemoved(cfiString);
        cfiString = withBasePathRemoved(cfiString);

        var rangeFragments = cfiString.split(',');
        var range = curDoc.createRange();
        if (rangeFragments.length === 3) {
            var startString = rangeFragments[0] + rangeFragments[1];
            var endString = rangeFragments[0] + rangeFragments[2];

            var startLoc = new Position(startString);
            var endLoc = new Position(endString);

            startLoc.setRangeStart(range, curDoc);
            endLoc.setRangeEnd(range, curDoc);


        } else if (rangeFragments.length === 1) {
            var loc = new Position(rangeFragments[0]);
            loc.setRangeStart(range, curDoc);
            loc.setRangeEnd(range, curDoc);
        }

        return range;
    }

    /**
     * Generates the CFI Base path for a given spine itemId
     *
     * @param  {Number} spineIndex 0-based index of the spine in the content document
     *                             (this is almost always 2)
     * @param  {Number} itemIndex  0-based index of the item in the spine
     * @param  {String} itemId     optional id of the item
     * @return {String}            cfi base path
     */
    function generateBasePath(spineIndex, itemIndex, itemId) {
        // Make sure input is integer
        spineIndex = parseInt(spineIndex);
        itemIndex = parseInt(itemIndex);

        // Add one to spineIndex
        spineIndex = (spineIndex + 1) * 2;

        // Start CFI String
        var ret = ['/', spineIndex, '/', (itemIndex + 1) * 2].join('');

        // Add id if available
        if (itemId) {
            ret = [ret, '[', itemId, ']'].join('');
        }

        // Return CFI String
        return ret;
    }

    function cfiStringFromSpineIndex(itemIndex, itemId) {
        var basePath = generateBasePath(2, itemIndex, itemId);

        return [
            'epubcfi(',
            basePath,
            '!/4/1:0',
            ')'
        ].join('');
    }

    function lastParentIdFromCFIString(cfiString) {
        var regex = /\[([^\]]+)\]/g;
        var pagePath = cfiString.split('!')[1];

        if (!pagePath) {
            return null;
        }

        var ids = pagePath.match(regex);

        if (!(ids && ids.length)) {
            return null;
        }

        var lastId = ids[ids.length-1];

        return regex.exec([lastId])[1];
    }

    function spineIndexFromCFIString(cfiString) {
        cfiString = withSyntaxWrapperRemoved(cfiString);
        var basePath = cfiString.split('!')[0];
        var steps = stepsFromPathString(basePath);

        if (!steps.length) {
            return null;
        }

        return (steps[steps.length-1].index / 2) - 1;
    }

    function spineIdFromCFIString(cfiString) {
        cfiString = withSyntaxWrapperRemoved(cfiString);
        var basePath = cfiString.split('!')[0];
        var steps = stepsFromPathString(basePath);

        if (!steps.length) {
            return null;
        }

        return steps[steps.length-1].id;
    }

    function cfiStringFromNode(node, basePath) {
        //TODO common source with `nodeFromSteps()`
        //Forward to first legal start node
        while (node) {
            if (nt.isIgnorable(node)) {
                node = nt.getFirstChildNode(node);
                continue;
            } else if (nt.isSkippable(node)) {
                node = nt.getNextNodeSibling(node);
                continue;
            } else {
                //This node is good
                break;
            }
        }

        if (!node) {
            throw new Error('cfiStringFromNode failed to find legal starting node');
        }

        var position = new Position(node);

        return position.createCFIString(basePath);
    }


})(
    window.ePubAnnotation,
    window.ePubAnnotation.NodeTraversal,
    window.ePubAnnotation.utils
);


'use strict';

(function(api) {
    function HighlightColor(name, color, displayText) {
        /* jshint validthis: true */
        var highlightColor = this;

        highlightColor.name = name;
        highlightColor.color = color;
        highlightColor.displayText = displayText;

        highlightColor.classes = name + '-highlight';
        highlightColor.selectClasses = 'colorSelect ' + name;
        highlightColor.menuClasses = name;
    }

    function highlightColorToColorInfo(highlightColor) {
        return {
            aria: highlightColor.displayText, // multiSelect
            classes: highlightColor.selectClasses, // multiSelect
            menuClasses: highlightColor.menuClasses, // contextMenu
            highlight: highlightColor,
        };
    }

    var colors = [
        new HighlightColor('yellow', '#FFF098', 'Yellow Highlight'),
        new HighlightColor('blue', '#BDD7FC', 'Blue Highlight'),
        new HighlightColor('green', '#CFFF53', 'Green Highlight'),
        new HighlightColor('pink', '#FFBEDC', 'Pink Highlight')
    ];

    var colorInfoArray = colors.map(highlightColorToColorInfo);

    var highlightDefaults = {
        shape: 'epr-shape-square-filled',
        color: colors[0].classes
    };

    function getColorInfoForClass(classes) {
        for (var i = 0; i < colorInfoArray.length; ++i) {
            if (colorInfoArray[i].highlight.classes === classes) {
                return colorInfoArray[i];
            }
        }
    }

    api.colorData = {

        // Properties
        colors: colors,
        highlightDefaults: highlightDefaults,
        colorInfoArray: colorInfoArray,

        //methods
        getColorInfoForClass: getColorInfoForClass
    };

})(window.ePubAnnotation);


'use strict';

(function(api, rangy, cfi, utils, colorData) {

    api.createFromSelection = createFromSelection;
    api.editAnnotation = editAnnotation;
    api.getRangeForAnnotation = getRangeForAnnotation;
    api.textForRange = textForRange;
    //Note: This will return html with any partially selected elements closed
    api.htmlForRange = htmlForRange;

    //MHE: limit text to 3500 characters
    var MHE_CHAR_LIMIT = 3500;

    // Returns true if selection was empty or contains only whitespace,
    // to prevent creation of annotation object
    // nonTextFlag - if image (non text asset) clicked no text appear on selection
    // but Reader needs empty selection to get cfi from selection
    // to anchor position for navigation, so nonTextFlag override invalidSelection
    // only in case of empty text selection
    function isSelectionInvalid(selection, doc, nonTextFlag) {
        if (!selection || selection.rangeCount < 1) {
            return true;
        }

        // only non text selection case: (e.g. image click in avalon authoring)
        if (nonTextFlag) {
            return false;
        }

        var range = selection.getRangeAt(0);
        var text = textForRange(new rangy.WrappedRange(range), doc);
        var invalidSelection = /^\s*$/.test(text);

        return invalidSelection ? true : false;
    }

    //Given an element or documentFragment,
    //removes all the hidden content from it and its children.
    function removeHiddenContent(element, doc) {
        if (shouldBeRemoved(element, doc)) {
            if (element.parentNode) {
                element.parentNode.removeChild(element);
            }
            return;
        }

        removeHTMLComments(element);

        var elementChildren = getElementChildren(element);
        for (var i = 0; i < elementChildren.length; i++) {
            removeHiddenContent(elementChildren[i], doc);
        }
    }

    function shouldBeRemoved(element, doc) {
        var excludeClassNamesOnBoth = [
                'mhe-inline-credit',
                'mhe-user-select-none',
                'mhe-tts-ignore'
            ],
            excludeClassNamesOnInstructor = excludeClassNamesOnBoth.concat([
                'student',
                'mhe-user-select-none-on-instructor'
            ]),
            excludeClassNamesOnLearner = excludeClassNamesOnBoth.concat([
                'teacher',
                'instructor',
                'acme-teacher',
                'mhe-user-select-none-on-learner'
            ]),
            excludeTagNames = [
                'svg',
                'script'
            ];

        if (element.classList) {
            if (doc.body.classList.contains('mhe-context-view-instructor') &&
                hasClassOnExcludeList(element, excludeClassNamesOnInstructor)) {
                return true;
            } else if (doc.body.classList.contains('mhe-context-view-learner') &&
                hasClassOnExcludeList(element, excludeClassNamesOnLearner)) {
                return true;
            }
        }

        if (element.tagName && excludeTagNames.indexOf( element.tagName.toLowerCase() ) > -1) {
            return true;
        }

        return false;
    }

    function hasClassOnExcludeList(element, excludeList) {
        for (var i = 0, len = excludeList.length; i < len; i++) {
            if (element.classList.contains(excludeList[i])) {
                return true;
            }
        }
        return false;
    }

    function getElementChildren(element) {
        var newNodes = [];
            for (var i = 0; i < element.childNodes.length; i++) {
                if (element.childNodes[i] && element.childNodes[i].nodeType === 1) {
                    newNodes.push(element.childNodes[i]);
                }
            }
        return newNodes;
    }

    function removeHTMLComments(element) {
        for (var i = 0; i < element.childNodes.length; i++) {
            if (element.childNodes[i] && element.childNodes[i].nodeType === 8) {
                element.childNodes[i].textContent = ''; // setting to empty string instead of deleting to preserve DOM structure
            }
        }
    }

    //Given a range, returns the text suitable for highlighting/reading aloud
    //(filtering out teacher content, scripts, etc)
    function documentFragmentForRange(range, doc) {
        var docFrag = range.cloneContents();
        removeHiddenContent(docFrag, doc);
        return docFrag;
    }

    function textForNode(node) {
        var tagName = node.tagName ? node.tagName.toUpperCase() : undefined;
        var textContent = '';
        switch (tagName) {
            case 'IMG':
                // get the alt text
                textContent = node.alt;
                break;
            case 'IFRAME':
                // @todo how do we want ot handle widgets?
                break;
            case 'SVG':
                // @todo some SVG have alt text similar to images (but this could also be rendered mathml)
                //NOTE: svg is currently filtered in `shouldBeRemoved()`
                break;
            // @todo We can improve our mathml support by sniffing for more math nodes
            //eg 'MFRAC' nodes could perhaps have an implementation like:
            //
            // textContent = textForNode(firstChild) + ' divided by ' textForNode(secondChild)
            //
            //though there could be complications, and this isn't a localizable solution
            case 'BR':
                //@todo discuss to figure out if we should break on line breaks (I can think of arguments on both sides)
                break;
            default:
                if (node.hasChildNodes()) {
                    var children = node.childNodes;
                    var childText = [];
                    for (var i = 0; i < children.length; i++) {
                        childText.push(textForNode(children[i]));
                    }
                    textContent = childText
                        .filter(function (text) {
                            return text !== '';
                        })
                        .join(' ');
                } else {
                    return node.textContent;
                }
        }

        return textContent;
    }

    //Given a range, returns the text suitable for highlighting/reading aloud
    function textForRange(range, doc) {
        var docFrag = documentFragmentForRange(range, doc);

        var text = textForNode(docFrag) || '';
        text = text.replace(/[\u0020\t]{2,}/g, '\u0020')
                   .replace(/(\u0020*\n\u0020*)+/g, '\n');
        return text;
    }

    function htmlForRange(range, doc) {
        var docFrag = documentFragmentForRange(range, doc);
        //get html out of document fragment (yuck)
        //cf https://stackoverflow.com/questions/4896944/converting-range-or-documentfragment-to-string
        var div = doc.createElement('div');
        div.appendChild(docFrag.cloneNode(true));

        return div.innerHTML;
    }

    //Truncate text for firebase storage and annotation export
    function truncateText(text, limit) {
        var textLength = text.length;
        if (textLength > limit) {
            text = [
                text.slice(0, limit / 2),
                text.slice(textLength - limit / 2)
            ].join('...\n\n...');
        }
        return text;
    }

    /**
     * given an annotation assumed to be a placemark, grabs text surrounding
     * the selection.  We try to grab 100 characters following the selection
     * beginning.  If we hit the end of the element before 100 characters, we
     * grab more from the front until we get to 100 characters or the beginning
     * of the element.  We add ellipses to the beginning and/or the end at word
     * boundaries if they are not at the element boundary.
     *
     * This function will throw if annotation has an invalid range
     * @param  {Object} annotation
     * @param  {Document} doc
     * @return {String}
     */
    function grabPlacemarkText(annotation, doc, optionalLegacyVersion) {

        var range = getRangeForAnnotation(annotation, doc, optionalLegacyVersion);
        var startElement = utils.containingElement(range.startContainer);
        var endElement = utils.containingElement(range.endContainer);

        //Make sure the start and end elements are not annotation elements
        //(that were added to the DOM after the fact).
        startElement = utils.firstNonIgnorableParent(startElement);
        endElement = utils.firstNonIgnorableParent(endElement);

        if ((startElement !== endElement) || !startElement) {
            //If the selection crosses different elements, or one was NULL
            //use selection's text
            var text = textForRange(range, doc);
            return truncateText(text, MHE_CHAR_LIMIT);
        }

        //Compute the start and end offsets in relation to the parent element.
        //This requires creating a range, and counting the length of its text.
        var newRange = rangy.createRange(doc);
        var selectedText = textForRange(range, doc);

        newRange.setStart(startElement, 0);
        newRange.setEnd(range.startContainer, range.startOffset);
        var startOffset = textForRange(newRange, doc).length;
        var endOffset = startOffset + selectedText.length;

        //create a copy of the startElement, so that we can strip out
        //teacher notes without affecting the real DOM.
        var startElementClone = startElement.cloneNode(true);

        removeHiddenContent(startElementClone, doc);

        var elemText = startElementClone.textContent;
        var elemLength = elemText.length;
        var kMaxLength = 100;

        //If selected text is too long, just use it as is
        if (endOffset - startOffset > kMaxLength) {
            return truncateText(selectedText, MHE_CHAR_LIMIT);
        }

        //First attempt to go from beginning of selection to kMaxLength
        var desiredStart = startOffset;
        var desiredEnd = startOffset + kMaxLength;

        //If that is too long, then try to go back kMaxLength from the end,
        //but stopping if you get to the beginning of the element.
        if (desiredEnd > elemLength) {
            desiredEnd = elemLength;
            desiredStart = Math.max(0, desiredEnd - kMaxLength);
        }

        var frag = elemText.slice(desiredStart, desiredEnd);

        if (desiredStart > 0) {
            //add ellipses to front...
            if (startOffset === desiredStart) {
                //either prepended to our desired selection
                frag = '...' + frag;
            } else {
                //of by breaking at a word boundary
                frag = frag.replace(/^\S*\s/, '...');
            }
        }

        if (desiredEnd < elemLength) {
            //add ellipses to end, on a word boundary
            frag = frag.replace(/\s\S*$/, '...');
        }

        return frag;
    }

    ///////////PUBLIC METHODS///////////////

    //Returns the foundation object that becomes an annotation.
    //(This extends a default annotation object to make a real Annotation)
    // nonTextFlag is passed when image (non text) asset clicked
    function createFromSelection(doc, cfiBase, optionalLegacyVersion, nonTextFlag) {
        var selection = utils.getActiveSelection(doc);

        if (isSelectionInvalid(selection, doc, nonTextFlag)) {
            return null;
        }

        var range = new rangy.WrappedRange(selection.getRangeAt(0));
        //TODO: add base part
        var cfiString = cfi.getVersion(optionalLegacyVersion).cfiStringFromRange(range, cfiBase);
        var text = textForRange(range, doc);
        var textUnderLimit = truncateText(text, MHE_CHAR_LIMIT);
        return {
            cfi: cfiString,
            text: textUnderLimit
        };
    }

    function modernizeLegacyAnnotation(annotation) {
        if (annotation.highlight && !annotation.shape) {
            annotation.shape = colorData.highlightDefaults.shape;
        }
    }

    /**
     *  Creates the annotation object that will be stored in firebase (minus its $id)
     *
     *  Legal props:
     *  selection : base annotation object to edit in place
     *  highlight : Boolean
     *  hasNote : Boolean
     *  placemark : Boolean
     *  color : HighlightColor
     *  noteText : String ( if hasNote is true)
     *
     *  @Returns {Boolean} If an annotation was created or edited, returns true.
     *  	Otherwise, returns undefined.  On an undefined return, it is client's
     *  	responsibility to delete the annotation if appropriate.
    */
    function editAnnotation(props, doc, optionalLegacyVersion) {
        var hasNote = (props.hasNote && props.noteText);
        var shouldEdit = props.highlight ||
                                    hasNote ||
                                    props.placemark ||
                                    props.shape;

        if (shouldEdit) {
            //It is important to edit this object in-place
            var annotation = props.selection;
            modernizeLegacyAnnotation(annotation);

            if (annotation.color === undefined) {
                annotation.color = colorData.highlightDefaults.color;
            }

            annotation.highlight = !!props.highlight;

            if (props.color) {
                annotation.color = props.color.highlight.classes;
            }

            if (hasNote) {
                annotation.note = props.noteText;
            } else {
                delete annotation.note;
            }

            if (props.placemark) {
                annotation.placemarkText = grabPlacemarkText(
                    props.selection, doc, optionalLegacyVersion);
            } else {
                delete annotation.placemarkText;
            }

            if (props.shape) {
                annotation.shape = props.shape;
                annotation.highlight = true;
            }

            annotation.clientModifiedAt = (new Date()).toISOString();
            annotation.modifiedBy = props.platformId || '_';

            if (annotation.clientCreatedAt === undefined) {
                annotation.clientCreatedAt = annotation.clientModifiedAt;
                annotation.createdBy = annotation.modifiedBy;
            }

            return annotation;
        }
    }

    function getRangeForAnnotation(annotation, doc, optionalLegacyVersion) {
        var range = cfi.getVersion(optionalLegacyVersion).rangeFromCFIString(annotation.cfi, doc);
        return new rangy.WrappedRange(range);
    }

})(
    window.ePubAnnotation,
    window.rangy,
    window.ePubAnnotation.cfi,
    window.ePubAnnotation.utils,
    window.ePubAnnotation.colorData
);


'use strict';

(function(api, rangy, utils, colorData) {

    var globalBaseClass = 'mhe-global-annotation';

    function Highlighter(namespace) {
        this.scopedClass = namespace ? namespace : 'annotation';
        this.highlightClass = 'highlight';
        this.noteClass = 'note';
        this.placemarkClass = 'placemark';
        this.commentClass = 'highlight-comment';
        this.lrClass = 'has-lr';
        this.clickableClass = 'clickable';
        this.nonClickableClass = 'not-clickable';
    }




    //Given a node which is about to be highlghted, return true if the node should
    //be highlighted, false if it should be ignored.  Goal is to ignore all text
    //nodes that occur within mathML.
    function highlighterNodeFilter(node) {
        var elementsToExclude = ['annotation', 'math', 'svg'];

        var el = utils.containingElement(node);
        var tagName = el && el.tagName.toLowerCase();

        if (tagName && elementsToExclude.indexOf(tagName) !== -1) {
            return false;
        }

        //Just filtering 'svg' nodes does not prevent child text nodes from being
        //filtered.  Here we check the namespace of the parent to see if it belongs
        //to the svg namespace (and we can add more namespaces as needed.)
        //
        //It is particularly important to filter svg's text nodes, because their
        //className property is of type `SVGAnimatedString` which causes rangy's
        //classApplier to fail. (cf EPR-1309)
        // Also applicable to MathML elements
        var namespacesToExclude = ['http://www.w3.org/2000/svg' ,'http://www.w3.org/1998/Math/MathML'];
        var namespace = el.parentElement && el.parentElement.namespaceURI;

        if (namespace && namespacesToExclude.indexOf(namespace) !== -1) {
            return false;
        }

        return true;
    }

    Highlighter.prototype.getMarkClassesForAnnotation = function(annotation) {
        var classes = [globalBaseClass, this.scopedClass];
        if (annotation.note) {
            classes.push(this.noteClass);
        }
        if (annotation.highlight) {
            if (!annotation.shape) {
                classes.push(colorData.highlightDefaults.shape);
            }
            classes.push(this.highlightClass);
        }
        if (annotation.color) {
            classes.push(annotation.color);
        }
        if (annotation.placemarkText) {
            classes.push(this.placemarkClass);
        }
        if (annotation.shape) {
            classes.push(annotation.shape);
        }

        if (this.hasComment(annotation)) {
            classes.push(this.commentClass);

            if (annotation.commentColor) {
                classes.push(annotation.commentColor + '-comment');
            }
        }

        if (annotation.hasLR) {
            classes.push(this.lrClass);
        }

        if (annotation.clickable === false) {
            classes.push(this.nonClickableClass);
        } else if (annotation.clickable === true) {
            classes.push(this.clickableClass);
        }

        // lately we experience that same mark annotation needs to have
        // different style, behavior but cant reliable identify if its authoring or awd
        // possible platform values: 'avalon-web', 'avalon-mobile', 'avalon-authoring',
        // 'reader-web', 'reader-mobile' and etc.
        // know there is namespace for similar one, but most of current web highlights
        // tighted to 'annotation' class, dont want change it for now
        if (annotation.platform) {
            classes.push(annotation.platform);
        }

        return classes;
    };

    //Deletion
    function ieWorkaroundNormalize(node) {
        if (!node) { return; }
        if (node.nodeType === 3) {
            while (node.nextSibling && node.nextSibling.nodeType === 3) {
                node.nodeValue += node.nextSibling.nodeValue;
                node.parentNode.removeChild(node.nextSibling);
            }
        } else {
            ieWorkaroundNormalize(node.firstChild);
        }
        ieWorkaroundNormalize(node.nextSibling);
    }

    function removeMark(doc, mark) {
        var parentNode = mark ? mark.parentNode : false;
        if (parentNode) {
            mark.outerHTML = mark.innerHTML;

            //If we drop IE support, we could go back to the builtin normalize
            //cf. http://bit.ly/2agbYAE
            //IE bug: http://bit.ly/2agbUB5
            //Closed as won't fix, because its fixed in Edge

            // Check if its IE before call it!
            if(utils.detectIE()) {
                ieWorkaroundNormalize(parentNode);
            } else {
                parentNode.normalize();
            }
        }
    }

    function removeAllMarksOfClass(doc, className, nonTextFlag) {
        var elementList = doc.getElementsByClassName(className);

        if (!elementList || elementList && !elementList.length) {
            return;
        }

        // remove class from non text Elements
        // not perfect solution but fast prototype
        if (nonTextFlag) {
            var otherPossibleClasses = [
                'highlight',
                'placemark',
                'note',
                'mhe-global-annotation',
                'epr-shape-square-filled',
                'epr-shape-square-outline',
                'epr-shape-round-outline',
                'epr-shape-underline'
            ].join(' ');
            className += ' ' + otherPossibleClasses;
            var classNames = className.split(' ');

            var nonTextElements = Array.prototype.slice.apply(elementList).filter(function(element) {
                return element.tagName.toUpperCase() !== 'MARK';
            });
            for (var i = 0, len = nonTextElements.length; i < len; i++) {
                classNames.forEach(function(cls) {
                    nonTextElements[i].classList.remove(cls);
                });
            }
        }

        var marksArray = Array.prototype.slice.apply(elementList).filter(function(element) {
            return element.tagName.toUpperCase() === 'MARK';
        });

        //TODO: remove classes from the non-mark classes ones

        while (marksArray.length > 0) {
            removeMark(doc, marksArray.pop());
        }
    }

    ///////// PUBLIC ////////
    //Client is required to set a base CFI of the page that is being displayed
    //Attempts to render an annotation not belonging to this page will be ignored.
    Highlighter.prototype.setBaseCFI = function(cfiString) {
        this.baseCFIString = cfiString;
    };

    function annotationBaseMatchesThisPage(annotation, highlighter) {
        if (highlighter.baseCFIString === undefined) {
            //There is no baseCFI. It doesn't match.
            return false;
        }

        var annotationSpineID = api.cfi.spineIdFromCFIString(annotation.cfi);
        var documentSpineID = api.cfi.spineIdFromCFIString(highlighter.baseCFIString);

        if (annotationSpineID) {
            //There's a defined spineID, use spine IDs for matching
            return (annotationSpineID === documentSpineID);
        }

        //fallback to using spine index if there's no spineIdFromCFIString
        var annotationSpineIndex = api.cfi.spineIndexFromCFIString(annotation.cfi);
        var documentSpineIndex = api.cfi.spineIndexFromCFIString(highlighter.baseCFIString);

        return annotationSpineIndex === documentSpineIndex;
    }

    Highlighter.prototype.addMarksForAnnotation = function(annotation, index,
        doc, optionalLegacyVersion, nonTextFlag, customIDKey) {


        if (!annotationBaseMatchesThisPage(annotation, this)) {
            //Fail silently if we're on the wrong page
            return true;
        }

        try {
            var idKey = customIDKey || '$id';
            var classes = this.getMarkClassesForAnnotation(annotation).join(' ');
            var scopedClass = this.scopedClass;
            var applierClass = scopedClass + '-id-' + annotation[idKey] + ' ' + classes + ' highlight-element';

            /**
             * Special Handling for non-clickable annotations
             */
            var elementAttributes = {
                'data-highlight-id': annotation[idKey],
                'data-highlight-index': index,
                'tabindex': 0
            };
            if (annotation.clickable === false || annotation.focusable === false) {
                delete elementAttributes['tabindex'];
            }

            var applierProps = {
                ignoreWhiteSpace: true,
                elementTagName: 'mark',
                tagNames: [],
                elementAttributes: elementAttributes,
                elementProperties: {
                    className: classes
                },
                nodeFilter: highlighterNodeFilter,
                elementPostProcessCallback: function (element, currentIndex, lastElementIndex) {
                    if (element.tagName.toUpperCase() !== 'MARK') {
                        element.classList.remove(globalBaseClass);
                    }
                    if (currentIndex === lastElementIndex && lastElementIndex === 0) {
                        element.classList.add(scopedClass + '-start-end');
                        element.id = annotation[idKey];
                    } else if (currentIndex === 0) {
                        element.classList.add(scopedClass + '-start');
                        element.id = annotation[idKey];
                    } else if (currentIndex === lastElementIndex) {
                        element.classList.add(scopedClass + '-end');
                    } else {
                        element.classList.add(scopedClass + '-middle');
                    }
                }
            };

            if (nonTextFlag) {
                applierProps['tagNames'] = ['svg', 'img', 'iframe', 'audio', 'video'];
            }

            if (this.hasComment(annotation)) {
                applierProps.elementAttributes['data-comments'] = annotation.comments;
            }

            var classApplier = rangy.createClassApplier(applierClass, applierProps);
            var range = api.getRangeForAnnotation(annotation, doc, optionalLegacyVersion);

            classApplier.applyToRange(range, null, nonTextFlag);
            return true;

        } catch (e) {
            if (api.isLegacyVersionError(e)) {
                throw e;
            }
            return false;
        }
    };

    Highlighter.prototype.removeMarksForAnnotation = function(doc, annotation, nonTextFlag, customIDKey) {
        if (annotation && doc) {
            var classes = this.getMarkClassesForAnnotation(annotation);
            var idKey = customIDKey || '$id';
            var applierClass = this.scopedClass + '-id-' + annotation[idKey];

            classes.push(applierClass);
            classes.sort();
            removeAllMarksOfClass(doc, classes.join(' '), nonTextFlag);
        }
    };

    Highlighter.prototype.removeAllMarks = function removeAllMarks(doc, nonTextFlag) {
        removeAllMarksOfClass(doc, this.scopedClass, nonTextFlag);
    };

    Highlighter.prototype.hasComment = function(annotation) {
        if (annotation.comments && parseInt(annotation.comments) > 0 && !isNaN(annotation.comments)) {
            return true;
        }
        return false;
    };

    Highlighter.prototype.isAnnotation = function isAnnotation(element) {
        return element &&
            element.classList &&
            element.classList.contains(this.scopedClass);
    };

    Highlighter.prototype.getAnnotationForElement = function(element, annotations, customIDKey) {
        var idKey = customIDKey || '$id';
        function getAnnotationById(id, annotations) {
            for (var i = 0, length = annotations.length; i < length; ++i) {
                if (annotations[i][idKey] === id) {
                    return annotations[i];
                }
            }
        }

        if (!this.isAnnotation(element)) {
            return undefined;
        }

        //regex for fishing out the annotation id from the classList
        var annotationIDregex = new RegExp(this.scopedClass + '-id-([^\ ]+)');

        //Find class name (for regular Elements OR SVG Elements!)
        var className = element.className.baseVal || element.className || '';

        var matches = className.match(annotationIDregex);
        var annotationId = matches && matches[1];
        return annotationId && getAnnotationById(annotationId, annotations);
    };

    Highlighter.prototype.getSelectedAnnotation = function(event, annotations, customIDKey) {
        var element = event.target;
        while (element && !this.isAnnotation(element)) {
            element = element.parentElement;
        }

        return this.getAnnotationForElement(element, annotations, customIDKey);
    };

    api.Highlighter = Highlighter;
    api.Highlighter.globalBaseClass = globalBaseClass;

})(
    window.ePubAnnotation,
    window.rangy,
    window.ePubAnnotation.utils,
    window.ePubAnnotation.colorData
);


(function (api, utils, NodeTraversal, cfi) {

    function print(object) {
        //uncomment for debugging
        // console.log(object);
    }

    var data = {

        // The breakList are elements to automatically group into an utterance
        // Since PlayerAPI cleans up the HTML before sending to ReadSpeaker,
        // it needs to also know this list or they will be stripped.
        // @todo see if more elements should be added
        breakList: [
            'P', 'H1', 'H2', 'H3', 'H4',
            'H5', 'H6', 'LI', 'FIGCAPTION', 'IMG',
            'IFRAME', 'PRE'],

        specialHTMLElements: [	
            'DETAILS'	
        ],

        // The class added to the Span used to wrap naked text nodes
        // @todo test that CFI handling not screwed up when text nodes get wrapped.
        utteranceIgnorableClass: 'tts-utterance-ignorable',

        // Class added to the current active utterance
        activeUtteranceClass: 'tts-active',

        // The data attribute used to demark utterances.
        utteranceDataAttr: 'data-tts-utterance',

        // Array of utterance data, returned by method processUtterances
        utterances: []
    };

    /**
     * Loop through a document and create utterances.
     * Utterances represent areas in the document that are read out loud according to breakList.
     * Certain HTML nodes will automatically create an utterance such as a <p> or a <li>.
     * Utterances are created so that they do not overlap with each other
     * (ie... no utterance will have a child element is an utterance).
     * If there is a naked text node it will get wrapped in a span with a special class.
     * Utterances are indexed via a data attribute starting with 0.
     *
     * This method returns an array with:
     *      html - The HTML of the element
     *      text - The text of the elment
     *      cfi  - The CFI to recreate the utterance range
     *
     * For Example:
     * <body>
     *     <ul>
     *         <li><p>Hello</p></li>
     *         <li><img src="http://example.com/1.png" alt="Sample Image"></li>
     *         <li> </li>
     *     </ul>
     *     World
     * </body>
     *
     * The markup would for the document would be transformed into:
     * <body>
     *     <ul>
     *         <li data-tts-utterance="0"><p>Hello</p></li>
     *         <li data-tts-utterance="1"><img src="http://example.com/1.png" alt="Sample Image"></li>
     *         <li> </li>
     *     </ul>
     *     <span class="tts-wrapped-text-node" data-tts-utterance="2">World</span>
     * </body>
     *
     * Notice utterances stop on the <LI> attribute even though it has a child <P> tag.
     * Also note that utterances that would be equivalent to an empty string are excluded (like the <LI> with empty text.
     *
     * The return value of this methoud would be an array:
     * [
     *     {
     *        'text': 'Hello',
     *        'html': '<li data-tts-utterance="0"><p>Hello</p></li>',
     *        'cfi': ....
     *     },
     *     {
     *          'text': 'Sample Image',
     *          'html': '<li data-tts-utterance="1"><img src="http://example.com/1.png" alt="Sample Image"></li>',
     *          'cfi': ...
     *     }
     *     {
     *          'text': 'World',
     *          'html': '<span class="tts-wrapped-text-node" data-tts-utterance="2">World</span>',
     *          'cfi': ...
     *     }
     * ]
     *
     *
     * @param doc
     * @param cfiBasePath
     * @returns {Array}
     */
    function processUtterances(doc, cfiBasePath) {

        // Remove existing utterances
        removeUtterances(doc);

        // The starting node will be the body element
        var el = doc.querySelector('body');

        // If no body return empty array
        if (!el) {
            return data.utterances;
        }

        // check if it possible children nodes are utterances?
        if (hasPossibleUtterances(el)) {
            walkDocumentTree(el, doc, cfiBasePath);
        }

        return data.utterances;
    }

    /**
     * This function will remove all changes to the markup created by processUtterances.
     * - Removing all attributes data-tts-utterance
     * - Removing the class 'tts-active' which is added to the current utterance
     * - Unwrapping TextNodes that were wrapped
     * - Removing the DIV used for the utterance marker
     *
     * Another way of saying that removeUtterances should be the inverse function of processUtterances
     *
     * @param doc
     */
    function removeUtterances(doc) {
        // clear the data
        data.utterances = [];

        // exit early if doc variable undefined or null
        if (!doc) {
            return;
        }

        // remove the attributes added to elements
        var existingElmts = doc.querySelectorAll('[' + data.utteranceDataAttr + ']');
        for (var i = 0; i < existingElmts.length; i++) {
            existingElmts[i].removeAttribute(data.utteranceDataAttr);
        }

        // removing active utterance class
        var activeElmts = doc.querySelectorAll('.' + data.activeUtteranceClass);
        for (var j = 0; j < activeElmts.length; j++) {
            var activeElmt = activeElmts[j];
            activeElmt.classList.remove(data.activeUtteranceClass);
        }

        // Unwrapping text nodes that were wrapped
        var wrappedElmts = doc.querySelectorAll('.' + data.utteranceIgnorableClass);
        for (var k = 0; k < wrappedElmts.length; k++) {
            var wrappedElmt = wrappedElmts[k];
            var textNode = doc.createTextNode(wrappedElmt.textContent);
            wrappedElmt.parentElement.replaceChild(textNode, wrappedElmt);
        }

        // Remove utterance marker
        var utteranceMarkerElem = doc.querySelector('#tts-utterance-marker');
        if (utteranceMarkerElem) {
            utteranceMarkerElem.parentElement.removeChild(utteranceMarkerElem);
        }
    }

    /**
     * This method is used to visually 'highlight' or identify the utterance currently being spoken.
     * You pass this method the index of the utterance you want to be currently active.
     * It will add a 'tts-active' class to the element which can be used for styling.
     * It will move the utterance marker to be positioned next to the utterance.
     *
     * @param i
     * @param doc
     * @returns {*}
     */
    function setActiveUtterance(i, doc) {
        var activeElmt = null;

        // remove class not currently utterance
        for (var j = 0; j < data.utterances.length; j++) {
            var element = doc.querySelector('[data-tts-utterance="' + i + '"]');
            if (element) {
                if (j === i) {
                    activeElmt = element;
                    element.classList.add('tts-active');
                    moveUtteranceMarkerToElement(doc, element);
                } else {
                    element.classList.remove('tts-active');
                }
            }
        }

        return activeElmt;
    }

    /**
     * This function is used as an integration point for the Mobile team.
     * Before changing, discuss with the mobile developers.
     *
     * @param {Document} doc - the document to act on
     * @param {string || null} cfiBasePath - the base path (of the epub spine item) to use when generating
     *      cfis of the utterances.  If omitted, the `cfi` property is omitted from the utterances.
     */
    function createTextUtteranceArray(doc, cfiBasePath) {
        return processUtterances(doc, cfiBasePath);
    }

    /**
     * INTERNAL FUNCTION
     *
     * Loops through all children and determines if
     * any of the children are in the breakList.
     *
     * Returns TRUE if child utterance exist and FALSE otherwise.
     *
     * @param el
     */
    function hasPossibleUtterances(el) {
        var children = el.children;
        for (var index = 0; index < children.length; index++) {
            var child = children[index];

            // matches element in breakList
            if (data.breakList.indexOf(child.tagName.toUpperCase()) >= 0) {
                return true;
            }

            // Recursively loop through all child elements
            if (child.children.length > 0) {
                var childHasPossibleUtterances = hasPossibleUtterances(child);
                if (childHasPossibleUtterances) {
                    return true;
                }
            }
        }
        return false;
    }

    /**	
     * INTERNAL FUNCTION	
     *	
     * Handle the toggle box case	
     * This is a special case because the utterance generation it's different	
     *	
     * @param el HTMLDetailsElement	
     * @param doc	
     * @param cfiBasePath	
     */	
     function createDetailsUtterance(el, doc, cfiBasePath) {	
        el.childNodes.forEach(function (detailsElement) {	
            createUtterance(detailsElement, doc, cfiBasePath, false)	
        })	
    }

    /**
     * INTERNAL FUNCTION
     *
     * Loops through all children and create the utterances
     * for each element.
     *
     * @param el
     * @param doc
     * @param cfiBasePath
     */
    function walkDocumentTree(el, doc, cfiBasePath) {

        // Util fn to get the element tag name
        function elTagName(el) {
            return el && el.tagName && el.tagName.toUpperCase()
        }
        	
        // First validate special cases each time
        if (data.specialHTMLElements.indexOf(elTagName(el)) >= 0) {	
            switch (elTagName(el)) {	
                case 'DETAILS':	
                    createDetailsUtterance(el, doc, cfiBasePath)	
                    return;	
                    break;	
            }	
        }

        // Bool to find special cases in childs
        
        var specialTagNameCase = [].slice.call(el.childNodes, 0).some(function(elem) {
            return data.specialHTMLElements.indexOf(elTagName(elem)) >= 0
        });
        	
        // matches element in breakList	if not special cases
        if (data.breakList.indexOf(elTagName(el)) >= 0 && !specialTagNameCase) {	
            createUtterance(el, doc, cfiBasePath);	
            return;	
        }

        // check the children nodes
        var childNodes = el.childNodes;
        for (var index = 0; index < childNodes.length; index++) {
            var childNode = childNodes[index];

            // wrap naked text nodes in a <span> with a special class
            if (childNode.nodeType === 3) {
                var textContent = removeWhitespace(childNode.textContent);
                if (textContent !== '') {
                    childNode = wrapTextNode(childNode, doc);
                }
            }

            // only care about element nodes going forward
            if (childNode.nodeType !== 1) {
                continue;
            }

            // If no possible utterances in child nodes, create Utterance
            // otherwise recursively loop through children
            if (!hasPossibleUtterances(childNode)) {
                createUtterance(childNode, doc, cfiBasePath);
            } else {
                walkDocumentTree(childNode, doc, cfiBasePath);
            }
        }
    }

    /**
     * INTERNAL FUNCTION
     *
     * Given an element that has been identified as place to create an utterance
     * - Add special data attribute
     * - Calculate the CFI
     * - Push to the utterances array
     *
     * @param el
     * @param doc
     * @param cfiBasePath
     */
    function createUtterance(el, doc, cfiBasePath, shouldCheckVisibility) {
        var shouldCheckContentVisibility = true;
        if (shouldCheckVisibility !== undefined) {
            shouldCheckContentVisibility = shouldCheckVisibility;
        }
        var textContent = getUtteranceText(el, doc);

        // ignore any elements without any textual content
        if ('' === textContent) {
            return;
        }

        // ignore any elements that are not visible
        if (shouldCheckContentVisibility && !isVisible(el)) {
            return;
        }

        //Create the CFI for the element.  If the element has children, select the first and last child.
        //This often creates a better bounding rect than selecting the whole element.  If the element has no
        //children, we select the entire element.
        var elmtCfi;

        if (el.childNodes.length > 0) {
            var range = doc.createRange();
            range.setStart(el.firstChild, 0);
            range.setEnd(el.lastChild, el.lastChild.length);
            elmtCfi = cfiBasePath && cfi.cfiStringFromRange(range, cfiBasePath);
        } else {
            elmtCfi = cfiBasePath && cfi.cfiStringFromNode(el, cfiBasePath);
        }

        el.setAttribute('data-tts-utterance', data.utterances.length);
        data.utterances.push({
            text: textContent,
            html: el.outerHTML,
            cfi: elmtCfi
        });
    }

    /**
     * INTERNAL FUNCTION
     *
     * Generate the text content spoken for a given element node.
     * Allows for special handling to parse the text to be read out-loud (ex alt text for images).
     *
     * @param node
     * @param doc
     * @returns {*}
     */
    function getUtteranceText(node, doc) {

        var range = doc.createRange();
        range.selectNode(node);
        //This will use existing logic used by annotation & read selected that mirrors
        //the above (skipping certain things where appropriate, etc).  Probably the above
        //logic and the logic in `textForRange` should be combined at some point.
        var textContent = api.textForRange(range, doc);

        return removeWhitespace(textContent);
    }

    /**
     * INTERNAL FUNCTION
     *
     * Whitespace isn't spoken out-loud, so they they can be skipped for utterances.
     * This function strip out all extra spaces and line breaks.
     *
     * @param textContent
     * @returns {*}
     */
    function removeWhitespace(textContent) {
        return textContent
            .replace(/[\n\r]/g, ' ')  // replace line breaks with spaces
            .replace(/\s+/g, ' ') // replace line breaks with spaces
            .trim(); // trim string
    }

    /**
     * INTERNAL FUNCTION
     *
     * Wrap naked text nodes as a span with special class.
     *
     * @param textNode
     * @param doc
     * @returns {HTMLElement}
     */
    function wrapTextNode(textNode, doc) {
        var wrapper = doc.createElement('span');
        wrapper.setAttribute('class', data.utteranceIgnorableClass);
        textNode.parentNode.insertBefore(wrapper, textNode);
        wrapper.appendChild(textNode);
        return wrapper;
    }

    /**
     * INTERNAL FUNCTION
     *
     * Elements that are not visible on the page don't make sense to read out-loud.
     * This is the jQuery :visible psuedo filter in plain javascript.
     * This logic might be extended as needed to exclude further elements.
     * @todo confirm this works correctly with Teacher comments and other logic
     *
     * @param elem
     * @returns {boolean}
     */
    function isVisible(elem) {
        // check if running in unit test
        if (window.__karma__) {
            return true;
        }
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    }

    /**
     * INTERNAL FUNCTION
     *
     * This function is used to update the utterance-marker (the grey bar) used to identify the active utterance.
     * If the <DIV> doesn't exist, it will create it, otherwise, it will update.
     *
     * @param doc
     * @param activeElement
     */
    function moveUtteranceMarkerToElement(doc, activeElement) {
        var marker = doc.getElementById('tts-utterance-marker');
        if (!marker) {
            marker = doc.createElement('div');
            marker.setAttribute('id', 'tts-utterance-marker');
            marker.setAttribute('class', data.utteranceIgnorableClass);
            doc.body.appendChild(marker);
        }

        var newHeight = activeElement.clientHeight;
        var newTop = calculateOffsetFromBody(activeElement);
        marker.style.height = newHeight + 'px';
        marker.style.top = newTop + 'px';
    }

    /**
     * INTERNAL FUNCTION
     *
     * This function is used calculate the number of pixels from the top
     * of the <body> to the top of an element nested arbitrarily deep.
     *
     * @param el
     * @param totalOffset
     * @returns {number}
     */
    function calculateOffsetFromBody(el, totalOffset) {
        if (!el || !el.offsetParent) {
            return 0;
        } else {
            totalOffset = (totalOffset || 0) + el.offsetTop
            if (el.offsetParent.tagName.toLowerCase() === 'body') {
                return totalOffset;
            }
            return calculateOffsetFromBody(el.offsetParent, totalOffset);
        }
    }

    api.ttsClasses = {
        utteranceIgnorableClass: data.utteranceIgnorableClass,
        activeUtteranceClass: data.activeUtteranceClass
    };
    api.createTextUtteranceArray = createTextUtteranceArray;
    api.processUtterances = processUtterances;
    api.setActiveUtterance = setActiveUtterance;
    api.removeUtterances = removeUtterances;
})(
    window.ePubAnnotation,
    window.ePubAnnotation.utils,
    window.ePubAnnotation.NodeTraversal,
    window.ePubAnnotation.cfi
);